export const TRANSLATIONS = {
  ja: {
    // Common
    CONFIRM: '確認',
    CANCEL: 'キャンセル',
    SAVE: '保存',
    SAVE_ACTION: '保存する',
    EDIT_RECORD_LINK: '変更',
    DOWNLOAD: 'ダウンロード',
    DELETE: '削除',
    EDIT: '編集',
    ADD: '追加',
    ADD_NEW: '新規追加',
    SEARCH: '検索',
    CLOSE: '閉じる',
    LOGOUT: 'ログアウト',
    LOGOUT_CONFIRM_MESSAGE: 'ログアウトしますか？',
    USER_INFO_TITLE: 'ユーザー情報',
    USER_INFO_TAB_BASIC: '基本情報',
    USER_INFO_BASIC_UPDATE: '基本情報更新',
    USER_INFO_TAB_OTHER_INFO: 'その他の情報',
    USER_INFO_OTHER_UPDATE: 'その他の情報更新',
    USER_INFO_TAB_ACADEMIC_WORK_HISTORY: '学歴職歴',
    USER_INFO_TAB_HEALTH: '健康情報',
    USER_INFO_TAB_ONLINE_URLS: 'オンライン授業URL管理',
    USER_INFO_FURIGANA_LABEL: 'フリガナ',
    USER_INFO_NAME_LABEL: '氏名',
    USER_INFO_NAME_PLACEHOLDER: '山田たろう',
    USER_INFO_FURIGANA_PLACEHOLDER: 'ヤマダタロウ',
    USER_INFO_EMAIL_PLACEHOLDER: 'kurokawa_susumu@example.com',
    USER_INFO_EMAIL_TOOLTIP: 'Mana-viにログイン用のメール',
    USER_INFO_ENROLL_DATE_LABEL: '入学日',
    USER_INFO_GENDER_PLACEHOLDER: '男性',
    USER_INFO_DOB_PLACEHOLDER: '2020/8/10',
    USER_INFO_ADDRESS_PLACEHOLDER: '岐阜県岐阜市加納黒木町4',
    USER_INFO_PHONE_PLACEHOLDER: '+61488850430',
    EDUCATION_BACKGROUND_PLACEHOLDER: '星稜小学校',
    WORK_EXPERIENCE_PLACEHOLDER: '早稲田大学 法学部',
    CAREER_PATH_PLACEHOLDER: '京都大学 経済学部',
    QUALIFICATIONS_PLACEHOLDER: '大阪大学 医学部',
    GRADES_PLACEHOLDER: '名古屋大学 工学部',
    HEALTH_RESULT_PLACEHOLDER: '名古屋大学 工学部',
    USER_INFO_GOOGLE_MEET_URL_LIST: '有効Google Meet URL一覧',
    USER_INFO_URL_ISSUE: 'リンク発行',
    USER_INFO_URL_NAME: '名称',
    USER_INFO_URL_CODE: 'ミーティングコード',
    USER_INFO_URL_COHOSTS: '共同主催者',
    USER_INFO_URL_CREATED_AT: '発行日',
    USER_INFO_URL_CREATED_AT_TOOLTIP: 'Google Meet リンクの作成日です。対象の日時はGoogleカレンダー上でも予定として確認できます。',
    USER_INFO_URL_OPERATION: '操作',
    USER_INFO_URL_ISSUE_TITLE: 'Google Meetリンク発行',
    USER_INFO_URL_ISSUE_TOOLTIP: 'オンライン授業用 Google Meet URLの発行元',
    USER_INFO_URL_ISSUE_MESSAGE: 'これからGoogle Meetに参加URLは発行されます。\n複数のURLを識別しやすくするために、用途が分かるエイリアス名を設定してください。',
    USER_INFO_URL_EDIT_TITLE: '発行リンクを編集する',
    USER_INFO_URL_EDIT_MESSAGE: 'リンクの名称および共同主催者を変更します。',
    USER_INFO_URL_EDIT_GUESTS: '編集',
    USER_INFO_URL_ALIAS_PLACEHOLDER: '例）オンライン授業URL',
    CO_HOST_DROPDOWN_PLACEHOLDER: 'Mana-viの利用者から主催者を選択して下さい',
    USER_INFO_URL_INVITED_LABEL: '招待ゲスト',
    USER_INFO_URL_INVITED_EMPTY: '招待中の外部ゲストはいません',
    USER_INFO_URL_DELETE_TITLE: '確認',
    USER_INFO_URL_DELETE_MESSAGE: 'Google Meet 参加リンクを無効にして削除します。よろしいですか？',
    USER_INFO_URL_NO_DATA: 'Google Meet URLがありません。',
    USER_INFO_ONLINE_URL_PLACEHOLDER: '例）オンライン授業URL',
    CO_HOST_EMAILS_LABEL: '共同主催者追加する',
    CO_HOST_EMAIL_PLACEHOLDER: 'cohost@example.com',
    CO_HOST_SELECT_BUTTON: '共同主催者を追加',
    CO_HOST_SELECT_TITLE: '共同主催者を選択',
    CO_HOST_SELECT_PLACEHOLDER: '名前またはメールで検索',
    INVALID_EMAIL_FORMAT: 'メールアドレスの形式が正しくありません',
    EMAIL_ALREADY_ADDED: 'このメールアドレスはすでに追加されています',
    GOOGLE_ACCOUNT_LABEL: 'Googleアカウント',
    GOOGLE_ACCOUNT_LINK_BTN: '連携する',
    GOOGLE_ACCOUNT_LINKED_BADGE: '連携済み',
    GOOGLE_ACCOUNT_UNLINKED_BADGE: '未連携',
    GOOGLE_ACCOUNT_TAB_LABEL: 'Google連携',
    GOOGLE_ACCOUNT_NOT_LINKED_DESC: 'Googleアカウントはまだ連携されていません。',
    GOOGLE_STATUS_CHECKING: '確認中...',
    GOOGLE_ACCOUNT_UNLINK: '連携解除',
    GOOGLE_ACCOUNT_UNLINK_CONFIRM_TITLE: 'Googleアカウント連携解除',
    GOOGLE_ACCOUNT_UNLINK_CONFIRM_MESSAGE: '解除すると、発行されるGoogle Meet URLが無効にしてしまいます。よろしいでしょうか？',
    GOOGLE_LINK_TOOLTIP: 'Googleアカウントを連携すると、Google Meetを使用したオンライン授業の出席確認が自動で行われ、より便利になります',
    GOOGLE_LINK_UNLINKED_TEXT: 'Googleアカウントはまだ<b>未連携</b>です。',
    GOOGLE_LINK_LINKED_TEXT: 'Googleアカウントは<b>連携済み</b>です。',
    GOOGLE_LINK_TEACHER_UNLINK_CONFIRM: '連携を解除すると、このGoogleアカウントに関連付けられているすべてのMeet URLおよび共同主催者の設定が削除されます。',
    GOOGLE_LINK_STUDENT_UNLINK_CONFIRM: '連携を解除すると、Google Meet参加時に学籍番号とメールを手動で入力する必要があります。\n本当にGoogleアカウントの連携を解除しますか？',
    CHANGE_PASSWORD_BUTTON: 'パスワード変更',
    CHANGE_PASSWORD_TITLE: 'パスワード変更',
    CHANGE_PASSWORD_CURRENT_LABEL: '現在のパスワード',
    CHANGE_PASSWORD_CURRENT_PLACEHOLDER: '現在のパスワードを入力',
    CHANGE_PASSWORD_NEW_LABEL: '新しいパスワード',
    CHANGE_PASSWORD_NEW_PLACEHOLDER: '新しいパスワードを入力',
    CHANGE_PASSWORD_CONFIRM_LABEL: '新しいパスワード（確認）',
    CHANGE_PASSWORD_CONFIRM_PLACEHOLDER: '新しいパスワードをもう一度入力',
    CHANGE_PASSWORD_HINT: '8文字以上で入力してください',
    CHANGE_PASSWORD_LENGTH_ERROR: '8文字以上で入力してください',
    CHANGE_PASSWORD_MISMATCH_ERROR: '新しいパスワードと確認用パスワードが一致しません',
    CHANGE_PASSWORD_ACTION: '変更',
    USER_PREFERENCES: '設定',
    SETTINGS: '設定',
    PROFILE_SETTINGS_TITLE: 'プロフィール設定',
    EDIT_AVATAR: 'プロフィール画像を変更',
    USER_INFO_ROLE_STUDENT_BADGE: '受講生',
    THEME_LABEL: 'テーマ',
    LANGUAGE_LABEL: '言語',
    SEMESTER_TYPE_LABEL: '学期区分',
    REGULAR: '定期制',
    FLEXIBLE: '短期・自由',
    LOGIN: 'ログイン',
    NO_DATA: 'データがありません',
    NOT_SET: '未設定',
    USER_INFO_UNSET: '未設定',
    ITEM_SELECTED: '{0}件選択済み',
    TABLE_RANGE_TEXT: '{0}〜{1} 件を表示（全 {2} 件）',
    LOADING: '読み込み中...',
    CONFIRM_DISCARD_TITLE: '編集内容を破棄しますか？',
    CONFIRM_DISCARD_MESSAGE: 'この操作を行うと編集中の内容が失われます。\n続行しますか？',
    CONFIRM_SAVE_TITLE: '保存しますか？',
    CONFIRM_SAVE_MESSAGE: 'この内容で保存します。\n続行しますか？',
    RESET_PASSWORD_TITLE: 'パスワードをリセットしますか？',
    RESET_PASSWORD_MESSAGE: 'このユーザーの新しいパスワードを作成します。\n続行しますか？',
    RESET_PASSWORD_BUTTON: 'パスワードリセット',
    RESET_PASSWORD_ACTION: 'リセット',
    SAVE_COMPLETE_TITLE: '保存完了',
    SAVE_COMPLETE_MESSAGE: '保存が完了しました。',
    OK: 'OK',
    AVATAR_CHANGE_TITLE: 'アバターを変更',
    SELECT_IMAGE: '画像を選択',
    FILE_EXIST: "ファイルは既に存在します。保存しますか?",
    COMMON_SHOW_MORE: 'もっと見る',
    COMMON_SHOW_LESS: '折りたたむ',
    COPY_TO_CLIPBOARD: 'クリップボードにコピー',
    COPIED_TO_CLIPBOARD: 'コピー済み',
    
    // App
    APP_NAME: 'マナビ',

    // Login
    LOGIN_TITLE: 'マナビ',
    LOGIN_SUBTITLE: 'システムにログイン',
    EMAIL_LABEL: 'メールアドレス',
    EMAIL_PLACEHOLDER: 'メールアドレスを入力',
    EMAIL_REQUIRED: 'メールアドレスを入力してください',
    PASSWORD_LABEL: 'パスワード',
    PASSWORD_PLACEHOLDER: 'パスワードを入力',
    PASSWORD_REQUIRED: 'パスワードを入力してください',
    LOGIN_BUTTON: 'ログイン',
    LOGIN_ERROR: 'メールアドレスまたはパスワードが正しくありません',

    CHANGE_PASSWORD_SUCCESS: 'パスワードの変更が完了しました。',
    CHANGE_PASSWORD_FAIL: 'パスワードの変更に失敗しました。',
    RESET_PASSWORD_SUCCESS: 'パスワードのリセットが完了しました。',
    RESET_PASSWORD_FAIL: 'パスワードのリセットに失敗しました。',
    
    // Dashboard
    DASHBOARD_TITLE: 'ダッシュボード',
    DASHBOARD_WELCOME: 'マナビへようこそ！',
    DASHBOARD_WELCOME_USER: '{0}さん、ようこそ',
    DASHBOARD_TODAY_LECTURES: '本日の授業',
    DASHBOARD_MONTHLY_SCHEDULE: '月間スケジュール',
    DASHBOARD_MONTHLY_PLACEHOLDER: '月間スケジュールを表示',
    DASHBOARD_EVENTS: 'イベント',
    DASHBOARD_VIEW_MORE: 'もっと確認する',
    DASHBOARD_ATTENDANCE_REQUESTS: '本日の出欠申請',
    DASHBOARD_ASSIGNED_CLASSES: '担当科目',
    DASHBOARD_TIMETABLE: '時間割',
    DASHBOARD_CURRENT_COURSES: 'ラーニング科目',
    DASHBOARD_TAG_EVENT: 'イベント',
    DASHBOARD_TAG_TEST: 'テスト',
    DASHBOARD_TAG_DEADLINE: '締切',
    DASHBOARD_TAG_PRACTICE: '実習',
    ATTENDANCE_COL_STUDENT: '申請者',
    ATTENDANCE_COL_CLASS: 'クラス',
    ATTENDANCE_COL_TYPE: '申請種類',
    ATTENDANCE_COL_DATE: '日付',
    ATTENDANCE_COL_REASON: '理由',
    ATTENDANCE_TYPE_ABSENT: '欠席',
    ATTENDANCE_TYPE_LEAVE: '欠課',
    TOTAL_BOOKS: '総書籍数',
    TOTAL_USERS: 'ユーザー数',
    TOTAL_LESSONS: 'レッスン数',
    
    // Dashboard Cards
    SCHEDULE: 'スケジュール',
    SCHEDULE_DESC: 'カレンダーを見る',
    TAKE_TEST: 'テストを受ける',
    TAKE_TEST_DESC: 'クイズ/試験開始',
    MY_PROGRESS: 'マイ進歩',
    MY_PROGRESS_DESC: '統計を見る',
    
    // Dashboard Sections
    MY_COURSES: 'マイ科目',
    MY_COURSES_DESC: '登録中のすべての科目の進歩を追跡',
    UPCOMING_TESTS: '今後のテスト',
    RECENT_ACTIVITY: '最近のアクティビティ',
    
    // Course Info
    NEXT_CLASS: '次回の授業',
    PROGRESS: '進歩',
    CONTINUE: '続ける',
    START_TEST: 'テスト開始',
    
    // Days
    MONDAY: '月曜日',
    TUESDAY: '火曜日',
    WEDNESDAY: '水曜日',
    THURSDAY: '木曜日',
    FRIDAY: '金曜日',
    SATURDAY: '土曜日',
    SUNDAY: '日曜日',
    
    // Courses
    ADVANCED_MATH: '高等数学',
    WEB_DEVELOPMENT: 'Web開発',
    DATA_STRUCTURES: 'データ構造',
    CALCULUS: '微積分I',
    LINEAR_ALGEBRA: '線形代数',
    PHYSICS_101: '物理学101',
    CHEMISTRY_101: '化学101',
    BIOLOGY_101: '生物学101',
    COURSE_CODE_EXISTS: '科目コードはすでに登録されています',
    COURSE_NOT_FOUND: '科目が見つかりません',
    COURSE_ID_REQUIRED: '科目IDは必須項目です',
    
    // Activity
    SUBMITTED_ASSIGNMENT: '課題を提出しました',
    NEW_MATERIAL_UPLOADED: '新しい教材がアップロードされました',
    GRADE_POSTED: '成績が投稿されました',
    HOURS_AGO_2: '2時間前',
    HOURS_AGO_5: '5時間前',
    DAY_AGO_1: '1日前',
    
    // Date Format
    DATE_FORMAT: '{0}年{1}月{2}日',
    
    // Menu
    MENU_HOME: 'ダッシュボード',
    MENU_DASHBOARD: 'ダッシュボード',
    MENU_STUDENT_DASHBOARD: '生徒ダッシュボード',
    MENU_COURSE_SCHEDULE: '科目スケジュール',
    MENU_ONLINE_TEST: 'オンラインテスト',
    MENU_PDF_VIEWER: 'PDFビューア',
    MENU_TEACHER_DASHBOARD: '教師ダッシュボード',
    MENU_TEACHER_EVENT: 'イベント登録',
    MENU_TIMETABLE: '時間割',
    MENU_CALENDAR: 'カレンダー',
    MENU_ADMIN_DASHBOARD: '管理者ダッシュボード',
    MENU_ADMIN_COURSE: '科目管理',
    MENU_ADMIN_USER: 'ユーザー管理',
    MENU_ADMIN_USER_REGISTRATION: 'ユーザー登録',
    MENU_ADMIN_USERS: 'ユーザー',
    MENU_ADMIN_MAJORS: '学科',
    MENU_ADMIN_COURSES: '科目',
    MENU_ADMIN_CLASSES: 'クラス',
    MENU_ADMIN_SEMESTERS: '学期',
    MENU_SECTION_SYSTEM: 'システム設定',
    MENU_SECTION_ACADEMIC: '学務設定',
    MENU_SECTION_OPERATION: '運用設定',
    MENU_ADMIN_ASSETS: '設備資産',
    MENU_ADMIN_PERIODS: '授業コマ',
    MENU_ADMIN_TIMETABLE: '時間割',

    // Helper
    HELPER_INTERNAL_UI_HELPER: '内部UIヘルパー',
    HELPER_TITLE: 'UIヘルパー / コンポーネントプレイグラウンド',
    HELPER_LEAD: '共有UIプリミティブ、アイコン状態、デザインシステムの挙動を一か所で確認するためのビジュアルQA画面です。',
    HELPER_CURRENT_PRIMITIVES: '現在のプリミティブ',
    HELPER_PRIMITIVE_BUTTON: 'ボタン',
    HELPER_PRIMITIVE_TABS: 'タブ',
    HELPER_PRIMITIVE_ICON_BUTTON: 'アイコンボタン',
    HELPER_PRIMITIVE_ICON_TOGGLE_BUTTON: 'アイコン切り替えボタン',
    HELPER_PRIMITIVE_SWITCH: 'スイッチ',
    HELPER_PRIMITIVE_LABEL: 'ラベル',
    HELPER_PRIMITIVE_BADGE: 'バッジ',
    HELPER_PRIMITIVE_INPUT: '入力',
    HELPER_PRIMITIVE_DROPDOWN: 'ドロップダウン',
    HELPER_PRIMITIVE_ICON_HELPER: 'アイコンヘルパー',
    HELPER_PRIMITIVE_AVATAR: 'アバター',
    HELPER_PRIMITIVE_DATE_PICKER: '日付選択',
    HELPER_PRIMITIVE_PAGINATION: 'ページネーション',
    HELPER_PRIMITIVE_TOOLTIP: 'ツールチップ',
    HELPER_PRIMITIVE_CHECKBOX: 'チェックボックス',
    HELPER_PRIMITIVE_RADIO_BUTTON: 'ラジオボタン',
    HELPER_PRIMITIVE_MENU_ITEM: 'メニューアイテム',
    HELPER_SECTION_PRIMITIVE: 'プリミティブ',
    HELPER_SECTION_HELPER: 'ヘルパー',
    HELPER_SECTIONS: 'セクション',
    HELPER_NAV_OVERVIEW: '概要',
    HELPER_NAV_TABS: 'タブ',
    HELPER_NAV_BUTTONS: 'ボタン',
    HELPER_NAV_BUTTON_GROUPS: 'ボタングループ',
    HELPER_NAV_ICON_BUTTONS: 'アイコンボタン',
    HELPER_NAV_ICON_TOGGLE_BUTTONS: 'アイコン切り替えボタン',
    HELPER_ICON_TOGGLE_BUTTONS_TITLE: 'アイコン切り替えボタン',
    HELPER_ICON_TOGGLE_BUTTONS_DESC: '状態を切り替えるボタン。主にテーマや言語の変更に使用されます。',
    HELPER_TOGGLE_THEME: 'テーマの切り替え',
    HELPER_TOGGLE_LANGUAGE: '言語の切り替え',
    HELPER_TOGGLE_DISABLED: '無効',
    HELPER_NAV_SWITCHES: 'スイッチ',
    HELPER_NAV_LABELS: 'ラベル',
    HELPER_NAV_BADGES: 'バッジ',
    HELPER_NAV_ICONS: 'アイコン',
    HELPER_NAV_AVATARS: 'アバター',
    HELPER_NAV_AVATAR_GROUP: 'アバターグループ',
    HELPER_NAV_TAG: 'タグ',
    HELPER_DIALOG_TITLE: 'ダイアログ',
    HELPER_TAG_TITLE: 'タグ',
    HELPER_INPUTS_TITLE: '入力',
    HELPER_DATE_PICKER_TITLE: '日付選択',
    HELPER_CALENDAR_CELL_TITLE: 'カレンダーセル',
    HELPER_CHECKBOX_TITLE: 'チェックボックス',
    HELPER_MENU_ITEM_TITLE: 'メニューアイテム',
    HELPER_MENU_ITEM_COLLAPSE_TITLE: 'メニューアイテム (折りたたみ)',
    HELPER_NAV_INPUTS: '入力',
    HELPER_NAV_DROPDOWN: 'ドロップダウン',
    HELPER_NAV_LINKS: 'リンク',
    HELPER_NAV_DATE_PICKER: '日付選択',
    HELPER_NAV_CALENDAR_CELL: 'カレンダーセル',
    HELPER_NAV_PAGINATION: 'ページネーション',
    HELPER_NAV_PAGINATION_CELL: 'ページネーションセル',
    HELPER_NAV_TOOLTIP: 'ツールチップ',
    HELPER_NAV_CHECKBOX: 'チェックボックス',
    HELPER_NAV_RADIO: 'ラジオ',
    HELPER_NAV_DIALOG: 'ダイアログ',
    HELPER_NAV_SIDEBAR: 'サイドバー',
    HELPER_NAV_SELECT: 'セレクト',
    HELPER_NAV_DATA_TABLE: 'データテーブル',
    HELPER_NAV_TABLE: 'テーブル',
    HELPER_NAV_TABLE_HEADER_CELL: 'テーブルヘッダーセル',
    HELPER_NAV_TABLE_CELL: 'テーブルセル',
    HELPER_DIALOG_ANCHORED_TITLE: 'アンカー付きダイアログ（ポップオーバーモード）',
    HELPER_DIALOG_ANCHORED_DESC: 'ダイアログが画面中央ではなくトリガー要素の位置に表示されます。バックドロップは透明で、ダイアログ外側をクリックすると閉じます。',
    HELPER_DIALOG_ANCHORED_TRIGGER: 'アンカー付きダイアログを開く',
    HELPER_DIALOG_ANCHORED_BODY: 'このダイアログはトリガーボタンの右側に表示されます。バックドロップは透明なため、外側をクリックすると閉じます。',
    HELPER_DIALOG_ANCHORED_CONFIRM: '了解',
    HELPER_TABLE_TITLE: 'テーブル',
    HELPER_TABLE_DESC: 'テーブルは、並べ替え、フィルター、ページング、編集、アクション、行選択に対応した構造化データを表示します。',
    HELPER_TABLE_ROW_DIVIDERS: '行の区切り線',
    HELPER_TABLE_ALTERNATING_ROWS: '交互の行背景',
    HELPER_TABLE_SORT_FILTER: '並べ替えとフィルター',
    HELPER_TABLE_PAGINATION: 'ページネーション',
    HELPER_TABLE_EDITABLE: '編集可能なセル',
    HELPER_TABLE_STICKY: '固定列 / 横スクロール',
    HELPER_TABLE_EMPTY: '空の状態',
    HELPER_TABLE_MULTI_SELECTION: '複数選択',
    HELPER_TABLE_SELECT_ALL: 'すべて選択',
    HELPER_TABLE_PARTIAL_SELECTION: '一部選択',
    HELPER_TABLE_NON_SELECTABLE: '選択不可の行',
    HELPER_TABLE_SELECTED_COUNT: '選択済み行',
    HELPER_TABLE_CLEAR_SELECTION: '選択を解除',
    HELPER_TABLE_SELECTED_ACTION: '選択行のアクション背景',
    HELPER_TABLE_ALTERNATE: '代替背景',
    HELPER_TABLE_NEUTRAL: 'ニュートラル背景',
    HELPER_TABLE_HEADER_TITLE: 'テーブルヘッダーセル',
    HELPER_TABLE_HEADER_DESC: '高さ48px、余白8px、body/md太字、任意のアクションと下線に対応します。',
    HELPER_TABLE_HEADER_DEFAULT: 'デフォルト（区切り線なし）',
    HELPER_TABLE_HEADER_BOTTOM_OUTLINE: '下線',
    HELPER_TABLE_HEADER_ACTION: 'アクション背景',
    HELPER_TABLE_HEADER_ALTERNATE: '代替背景',
    HELPER_TABLE_HEADER_NEUTRAL: 'ニュートラル背景',
    HELPER_TABLE_HEADER_CHECKBOX: '選択チェックボックス',
    HELPER_TABLE_HEADER_SORTABLE: '並べ替え可能なラベル',
    HELPER_TABLE_HEADER_FILTERABLE: 'フィルター可能なラベル',
    HELPER_TABLE_HEADER_ACTIVE: '選択中の並べ替え / フィルター',
    HELPER_TABLE_CELL_TITLE: 'テーブルセル',
    HELPER_TABLE_CELL_DESC: '最小高さ60px、左右8px・上下4pxの余白で、共有UIコンテンツを配置します。',
    HELPER_TABLE_CELL_TEXT: 'テキスト',
    HELPER_TABLE_CELL_TEXT_SUBTEXT: 'テキストと補足テキスト',
    HELPER_TABLE_CELL_AVATAR: 'アバター',
    HELPER_TABLE_CELL_ACTION_BUTTON: 'アクションボタン',
    HELPER_TABLE_CELL_ICON: 'アイコンのみ',
    HELPER_TABLE_CELL_MULTI_ICONS: '複数アイコン',
    HELPER_TABLE_CELL_BADGE: 'バッジ / ピル',
    HELPER_TABLE_CELL_ICON_BADGE: 'アイコン付きバッジ',
    HELPER_TABLE_CELL_CHECKBOX: 'チェックボックスのみ',
    HELPER_TABLE_CELL_RADIO: 'ラジオのみ',
    HELPER_TABLE_CELL_SWITCH: 'スイッチのみ',
    HELPER_TABLE_CELL_INPUT: 'コンパクト入力',
    HELPER_TABLE_CELL_PROGRESS: '進捗リング',
    HELPER_TABLE_CELL_DEFAULT: 'デフォルト背景',
    HELPER_TABLE_CELL_ACTION: 'アクション背景',
    HELPER_TABLE_CELL_ALTERNATE: '代替背景',
    HELPER_TABLE_CELL_NEUTRAL: 'ニュートラル背景',
    TABLE_SELECT_ROW: '{0}を選択',
    HELPER_NAV_RADIO_BUTTONS: 'ラジオボタン',
    HELPER_TABS_TITLE: 'タブ',
    HELPER_TABS_DESC: '状態、アイコン、ローディング、アクション、幅、アクセントカラーを確認できる共有タブプリミティブです。',
    HELPER_TABS_STATE_DEMO: '状態とアクション',
    HELPER_TABS_CONFIG_DEMO: 'レイアウト設定',
    HELPER_TABS_LAST_ACTION: '最後のアクション',
    HELPER_LINK_TITLE: 'リンク',
    HELPER_LINK_DESC: 'リンクコンポーネントは、Webページやページ内の特定セクションへのナビゲーションに使用します。',
    HELPER_LINK_MAIN_COMPONENT: 'メインコンポーネント',
    HELPER_LINK_QUICK_TOGGLE: 'クイック切り替え',
    HELPER_LINK_TYPE: 'タイプ',
    HELPER_LINK_STATE: '状態',
    HELPER_LINK_USAGE: '使用例',
    HELPER_LINK_BASE: '基本',
    HELPER_LINK_SHOW_LEFT_ICON: '左アイコン表示',
    HELPER_LINK_SHOW_RIGHT_ICON: '右アイコン表示',
    HELPER_LINK_DEFAULT: 'デフォルト',
    HELPER_LINK_INLINE: 'インライン',
    HELPER_LINK_HOVER: 'ホバー',
    HELPER_LINK_FOCUSED: 'フォーカス',
    HELPER_LINK_DISABLED: '無効',
    HELPER_LINK_INTERNAL_ROUTE: '内部リンク',
    HELPER_LINK_EXTERNAL: '外部リンク',
    HELPER_LINK_INLINE_PARAGRAPH: '段落内リンク',
    HELPER_PAGINATION_TITLE: 'ページネーション',
    HELPER_PAGINATION_DESC: '長い一覧や複数ページのコンテンツを移動するための、Figma準拠の共有ページネーションです。',
    HELPER_PAGINATION_MAIN_COMPONENT: 'メインコンポーネント',
    HELPER_PAGINATION_LAYOUT: 'レイアウト',
    HELPER_PAGINATION_STATE: '状態と使用例',
    HELPER_PAGINATION_CELL_TITLE: 'ページネーションセル',
    HELPER_PAGINATION_CELL_DESC: 'ページ番号、選択状態、省略記号を表示するページネーション内部のセルです。',
    HELPER_PAGINATION_CELL_STATE: 'セルの状態',
    HELPER_PAGINATION_DEFAULT: 'デフォルト',
    HELPER_PAGINATION_HOVER: 'ホバー',
    HELPER_PAGINATION_FOCUSED: 'フォーカス',
    HELPER_PAGINATION_SELECTED: '選択済み',
    HELPER_PAGINATION_DISABLED: '無効',
    HELPER_PAGINATION_USAGE: '他のコンポーネントでの使用例',
    HELPER_PAGINATION_FIRST_PAGE: '先頭ページ',
    HELPER_PAGINATION_MIDDLE_PAGE: '中間ページ',
    HELPER_PAGINATION_LAST_PAGE: '最終ページ',
    HELPER_PAGINATION_NO_FIRST_LAST: '先頭・最終ボタンなし',
    HELPER_PAGINATION_SMALL_PAGE_COUNT: '少ないページ数',
    HELPER_NAV_MENU_ITEM: 'メニューアイテム',
    HELPER_NAV_MENU_ITEM_COLLAPSE: 'メニューアイテム (折りたたみ)',
    HELPER_NAV_TOAST: 'トースト',
    HELPER_TOAST_TITLE: 'トースト',
    HELPER_TOAST_DESC: '6つの位置やバックグラウンド処理に対応した通知コンポーネントです。',
    HELPER_TOAST_DEMO_SYNC: 'バックグラウンド同期を実行',
    HELPER_TOAST_SYNC_DESC: 'このデモはトーストの表示状態のみをlocalStorageから復元します。本番環境では、バックエンドがjobIdとステータス確認APIを提供し、更新後または再ログイン後にフロントエンドが処理状態を再確認する必要があります。',
    HELPER_TOAST_SYNC_TRIGGER: 'バックグラウンド同期を実行（無期限）',
    HELPER_TOAST_SYNC_FINISH: 'バックグラウンド同期を完了（APIイベントシミュレーション）',
    TOAST_SYNC_RUNNING: 'データを同期しています...',
    TOAST_SYNC_SUCCESS: 'データの同期が完了しました。',
    HELPER_RADIO_TITLE: 'ラジオボタン',
    HELPER_RADIO_DESC: '状態、ラベル、補足テキスト、フォーム連携に対応した、Figma準拠の共有ラジオボタンです。',
    HELPER_RADIO_MAIN_COMPONENT: 'メインコンポーネント',
    HELPER_RADIO_SELECTED: '選択状態',
    HELPER_RADIO_STATE: '状態',
    HELPER_RADIO_LABEL_USAGE: 'ラベルの使用例',
    HELPER_RADIO_GROUP_USAGE: 'ラジオグループの使用例',
    HELPER_RADIO_USAGE_IN_OTHER_COMPONENTS: '他のコンポーネントでの使用例',
    HELPER_RADIO_DEFAULT: 'デフォルト',
    HELPER_RADIO_HOVER: 'ホバー',
    HELPER_RADIO_FOCUSED: 'フォーカス',
    HELPER_RADIO_DISABLED: '無効',
    HELPER_RADIO_SELECTED_YES: 'はい / 選択済み',
    HELPER_RADIO_SELECTED_NO: 'いいえ / 未選択',
    HELPER_RADIO_LABEL: 'ラベル付きラジオ',
    HELPER_RADIO_HINT: '補足テキストをここに表示できます。',
    HELPER_RADIO_DISABLED_LABEL: '無効なラジオ',
    HELPER_RADIO_READONLY_LABEL: '読み取り専用のラジオ',
    HELPER_RADIO_OPTION_COMMON: '共通',
    HELPER_RADIO_OPTION_SPECIALIZED: '専門',
    HELPER_RADIO_OPTION_OTHER: 'その他',
    HELPER_RADIO_DROPDOWN_MENU_ITEM: 'メニュー項目',
    HELPER_RADIO_DROPDOWN_META: '推奨',
    HELPER_BUTTONS_TITLE: 'ボタン',
    HELPER_BUTTONS_DESC: 'ボタンディレクティブのバリアント、サイズ、無効状態、読み込み状態、アイコン構成です。',
    HELPER_BUTTON_GROUPS_TITLE: 'ボタングループ',
    HELPER_BUTTON_GROUPS_DESC: '単一選択のセグメントボタンと、前後移動付きの操作グループです。',
    HELPER_BUTTON_GROUPS_SEGMENTED: '単一選択',
    HELPER_BUTTON_GROUPS_NAVIGATION: '前後ナビゲーション',
    HELPER_ICON_BUTTONS_TITLE: 'アイコンボタン',
    HELPER_ICON_BUTTONS_DESC: 'appIconButton のバリアント、トーン、サイズ、無効状態、選択状態です。',
    HELPER_SWITCHES_TITLE: 'スイッチ',
    HELPER_SWITCHES_DESC: 'app-switch セレクターを使ったスイッチの状態、ラベル、無効状態、対応サイズです。',
    HELPER_LABEL_TITLE: 'ラベル',
    HELPER_LABEL_DESC: 'フォームやコントロール向けの、必須マーカー、情報アイコン、無効状態に対応したFigma準拠の共有ラベルです。',
    HELPER_LABEL_MAIN_COMPONENT: 'メインコンポーネント',
    HELPER_LABEL_QUICK_TOGGLE: 'クイック切り替え',
    HELPER_LABEL_STATE: '状態',
    HELPER_LABEL_ICON_POSITION: 'アイコン位置',
    HELPER_LABEL_REQUIRED_MARKER: '必須マーカー',
    HELPER_LABEL_USAGE: '使用例',
    HELPER_LABEL_BASE: '基本',
    HELPER_LABEL_REQUIRED: '必須',
    HELPER_LABEL_INFORMATION: '情報',
    HELPER_LABEL_DEFAULT: 'デフォルト',
    HELPER_LABEL_DISABLED: '無効',
    HELPER_LABEL_ICON_RIGHT: '右アイコン',
    HELPER_LABEL_ICON_LEFT: '左アイコン',
    HELPER_LABEL_NO_ICON: 'アイコンなし',
    HELPER_LABEL_SHOW_REQUIRED: 'showRequired: true',
    HELPER_LABEL_HIDE_REQUIRED: 'showRequired: false',
    HELPER_LABEL_SAMPLE_TEXT: 'ラベル',
    HELPER_LABEL_INFO_TEXT: 'この項目の入力方法に関する補足情報です。',
    HELPER_LABEL_COURSE_NAME: '科目名',
    HELPER_LABEL_COURSE_PLACEHOLDER: '科目名を入力',
    HELPER_LABEL_SELECT_COURSE: '科目を選択',
    HELPER_LABEL_USAGE_INPUT: 'app-input の上に配置',
    HELPER_LABEL_USAGE_DROPDOWN: 'app-dropdown の上に配置',
    HELPER_LABEL_USAGE_INFO: '情報テキスト付きラベル',
    HELPER_BADGE_TITLE: 'バッジ',
    HELPER_BADGE_DESC: 'バッジは、ステータス、カテゴリ、メタデータをコンパクトに表示します。',
    HELPER_BADGE_MAIN_COMPONENT: 'メインコンポーネント',
    HELPER_BADGE_ICON_PLACEMENT: 'アイコン位置',
    HELPER_BADGE_VARIANT: 'バリエーション',
    HELPER_BADGE_SIZE: 'サイズ',
    HELPER_BADGE_DYNAMIC_COLORS: '動的カラー',
    HELPER_BADGE_USAGE: '使用例',
    HELPER_BADGE_OUTLINE: 'アウトライン',
    HELPER_BADGE_FILLED: '塗りつぶし',
    HELPER_BADGE_SMALL: '小',
    HELPER_BADGE_MEDIUM: '中',
    HELPER_BADGE_LARGE: '大',
    HELPER_BADGE_LEFT_ICON: '左アイコン',
    HELPER_BADGE_RIGHT_ICON: '右アイコン',
    HELPER_BADGE_BOTH_ICONS: '両側アイコン',
    HELPER_BADGE_NO_ICON: 'アイコンなし',
    HELPER_BADGE_DISABLED: '無効',
    HELPER_BADGE_STATUS: 'ステータス',
    HELPER_BADGE_COURSE_COLOR: 'コースカラー',
    HELPER_BADGE_LONG_TEXT: '長いテキスト',
    HELPER_BADGE_SAMPLE_LABEL: 'ラベル',
    HELPER_BADGE_ACTION_ORANGE: 'アクションオレンジ',
    HELPER_BADGE_SUCCESS_GREEN: '成功グリーン',
    HELPER_BADGE_INFORMATION_BLUE: '情報ブルー',
    HELPER_BADGE_DANGER_RED: '危険レッド',
    HELPER_BADGE_CUSTOM_PURPLE: 'カスタムパープル',
    HELPER_BADGE_NORMAL_LABEL: '通常ラベル',
    HELPER_BADGE_TRUNCATED_LABEL: '省略ラベル',
    HELPER_BADGE_LONG_TEXT_SAMPLE: 'これはバッジ内に表示される長いテキストの例です',
    HELPER_BADGE_ACTIVE: '有効',
    HELPER_BADGE_COURSE_VALUE: '日本語',
    HELPER_BADGE_REMOVABLE: '削除可能風',
    HELPER_BADGE_METADATA: 'メタデータ',
    HELPER_DROPDOWN_TITLE: 'ドロップダウン',
    HELPER_DROPDOWN_DESC: '検索、選択コントロール、アバター、カラードット、詳細なオプション表示に対応した、単一選択・複数選択共通のプリミティブです。',
    HELPER_DROPDOWN_EXAMPLES: 'ドロップダウン例',
    HELPER_DROPDOWN_COURSES: '科目',
    HELPER_DROPDOWN_USERS: 'ユーザー',
    HELPER_DROPDOWN_TAGS: '個のタグ',
    HELPER_DROPDOWN_TEACHERS: '名の教師',
    HELPER_DROPDOWN_BASIC_SINGLE: '基本の単一選択',
    HELPER_DROPDOWN_SINGLE_SEARCH: '検索付き単一選択',
    HELPER_DROPDOWN_MULTI_CHECKBOX: 'チェックボックス付き複数選択',
    HELPER_DROPDOWN_SINGLE_RADIO: 'ラジオ付き単一選択',
    HELPER_DROPDOWN_AVATAR: 'アバター',
    HELPER_DROPDOWN_MULTI_AVATAR: 'アバター付きユーザー複数選択',
    HELPER_DROPDOWN_DOT_COLOR: 'ドット / カラー',
    HELPER_DROPDOWN_DISABLED: '無効',
    HELPER_DROPDOWN_ERROR: 'エラー',
    HELPER_DROPDOWN_EMPTY_STATE: '空の状態',
    HELPER_DROPDOWN_MAX_BADGES: '最大バッジ数と省略表示',
    HELPER_DROPDOWN_OPTION_SUBLABEL: 'サブラベル付きオプション',
    HELPER_DROPDOWN_OPTION_ICON: 'アイコン付きオプション',
    HELPER_DROPDOWN_SELECT_COURSE: '科目を選択',
    HELPER_DROPDOWN_SEARCH_COURSE: '科目を検索',
    HELPER_DROPDOWN_SELECT_TEACHERS: '教師を選択',
    HELPER_DROPDOWN_SELECT_COURSE_TYPE: '授業タイプを選択',
    HELPER_DROPDOWN_SELECT_USER: 'ユーザーを選択',
    HELPER_DROPDOWN_SELECT_USERS: 'ユーザーを選択',
    HELPER_DROPDOWN_SEARCH_USER: 'ユーザーを検索',
    HELPER_DROPDOWN_COURSE_REQUIRED: '科目は必須です',
    HELPER_DROPDOWN_NO_AVAILABLE_COURSES: '選択可能な科目がありません',
    HELPER_DROPDOWN_NO_COURSES_FOUND: '科目が見つかりません',
    HELPER_DROPDOWN_SELECTED: '選択中',
    HELPER_DROPDOWN_NONE: 'なし',
    HELPER_ICONS_TITLE: 'アイコン',
    HELPER_ICONS_DESC: 'IconHelperService から登録済みアイコンを表示し、利用可能な選択状態も確認できます。',
    HELPER_AVATARS_TITLE: 'アバター',
    HELPER_AVATARS_DESC: 'app-avatar の画像、イニシャル、詳細表示、順序切り替えを確認できます。',
    HELPER_AVATAR_IMAGE_SIZES: '画像サイズ',
    HELPER_AVATAR_INITIALS: 'イニシャル表示',
    HELPER_AVATAR_LABEL_PLACEMENT: 'ラベル配置',
    HELPER_AVATAR_DETAILS: '詳細表示',
    HELPER_AVATAR_GROUP_TITLE: 'アバターグループ',
    HELPER_AVATAR_GROUP_DESC: '残りのユーザー数のカウンターを持つアバターのスタックを表示します。',
    HELPER_AVATAR_GROUP_COUNTS: '様々なユーザー数',
    HELPER_AVATAR_GROUP_SIZES: '様々なサイズ',
    HELPER_AVATAR_GROUP_1_USER: '1ユーザー',
    HELPER_AVATAR_GROUP_5_USERS: 'ちょうど5ユーザー',
    HELPER_AVATAR_GROUP_MORE_USERS: '5ユーザー以上',
    HELPER_VARIANTS: 'バリアント',
    HELPER_SIZES: 'サイズ',
    HELPER_TONES: 'トーン',
    HELPER_STATES: '状態',
    HELPER_STATES_AND_ICONS: '状態とアイコン',
    HELPER_SIZES_AND_STATES: 'サイズと状態',
    HELPER_STATE_DISABLED: '無効',
    HELPER_STATE_LOADING: '読み込み中',
    HELPER_STATE_SELECTED: '選択済み',
    HELPER_LEFT_ICON: '左アイコン',
    HELPER_RIGHT_ICON: '右アイコン',
    HELPER_TEXT_ONLY: 'テキストのみ',
    HELPER_ACTION_ICON: 'アクションアイコン',
    HELPER_BUTTON_DETAILS: '詳細',
    HELPER_TEXT_BUTTON: 'テキストボタン',
    HELPER_ADD_ITEM: '項目を追加',
    HELPER_BUTTON_PRIMARY_SIZE: 'プライマリ {0}',
    HELPER_SWITCH_ON: 'オン',
    HELPER_SWITCH_OFF: 'オフ',
    HELPER_SWITCH_DISABLED_ON: '無効オン',
    HELPER_SWITCH_DISABLED_OFF: '無効オフ',
    HELPER_SWITCH_WITH_LABEL: 'ラベル付き',
    HELPER_SWITCH_ENABLED: '有効',
    HELPER_DIRECTIVE_HOSTS: 'ディレクティブホスト',
    HELPER_ICON_REGISTRY: 'アイコンレジストリ',
    HELPER_ICON_REGISTERED_COUNT: '{0}個の登録済みアイコン',
    HELPER_ICON_SEARCH_PLACEHOLDER: 'アイコンを検索...',
    HELPER_ICON_SEARCH_LABEL: 'アイコンを検索',
    HELPER_ICON_DEFAULT: '通常',
    HELPER_ICON_DEFAULT_ONLY: '通常のみ',
    HELPER_COPY_CODE: 'コードをコピー',
    HELPER_CODE_COPIED: 'コピーしました',
    HELPER_TOOLTIP_TITLE: 'ツールチップ',
    HELPER_TOOLTIP_DESC: 'ホバーやキーボードフォーカス時に補足情報を表示し、ビューポート内での自動配置、矢印、サブテキストに対応します。',
    HELPER_TOOLTIP_BASE_VARIANTS: '基本とバリアント',
    HELPER_TOOLTIP_BASE: '基本',
    HELPER_TOOLTIP_SAMPLE_TEXT: 'これはツールチップです。',
    HELPER_TOOLTIP_HOVER_FOCUS: 'ホバーまたはフォーカス',
    HELPER_TOOLTIP_WITH_ARROW: '矢印あり',
    HELPER_TOOLTIP_SHOW_ARROW: '矢印を表示',
    HELPER_TOOLTIP_WITHOUT_ARROW: '矢印なし',
    HELPER_TOOLTIP_HIDE_ARROW: '矢印を非表示',
    HELPER_TOOLTIP_WITH_SUBTEXT: 'サブテキストあり',
    HELPER_TOOLTIP_SUBTEXT: '補足情報をここに表示できます。',
    HELPER_TOOLTIP_SHOW_SUBTEXT: 'サブテキストを表示',
    HELPER_TOOLTIP_DISABLED: '無効',
    HELPER_TOOLTIP_DISABLED_TEXT: 'このツールチップは無効です。',
    HELPER_TOOLTIP_DISABLED_TRIGGER: '無効なツールチップ',
    HELPER_TOOLTIP_ONLY_OVERFLOW: 'オーバーフロー時のみ',
    HELPER_TOOLTIP_OVERFLOW_TEXT: 'この長いラベルは、内容がオーバーフローした場合にのみツールチップを表示します。',
    HELPER_TOOLTIP_PLACEMENT: '配置',
    HELPER_TOOLTIP_PLACEMENT_VALUE: '配置: {0}',
    HELPER_TOOLTIP_PLACEMENT_TOP: '上',
    HELPER_TOOLTIP_PLACEMENT_TOP_START: '上・開始側',
    HELPER_TOOLTIP_PLACEMENT_TOP_END: '上・終了側',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM: '下',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM_START: '下・開始側',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM_END: '下・終了側',
    HELPER_TOOLTIP_PLACEMENT_LEFT: '左',
    HELPER_TOOLTIP_PLACEMENT_RIGHT: '右',
    HELPER_TOOLTIP_THEME_API: 'テーマとAPI',
    HELPER_TOOLTIP_DARK_CONTEXT: 'ダークテーマ',
    HELPER_TOOLTIP_DARK_TEXT: 'ダークテーマのツールチップ',
    HELPER_TOOLTIP_DARK_SUBTEXT: '最も近いテーマコンテキストのトークンを継承します。',
    HELPER_TOOLTIP_DARK_TRIGGER: 'ダークツールチップ',
    HELPER_TOOLTIP_API_TITLE: 'ツールチップのタイトル',
    HELPER_TOOLTIP_API_SUBTEXT: '任意のサブテキスト',
    HELPER_TOOLTIP_API_TRIGGER: 'トリガー',

    // Timetable
    TIMETABLE_TITLE: '時間割',
    TIMETABLE_SUBTITLE: 'ご自分の時間割が表示されています。',
    TIMETABLE_VIEW_LABEL: 'ビューを変えます',
    TIMETABLE_VIEW_TEACHER: '教師',
    TIMETABLE_VIEW_CLASS: 'クラス',
    TIMETABLE_TEACHER_LABEL: '教師',
    TIMETABLE_CLASS_LABEL: 'クラス',
    TIMETABLE_SHOW_UNASSIGNED: '担当していない授業も表示する',
    TIMETABLE_BADGE_ONLINE: 'オンライン',
    TIMETABLE_BADGE_OFFLINE: 'オフライン',

    // Calendar
    CALENDAR_TITLE: 'カレンダー',
    CALENDAR_SUBTITLE: '予定を月・週・日で確認できます',
    CALENDAR_MORE_EVENTS: '件',
    CALENDAR_ALL_DAY: '終日',
    CALENDAR_TOGGLE_COURSE_TIME: '授業の時間を表示',
    CALENDAR_TOGGLE_EVENT: 'イベントを表示',
    CALENDAR_EVENT_LIST_TITLE: 'イベント一覧',
    CALENDAR_EVENT_CREATE_TITLE: 'スケジュール登録',
    CALENDAR_EVENT_EDIT_TITLE: 'スケジュール編集',
    CALENDAR_EVENT_REGISTER: '登録する',
    CALENDAR_EVENT_KIND: '種類',
    CALENDAR_EVENT_KIND_LECTURE: '授業',
    CALENDAR_EVENT_KIND_EVENT: 'イベント',
    CALENDAR_EVENT_CLASS_MODE: '授業区分',
    CALENDAR_EVENT_CLASS_MODE_OFFLINE: '通学',
    CALENDAR_EVENT_SUBJECT: '対象科目',
    CALENDAR_EVENT_TEACHERS: '教師',
    CALENDAR_EVENT_TIME: '時刻',
    CALENDAR_EVENT_START_TIME: '開始時刻',
    CALENDAR_EVENT_END_TIME: '終了時刻',
    CALENDAR_EVENT_PARTICIPANTS: '参加者',
    CALENDAR_EVENT_LEARNING_METHOD: '授業方法',
    CALENDAR_EVENT_JOIN_URL: '参加URL',
    CALENDAR_EVENT_JOIN_NOW: 'ミーティングに参加',
    CALENDAR_EVENT_MEMO: 'メモ',
    CALENDAR_EVENT_DATE_RANGE_INVALID: '開始日は終了日以前である必要があります',
    CALENDAR_EVENT_TIME_RANGE_INVALID: '開始時刻は終了時刻以前である必要があります',
    CALENDAR_EVENT_CONFIRM_TITLE: 'スケジュール登録確認',
    CALENDAR_EVENT_CONFIRM_MESSAGE: '以下のスケジュールを登録します。\nよろしいでしょうか',
    CALENDAR_EVENT_CREATE_CONFIRM_TITLE: '登録しますか？',
    CALENDAR_EVENT_CREATE_CONFIRM_MESSAGE: 'この内容で登録します。\n続行しますか？',
    CALENDAR_EVENT_EDIT_CONFIRM_TITLE: '更新しますか？',
    CALENDAR_EVENT_EDIT_CONFIRM_MESSAGE: 'この内容で更新します。\n続行しますか？',
    CALENDAR_EVENT_DELETE_CONFIRM_TITLE: '削除しますか？',
    CALENDAR_EVENT_DELETE_CONFIRM_MESSAGE: 'この予定を削除します。\n続行しますか？',
    CALENDAR_EVENT_TOTAL_COUNT: '合計',
    CALENDAR_EVENT_TOTAL_SUFFIX: '件',
    CALENDAR_EVENT_DETAIL_DATETIME: '日時',
    CALENDAR_EVENT_DETAIL_TEACHER: '教師',
    CALENDAR_EVENT_DETAIL_LECTURE_TYPE: '授業種類',
    CALENDAR_EVENT_DETAIL_LOCATION: '場所・URL',
    CALENDAR_EVENT_DETAIL_MATERIALS: '教材',
    CALENDAR_EVENT_ASSIGNMENTS: '課題',
    CALENDAR_EVENT_WITHDRAW: '授業辞退',
    CALENDAR_EVENT_SCOPE_EDIT_TITLE: '繰り返し予定を修正しますか？',
    CALENDAR_EVENT_SCOPE_EDIT_MESSAGE: '繰り返し予定の日時を変更すると、繰り返しの例外として設定した予定を上書きします。',
    CALENDAR_EVENT_SCOPE_DELETE_TITLE: '繰り返し予定を削除しますか？',
    CALENDAR_EVENT_SCOPE_DELETE_MESSAGE: '繰り返し予定を削除すると、例外予定も削除されます。',
    CALENDAR_EVENT_SCOPE_EDIT_SINGLE: 'この予定のみ修正する',
    CALENDAR_EVENT_SCOPE_EDIT_FUTURE: 'この予定以降の予定をすべて修正',
    CALENDAR_EVENT_SCOPE_EDIT_ALL: '繰り返し予定をすべて修正',
    CALENDAR_EVENT_SCOPE_DELETE_SINGLE: 'この予定のみ削除する',
    CALENDAR_EVENT_SCOPE_DELETE_FUTURE: 'この予定以降の予定をすべて削除',
    CALENDAR_EVENT_SCOPE_DELETE_ALL: '繰り返し予定をすべて削除',
    CALENDAR_EVENT_EDIT_SINGLE_HINT: '{date} の予定を修正中',
    CALENDAR_EVENT_EDIT_FUTURE_HINT: '{date} 以降の予定をすべて修正中',
    CALENDAR_EVENT_EDIT_ALL_HINT: 'すべての繰り返し予定を修正中',
    CALENDAR_EVENT_LEARNING_METHOD_OFFLINE_PLACE: '通学場所',
    CALENDAR_EVENT_LEARNING_METHOD_ONDEMAND_URL: '視聴URL',
    CALENDAR_REPEAT_DIALOG_TITLE: '繰り返しカスタマイズ',
    CALENDAR_REPEAT_LABEL: '繰返',
    CALENDAR_REPEAT_WEEK_LABEL: '繰り返し週間',
    CALENDAR_REPEAT_DAY_LABEL: '曜日',
    CALENDAR_REPEAT_END_DATE_LABEL: '終了日',
    CALENDAR_REPEAT_END_NONE: 'なし',
    CALENDAR_REPEAT_END_HAS: 'あり',
    CALENDAR_REPEAT_NO_DEADLINE: '期限なし',
    CALENDAR_REPEAT_END_SUFFIX: '終了',
    CALENDAR_REPEAT_END_PLACEHOLDER: '終了日を選択',
    CALENDAR_REPEAT_EVERY_DAY: '毎日',
    CALENDAR_REPEAT_NONE: 'なし',
    CALENDAR_REPEAT_SET: 'セットする',
    CALENDAR_REPEAT_WEEK_1: '第1週目',
    CALENDAR_REPEAT_WEEK_2: '第2週目',
    CALENDAR_REPEAT_WEEK_3: '第3週目',
    CALENDAR_REPEAT_WEEK_4: '第4週目',
    CALENDAR_REPEAT_WEEK_5: '第5週目',

    // E-book management
    EBOOK_TITLE: '教科書管理',
    EBOOK_SUBTITLE: '教材・教科書を管理します',
    EBOOK_SEARCH: '教材を検索...',
    EBOOK_COL_NAME: 'ファイル名',
    EBOOK_COL_CATEGORY: '種類',
    EBOOK_COL_UPLOADER: '登録者',
    EBOOK_COL_UPLOADED_AT: '登録日時',
    EBOOK_COL_STATUS: 'ステータス',
    EBOOK_COL_EXPIRY: '有効期限',
    EBOOK_DIALOG_ADD_TITLE: '教材を追加',
    EBOOK_DIALOG_EDIT_TITLE: '教材を編集',
    EBOOK_DIALOG_VIEW_TITLE: '教材詳細',
    EBOOK_FIELD_NAME: 'ファイル名',
    EBOOK_FIELD_NAME_PLACEHOLDER: 'ファイル名を入力',
    EBOOK_FIELD_CATEGORY: '種類',
    EBOOK_FIELD_CATEGORY_PLACEHOLDER: '種類を選択',
    EBOOK_FIELD_UPLOADER: '登録者',
    EBOOK_FIELD_UPLOADER_PLACEHOLDER: '登録者を入力',
    EBOOK_FIELD_UPLOADED_AT: '登録日時',
    EBOOK_FIELD_UPLOADED_AT_PLACEHOLDER: '登録日を選択',
    EBOOK_FIELD_STATUS: 'ステータス',
    EBOOK_FIELD_STATUS_PLACEHOLDER: 'ステータスを選択',
    EBOOK_FIELD_EXPIRY: '有効期限',
    EBOOK_FIELD_EXPIRY_PLACEHOLDER: '有効期限を選択',
    EBOOK_FIELD_DESCRIPTION: '説明',
    EBOOK_FIELD_DESCRIPTION_PLACEHOLDER: '説明を入力',
    EBOOK_DETAIL_TITLE: 'PDF閲覧',
    EBOOK_DETAIL_SUBTITLE: 'PDFファイルを表示しています',
    EBOOK_DETAIL_EMPTY: '表示できるファイルがありません',
    PDF_TOOLBAR_HAND: 'ハンドモードに切り替え',
    PDF_TOOLBAR_SELECT: 'セレクトモードに切り替え',
    PDF_TOOLBAR_DOWNLOAD: 'ダウンロード',
    PDF_TOOLBAR_FULLSCREEN: 'フルスクリーン',
    PDF_TOOLBAR_EXIT_FULLSCREEN: 'フルスクリーン解除',
    PDF_TOOLBAR_SEARCH_PLACEHOLDER: 'PDFを検索...',
    COURSE_DETAIL_TITLE: '科目詳細',
    COURSE_DETAIL_SUBTITLE: '科目の学習内容と教材を確認します',
    COURSE_DETAIL_TAB_INFO: '概要',
    COURSE_DETAIL_TAB_LECTURES: '授業',
    COURSE_DETAIL_TAB_ASSIGNMENTS: '課題',
    COURSE_DETAIL_TAB_STUDENTS: '受講生',
    COURSE_DETAIL_TAB_COMING_SOON: 'この画面は準備中です',
    COURSE_DETAIL_TAB_EBOOK: '教科書',
    COURSE_DETAIL_TAB_VIDEOS: 'ビデオ',
    COURSE_DETAIL_TAB_TEST: 'テスト',
    COURSE_DETAIL_INFO_TITLE: '科目情報',
    COURSE_DETAIL_INFO_SUBTITLE: '科目の基本情報を表示します',
    COURSE_DETAIL_INFO_OVERVIEW: '概要情報',
    COURSE_DETAIL_INFO_CLASS_INFO: '授業クラス情報',
    COURSE_DETAIL_INFO_PROGRESS: '授業進捗',
    COURSE_DETAIL_INFO_TEACHING: '授業情報',
    COURSE_DETAIL_INFO_YEAR: '学年',
    COURSE_DETAIL_INFO_SEMESTER: '学期',
    COURSE_DETAIL_INFO_MAJOR: '学科',
    COURSE_DETAIL_INFO_TEACHER: '担当教師',
    COURSE_DETAIL_INFO_CREDITS: '単位数',
    COURSE_DETAIL_INFO_GRADING: '採点方法',
    COURSE_DETAIL_INFO_EVALUATION: '評価',
    COURSE_DETAIL_INFO_CLASS_TYPE: '授業種類',
    COURSE_DETAIL_INFO_SCHEDULE: '時間割',
    COURSE_DETAIL_PROGRESS_COMPLETE: '{0}% 完成した',
    COURSE_DETAIL_PROGRESS_DAYS_LEFT: '期末試験まで',
    COURSE_DETAIL_PROGRESS_ATTENDANCE: '授業の出席率',
    COURSE_DETAIL_PROGRESS_ASSIGNMENT: '課題の提出期限',
    COURSE_DETAIL_FLEX_PROGRESS_TITLE: '科目の進捗',
    COURSE_DETAIL_FLEX_PROGRESS_TEACHER_TITLE: '科目の完成進捗',
    COURSE_DETAIL_FLEX_SUBMIT_RATE: '提出率',
    COURSE_DETAIL_FLEX_WATCH_RATE: '視聴率',
    COURSE_DETAIL_FLEX_MISSING_COUNT: '未提出件数',
    COURSE_DETAIL_FLEX_AVG_SUBMIT: '平均提出率',
    COURSE_DETAIL_FLEX_AVG_WATCH: '平均視聴率',
    COURSE_DETAIL_FLEX_COURSE_COUNT: '科目数',
    COURSE_DETAIL_FLEX_UNWATCHED: '未視聴一覧',
    COURSE_DETAIL_FLEX_PENDING_ASSIGNMENT: '課題未提出一覧',
    COURSE_DETAIL_FLEX_CONTINUE: '続ける',
    COURSE_DETAIL_FLEX_FINISH: '終了にする',
    COURSE_DETAIL_FLEX_FINISHED: '終了済',
    COURSE_DETAIL_FLEX_FINISH_CONFIRM_TITLE: '科目を終了しますか？',
    COURSE_DETAIL_FLEX_FINISH_CONFIRM_MESSAGE: 'この操作は取り消せません。\n続行しますか？',
    COURSE_DETAIL_FLEX_MODE_OFFLINE: 'オフライン',
    COURSE_DETAIL_FLEX_MODE_ONDEMAND: 'オンデマンド',
    COURSE_DETAIL_FLEX_MODE_ONLINE: 'オンライン',
    COURSE_DETAIL_FLEX_DUE_DATE: '提出期限',
    COURSE_DETAIL_TEST_TITLE: 'テスト',
    COURSE_DETAIL_TEST_SUBTITLE: 'テストの内容は後で追加します',
    PDF_TOOL_HIGHLIGHT: 'ハイライト',
    PDF_TOOL_DRAW: '描画',
    PDF_TOOL_ERASE: '消しゴム',
    PDF_TOOL_NOTE: 'メモ',
    PDF_TOOL_UNDO: '元に戻す',
    PDF_TOOL_REDO: 'やり直し',
    PDF_TOOL_SAVE: '保存',
    PDF_TOOL_DOWNLOAD: 'ダウンロード',
    PDF_LOADING_TITLE: 'PDFを読み込み中...',
    PDF_LOADING_CONNECTING: '接続中...',
    PDF_LOADING_DOWNLOADED: '{0} ダウンロード済み...',
    EBOOK_CATEGORY_ALL_CLASSES: '全てのクラス',
    EBOOK_CATEGORY_KG202601: 'KG202601',
    EBOOK_CATEGORY_KG202602: 'KG202602',
    EBOOK_CATEGORY_KG202701: 'KG202701',
    EBOOK_CATEGORY_KG202702: 'KG202702',
    EBOOK_UPLOAD_TITLE: '教材新規登録',
    EBOOK_UPLOAD_DROP_TITLE: 'ファイルをここにドラッグ＆ドロップ',
    EBOOK_UPLOAD_DROP_SUBTITLE: 'またはクリックしてファイルを選択',
    EBOOK_UPLOAD_SELECT_FILE: 'ファイルを選択',
    EBOOK_UPLOAD_UPLOADING: 'アップロード中',
    EBOOK_UPLOAD_NAME_LABEL: '名称',
    EBOOK_UPLOAD_NAME_PLACEHOLDER: '名称を入力',
    EBOOK_UPLOAD_SHARE_LABEL: '共有先',
    EBOOK_UPLOAD_SHARE_PLACEHOLDER: '共有先を選択',
    EBOOK_UPLOAD_EXPIRY_LABEL: '有効期限',
    EBOOK_UPLOAD_EXPIRY_NONE: 'なし',
    EBOOK_UPLOAD_EXPIRY_HAS: 'あり',
    EBOOK_UPLOAD_REGISTER: '登録する',
    VIDEO_TITLE: 'ビデオ管理',
    VIDEO_SUBTITLE: '授業ビデオを管理します',
    VIDEO_SEARCH: 'ビデオを検索...',
    VIDEO_COL_NAME: 'ビデオ名',
    VIDEO_COL_SESSION: 'セッション',
    VIDEO_COL_UPLOADER: '登録者',
    VIDEO_COL_UPLOADED_AT: '登録日時',
    VIDEO_COL_STATUS: 'ステータス',
    VIDEO_COL_DURATION: '時間',
    VIDEO_UPLOAD_TITLE: 'ビデオ新規登録',
    VIDEO_UPLOAD_DROP_TITLE: 'ドラッグ＆ドロップ',
    VIDEO_UPLOAD_DROP_SUBTITLE: 'または',
    VIDEO_UPLOAD_SELECT_FILE: 'ファイルを選択',
    VIDEO_UPLOAD_UPLOADING: 'アップロード中',
    VIDEO_UPLOAD_NAME_LABEL: '名称',
    VIDEO_UPLOAD_NAME_PLACEHOLDER: '名称を入力',
    VIDEO_UPLOAD_SESSION_LABEL: 'セッション',
    VIDEO_UPLOAD_SESSION_PLACEHOLDER: 'セッションを選択',
    VIDEO_UPLOAD_DESCRIPTION_LABEL: '説明',
    VIDEO_UPLOAD_DESCRIPTION_PLACEHOLDER: '説明を入力',
    VIDEO_UPLOAD_REGISTER: '登録する',
    VIDEO_DETAIL_SUBTITLE: '授業ビデオの内容を確認します',
    VIDEO_DETAIL_NAME: 'ビデオ名',
    VIDEO_DETAIL_DESCRIPTION: '説明',
    VIDEO_DETAIL_NEXT: '次のビデオ',
    VIDEO_DETAIL_STATS_TITLE: '視聴状況',
    VIDEO_DETAIL_AVG_PROGRESS: '平均視聴率',
    VIDEO_DETAIL_STAT_VIEWERS: '視聴者数',
    VIDEO_DETAIL_STAT_COMPLETED: '完了',
    VIDEO_DETAIL_STAT_PROGRESS: '平均進捗',
    VIDEO_DETAIL_TABLE_NAME: '受講者',
    VIDEO_DETAIL_TABLE_PROGRESS: '進捗',
    VIDEO_DETAIL_TABLE_LAST: '最終視聴',
    VIDEO_DETAIL_TABLE_STATUS: 'ステータス',
    VIDEO_DETAIL_VIEWERS: '名',
    VIDEO_DETAIL_COMPLETED: '名完了',
    VIDEO_DETAIL_MATERIALS: '参考資料',
    VIDEO_DETAIL_SUBMIT: '課題',
    VIDEO_DETAIL_SUBMIT_PDF: 'Kiểm tra giữa kỳ giải tích 1.pdf',
    VIDEO_DETAIL_SUBMIT_LINK: '提出URL',
    VIDEO_DETAIL_SUBMITTED: '提出済',
    VIDEO_DETAIL_SUBMIT_ACTION: '提出する',
    VIDEO_DETAIL_SUBMIT_CONFIRM_NOTE: 'このボタンを押すと、課題は提出済みとして確定されます',
    VIDEO_DETAIL_NOT_SUBMITTED: '未提出',
    VIDEO_DETAIL_SUBMIT_URL_LABEL: '課題提出URL',
    VIDEO_DETAIL_SUBMIT_URL_PLACEHOLDER: 'Google DriveのURLを貼り付けてください',
    VIDEO_DETAIL_SUBMIT_URL_NOTE: '一回だけ動画の視聴完了まで提出できません',
    VIDEO_DETAIL_COL_VIEWER_PROGRESS: '視聴進捗',
    VIDEO_DETAIL_COL_SUBMISSION_PROGRESS: '提出進捗',
    VIDEO_DETAIL_SYNC: '視聴進捗更新',
    VIDEO_DETAIL_LAST_SYNC: '更新時点',
    VIDEO_DETAIL_PREZI_OPEN: 'クリックしてドキュメントを表示',
    VIDEO_DETAIL_HLS_PREPARING_PAGE_TITLE: 'ただいま動画をいっしょうけんめい準備中...',
    VIDEO_DETAIL_HLS_PREPARING_PAGE_DESC: 'しばらくしてから、もう一度このページに戻ってきてね！',
    VIDEO_DETAIL_HLS_BACK_TO_COURSE: '科目詳細に戻る',
    VIDEO_DETAIL_HLS_NOT_PROCESSED_TITLE: '動画はまだ処理されていません',
    VIDEO_DETAIL_HLS_NOT_PROCESSED_DESC: '録画URLがまだ処理キューに登録されていません。管理者に録画URLの設定を依頼してください。',
    VIDEO_DETAIL_HLS_QUEUED_TITLE: '動画は処理待ちです',
    VIDEO_DETAIL_HLS_QUEUED_DESC: '録画変換ジョブはキューに登録済みです。処理開始までしばらくお待ちください。',
    VIDEO_DETAIL_HLS_PENDING_TITLE: '動画を準備中です',
    VIDEO_DETAIL_HLS_PENDING_DESC: '録画を登録中です。しばらくしてから再度ご確認ください。',
    VIDEO_DETAIL_HLS_FAILED_TITLE: '動画の処理に失敗しました',
    VIDEO_DETAIL_HLS_FAILED_DESC: '録画のトランスコードに失敗しました。管理者に録画URLを再設定してもらってください。',
    VIDEO_DETAIL_HLS_NEW_VERSION_TITLE: '新しい動画バージョンがあります',
    VIDEO_DETAIL_HLS_NEW_VERSION_DESC: '視聴中の動画は更新されました。進捗は保存されています。ページを再読み込みして新しいバージョンを視聴してください。',
    VIDEO_DETAIL_HLS_RELOAD: '再読み込み',
    VIDEO_DETAIL_HLS_COOKIE_ERROR_TITLE: '動画を読み込めませんでした',
    VIDEO_DETAIL_HLS_COOKIE_ERROR_DESC: '認証に失敗しました。ページを再読み込みしてもう一度お試しください。',
    SYNC_UPLOAD_DROP_LABEL: 'ファイルをここにドラッグ＆ドロップ',
    SYNC_UPLOAD_DROP_HINT: 'またはクリックしてファイルを選択',
    SYNC_UPLOAD_CONFIRM: 'アップロード',
    VIDEO_MGMT_LECTURE_TITLE: '授業ごと管理',
    VIDEO_MGMT_LECTURE_SUBTITLE:
      '各授業セッションを統合的に管理するための管理画面です。授業の詳細情報、出席状況、課題提出状況を確認することができます。また、授業内容を受講生に公開する操作や、ミーティングで録画された動画のURLを設定・紐付けすることで、受講生が後から録画を視聴できるようにすることも可能です。',
    VIDEO_MGMT_STUDENT_SUBTITLE:
      '各授業セッションの情報を確認するための画面です。授業の詳細情報、参考資料を確認・ダウンロードし、授業録画を視聴することができます。',
    VIDEO_MGMT_CLASS_FILTER: 'クラスで絞込',
    VIDEO_MGMT_CLASS_OPTION_1: 'コース①2026/4/4~6/27',
    VIDEO_MGMT_CLASS_OPTION_2: 'コース②2026/7/4~9/26',
    VIDEO_MGMT_CLASS_OPTION_3: 'コース③2026/10/3~12/26',
    VIDEO_MGMT_COL_TITLE: '授業タイトル',
    VIDEO_MGMT_COL_TYPE: '授業種類',
    VIDEO_MGMT_COL_SCHEDULE: '授業日時',
    VIDEO_MGMT_COL_ATTENDANCE: '参加状況',
    VIDEO_MGMT_COL_ASSIGNMENT: '課題提出状況',
    VIDEO_MGMT_COL_PUBLISH: '授業公開',
    VIDEO_MGMT_COL_RECORDING_LINK: '録画紐付く',
    VIDEO_MGMT_COL_ACTION: '操作',
    VIDEO_MGMT_COL_WATCH_STATUS: '視聴状態',
    VIDEO_MGMT_COL_SUBMISSION_STATUS: '提出状態',
    VIDEO_MGMT_COL_MATERIAL_DOWNLOAD: '資料 DOWNLOAD',
    VIDEO_MGMT_COL_DETAIL: '詳細',
    VIDEO_MGMT_LECTURE_TYPE_LIVE: 'LIVE',
    VIDEO_MGMT_LECTURE_TYPE_ON_DEMAND: 'On-Demand',
    VIDEO_MGMT_ATTENDANCE_CONFIRM: '出欠確認',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_TITLE: '出席確定',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_MSG: 'この操作を実行すると、授業は正式に終了となり、選択した受講者の出席が確定されます。\n本当に出席を確定しますか？',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_WARNING_1: '※この操作は一度しか実行できず、実行後は取り消すことができません。',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_WARNING_2: '※選択されていない受講者は欠席として扱われます。',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_YES: '確定する',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_TITLE: '出席確認プレビュー',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_CODE: '学籍番号',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_NAME: '氏名',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_JOIN: '入室時刻',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_LEAVE: '退室時刻',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_JOINED: '出席',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_JOINED_COUNT: '出席予定：',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_EMPTY: '参加者が見つかりません',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_BTN_OK: '出席確定',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_BTN_EXPORT_CSV: 'CSV出力',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_DESC: 'Google Meetによって自動記録された参加者一覧です。',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_ONLINE: 'オンライン',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_INSTRUCTION: '内容をご確認のうえ、実際に受講した受講者を選択し、［出席確認］ボタンを押してください。',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_WARNING: '※参加者一覧はGoogle Meetから自動取得した情報です。受講者番号の入力誤りなどにより、正しく表示されない場合があります。',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_SELECTED: '選択中',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_SELECTED_COUNT: '{0}/{1}名',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_NO: 'No',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_MEET_NAME: '参加者名',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_USER_NAME: 'ユーザー名',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_START: '開始',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_END: '終了',
    VIDEO_MGMT_ATTENDANCE_SAVE_SUCCESS_TITLE: '出欠確認完了',
    VIDEO_MGMT_ATTENDANCE_SAVE_SUCCESS_MSG: '出席情報が正常に保存されました。',
    VIDEO_MGMT_RECORD_LINK: '録画紐付',
    VIDEO_MGMT_RECORD_LINK_ACTION: '紐付く',
    VIDEO_MGMT_RECORD_LINKED: '録画紐付済み',
    VIDEO_MGMT_RECORD_RELINK: '再紐付',
    VIDEO_MGMT_PUBLISH: '公開',
    VIDEO_MGMT_RECORD_DIALOG_TITLE: '録画URLを紐付け',
    VIDEO_MGMT_RECORD_DIALOG_NOTICE:
      'オンライン授業を受けられない方にも参加できるように、Google MeetのURLを録画された動画に切り替えますか',
    VIDEO_MGMT_RECORD_DIALOG_URL_LABEL: 'Google Drive URL',
    VIDEO_MGMT_RECORD_DIALOG_URL_PLACEHOLDER: 'https://drive.google.com/...',
    VIDEO_MGMT_RECORD_DIALOG_URL_REQUIRED: 'URLを入力してください。',
    VIDEO_MGMT_RECORD_DIALOG_SET: '設定する',
    VIDEO_MGMT_RECORD_STATUS_CHECKING_SHORT: '確認中',
    VIDEO_MGMT_RECORD_STATUS_PROCESSING_SHORT: '処理中',
    VIDEO_MGMT_DOWNLOAD_ALL: '資料全ダウンロード',
    VIDEO_MGMT_STATUS_WATCHED: '視聴済',
    VIDEO_MGMT_STATUS_NOT_WATCHED: '未視聴',
    VIDEO_MGMT_STATUS_SUBMITTED: '提出済',
    VIDEO_MGMT_STATUS_NOT_SUBMITTED: '未提出',
    VIDEO_MGMT_STUDENT_MGMT_TITLE: '受講生ごと管理',
    VIDEO_MGMT_STUDENT_MGMT_SUBTITLE:
      '各授業セッションを統合的に管理するための管理画面です。授業の詳細情報、出席状況、課題提出状況を確認することができます。また、ミーティングで録画された動画のURLを設定・紐付けすることで、受講生が後から録画を視聴できるようにすることも可能です。',
    VIDEO_MGMT_STUDENT_COL_NAME: '名前',
    VIDEO_MGMT_STUDENT_COL_WATCH_DETAIL: '視聴詳細',
    VIDEO_MGMT_STUDENT_COL_WATCH_PROGRESS: '視聴状況',
    VIDEO_MGMT_STUDENT_COL_ASSIGNMENT_PROGRESS: '課題提出状況',
    VIDEO_MGMT_STUDENT_COL_SUBMISSION: '提出物',
    VIDEO_MGMT_STUDENT_OPEN: '開く',
    VIDEO_MGMT_STUDENT_EXPORT: 'ダウンロードする',
    VIDEO_MGMT_STUDENT_EXPORT_TOOLTIP_TITLE: '視聴進捗詳細をダウンロード',
    VIDEO_MGMT_STUDENT_EXPORT_TOOLTIP_DESC:
      'クリックするとExcelファイル・PDFファイルがダウンロードされます。生徒ごとに専用のシートに分かれており、各Google Meet授業への参加履歴が詳しく確認できます。',
    VIEWING_DONE: '視聴済み',
    VIEWING_IN_PROGRESS: '視聴中',
    VIEWING_NOT_STARTED: '未視聴',
    SUBMISSION_DONE: '提出済み',
    SUBMISSION_NOT_SUBMITTED: '未提出',
    IN_PROGRESS: '進行中',
    NOT_STARTED: '未開始',

    // Admin users
    ADMIN_USERS_TITLE: 'ユーザー管理',
    ADMIN_USERS_SUBTITLE: 'システムへログインするアカウントの作成・編集・管理を行います。個別作成およびCSV一括登録に対応し、学生・教員・管理者を一元管理します。',
    ADMIN_USERS_SEARCH: 'ユーザーを検索...',
    ADMIN_MAJORS_TITLE: '学科管理',
    ADMIN_MAJORS_SUBTITLE: '学校の学科の新規登録・編集を行う画面です。各学科に対して科目を紐づけ、カリキュラム構成を管理します。',
    ADMIN_MAJORS_LIST_TITLE: '学科リスト',
    ADMIN_MAJORS_DETAIL_TITLE: '学科詳細',
    ADMIN_MAJORS_SEARCH_PLACEHOLDER: '学科を検索...',
    ADMIN_MAJORS_NAME_LABEL: '学科名',
    ADMIN_MAJORS_CODE_LABEL: '学科コード',
    ADMIN_MAJORS_REQUIRED_CREDITS: '必要単位',
    ADMIN_MAJORS_COURSE_SECTION: '科目割り当て',
    ADMIN_MAJORS_COURSE_COUNT: '{0}件の科目が割り当てられています',
    ADMIN_MAJORS_NAME_PLACEHOLDER: '学科名を入力',
    ADMIN_MAJORS_CODE_PLACEHOLDER: '学科コードを入力',
    ADMIN_MAJORS_CREDITS_PLACEHOLDER: '必要単位を入力',
    ADMIN_MAJORS_NO_COURSES: '割り当てられた科目はありません',
    ADMIN_MAJORS_ASSIGN_COURSES: '科目を割り当て',
    ADMIN_MAJORS_ASSIGN_MODAL_TITLE: '科目割り当て',
    ADMIN_CLASSES_TITLE: 'クラス管理',
    ADMIN_CLASSES_SUBTITLE: 'クラス（学生グループ）の新規作成・編集・管理を行う画面です。学生をクラス単位で管理し、履修登録や時間割作成などの業務を効率化します。',
    ADMIN_CLASSES_LIST_TITLE: 'クラスリスト',
    ADMIN_CLASSES_DETAIL_TITLE: 'クラス詳細',
    ADMIN_CLASSES_SEARCH_PLACEHOLDER: 'クラスを検索...',
    ADMIN_CLASSES_NAME_LABEL: 'クラス名称',
    ADMIN_CLASSES_CODE_LABEL: 'クラスコード',
    ADMIN_CLASSES_COHORT_YEAR: '入学年度',
    ADMIN_CLASSES_START_DATE: '開始日',
    ADMIN_CLASSES_GRAD_YEAR: '卒業予定年度',
    ADMIN_CLASSES_NAME_PLACEHOLDER: 'クラス名称を入力',
    ADMIN_CLASSES_CODE_PLACEHOLDER: 'クラスコードを入力',
    ADMIN_CLASSES_YEAR_PLACEHOLDER: '年度を選択',
    ADMIN_CLASSES_STUDENT_SECTION: '生徒割り当て',
    ADMIN_CLASSES_STUDENT_COUNT: '{0}名の生徒が割り当てられています',
    ADMIN_CLASSES_NO_STUDENTS: '割り当てられた生徒はありません',
    ADMIN_CLASSES_ASSIGN_STUDENTS: '生徒を割り当て',
    ADMIN_CLASSES_ASSIGN_MODAL_TITLE: '生徒割り当て',
    SEARCH_STUDENT: '生徒を検索...',
    ADMIN_COURSES_TITLE: '科目管理',
    ADMIN_COURSES_SUBTITLE: '学科科目の新規作成・編集を行い、共通科目または専攻科目として設定できます。教材のアップロードや担当教員の割り当ても本画面で管理可能です。',
    ADMIN_COURSES_LIST_TITLE: '科目リスト',
    ADMIN_COURSES_DETAIL_TITLE: '科目詳細',
    ADMIN_COURSES_SEARCH_PLACEHOLDER: '科目を検索...',
    ADMIN_COURSES_NAME_LABEL: '科目名',
    ADMIN_COURSES_NAME_PLACEHOLDER: '科目名を入力',
    ADMIN_COURSES_CODE_LABEL: '科目コード',
    ADMIN_COURSES_CODE_PLACEHOLDER: '科目コードを入力',
    ADMIN_COURSES_DESCRIPTION_LABEL: '科目説明',
    ADMIN_COURSES_DESCRIPTION_PLACEHOLDER: '科目説明を入力',
    ADMIN_COURSES_CREDITS_LABEL: '単位',
    ADMIN_COURSES_CREDITS_PLACEHOLDER: '単位数を入力',
    ADMIN_COURSES_LECTURES_LABEL: '必要講義数',
    ADMIN_COURSES_LECTURES_PLACEHOLDER: '必要講義数を入力',
    ADMIN_COURSES_ACTIVE_PERIOD_LABEL: '開講期間',
    ADMIN_COURSES_ACTIVE_PERIOD_PLACEHOLDER: '開講期間を入力',
    ADMIN_COURSES_COLOR_LABEL: '科目カラー',
    ADMIN_COURSES_COLOR_PLACEHOLDER: '#FFFFFF',
    ADMIN_COURSES_TYPE_LABEL: '科目種類',
    ADMIN_COURSES_MAJOR_LABEL: '学科',
    ADMIN_COURSES_TEACHER_LABEL: '担当教師',
    ADMIN_COURSES_TEACHER_SECTION: '担当教師',
    ADMIN_COURSES_TEACHER_COUNT: '{0}名の教師が割り当てられています',
    ADMIN_COURSES_ASSIGN_TEACHERS: '教師を割り当て',
    ADMIN_COURSES_NO_TEACHERS: '割り当てられた教師はありません',
    ADMIN_COURSES_ASSIGN_MODAL_TITLE: '教師割り当て',
    ADMIN_COURSES_EBOOK_SECTION: '教材アップロード',
    ADMIN_COURSES_EBOOK_COUNT: '{0}件の教材',
    ADMIN_COURSES_ASSIGN_EBOOKS: '教材を追加',
    ADMIN_COURSES_NO_EBOOKS: '教材がありません',
    SEARCH_TEACHER: '教師を検索...',
    COURSE_TYPE_COMMON: '共通',
    COURSE_TYPE_SPECIAL: '専門',
    ADMIN_SEMESTERS_TITLE: '学期管理',
    ADMIN_SEMESTERS_SUBTITLE: '学期の新規作成および編集を行う画面です。開始月・終了月を設定し、年度をまたいで再利用可能な学期管理を実現します。',
    ADMIN_SEMESTERS_LIST_TITLE: '学期リスト',
    ADMIN_SEMESTERS_DETAIL_TITLE: '学期詳細',
    ADMIN_SEMESTERS_SEARCH_PLACEHOLDER: '学期を検索...',
    ADMIN_SEMESTERS_NAME_LABEL: '学期名',
    ADMIN_SEMESTERS_NAME_PLACEHOLDER: '学期名を入力',
    ADMIN_SEMESTERS_DESC_LABEL: '学期説明',
    ADMIN_SEMESTERS_DESC_PLACEHOLDER: '学期説明を入力',
    ADMIN_SEMESTERS_YEAR_LABEL: '学年',
    ADMIN_SEMESTERS_START_MONTH: '開始月',
    ADMIN_SEMESTERS_END_MONTH: '終了月',
    ADMIN_SEMESTERS_START_MONTH_PLACEHOLDER: '開始月を選択',
    ADMIN_SEMESTERS_END_MONTH_PLACEHOLDER: '終了月を選択',
    ADMIN_SEMESTERS_COURSE_SECTION: '科目割り当て',
    ADMIN_SEMESTERS_COURSE_COUNT: '{0}件の科目が割り当てられています',
    ADMIN_SEMESTERS_ASSIGN_COURSES: '科目を割り当て',
    ADMIN_SEMESTERS_NO_COURSES: '割り当てられた科目はありません',
    ADMIN_SEMESTERS_ASSIGN_MODAL_TITLE: '科目割り当て',
    YEAR_1: '第1年目',
    YEAR_2: '第2年目',
    YEAR_3: '第3年目',
    YEAR_4: '第4年目',
    YEAR_5: '第5年目',
    YEAR_6: '第6年目',
    MONTH_1: '1月',
    MONTH_2: '2月',
    MONTH_3: '3月',
    MONTH_4: '4月',
    MONTH_5: '5月',
    MONTH_6: '6月',
    MONTH_7: '7月',
    MONTH_8: '8月',
    MONTH_9: '9月',
    MONTH_10: '10月',
    MONTH_11: '11月',
    MONTH_12: '12月',
    DEVICE_TYPE_CLASSROOM: '教室',
    DEVICE_TYPE_AV: '視聴覚機器',
    DEVICE_STATUS_AVAILABLE: '使用可能',
    DEVICE_STATUS_IN_USE: '使用中',
    DEVICE_STATUS_UNAVAILABLE: '使用不可能',
    ENROLLMENT_SLOT_LABEL: 'コマ',
    ENROLLMENT_ROOM_PLACEHOLDER: '教室を選択',
    ENROLLMENT_ONLINE_PLACEHOLDER: '参加URLを入力',
    ENROLLMENT_BADGE_ONLINE: 'LIVE',
    DAY_SUN: '日',
    DAY_MON: '月',
    DAY_TUE: '火',
    DAY_WED: '水',
    DAY_THU: '木',
    DAY_FRI: '金',
    DAY_SAT: '土',

    // Shared
    ALL: 'すべて',
    GO: '移動',
    ACTIONS: '操作',
    VIEW: '表示',
    MANAGE: '管理',
    ARCHIVE: 'アーカイブ',
    REGISTER: '登録',
    BACK: '戻る',
    ROLE: 'ロール',
    STATUS: 'ステータス',
    YES: 'はい',
    NO: 'いいえ',
    TA_LABEL: 'TA',
    FIELD_REQUIRED: '必須項目です',
    ASSIGN_COURSE_REQUIRED: '科目のご選択をお願いいたします。',
    VALID_COURSE_TYPE: 'この科目はすでに別の専攻に割り当てられています。',
    ROLE_STUDENT: '生徒',
    ROLE_TEACHER: '教師',
    ROLE_ADMIN: '管理者',
    STATUS_ACTIVE: '有効',
    STATUS_INACTIVE: '無効',
    STATUS_DRAFT: '下書き',
    STATUS_ARCHIVED: 'アーカイブ',
    STATUS_SUSPENDED: '一時停止',
    MALE: '男性',
    FEMALE: '女性',
    OTHER: 'その他',
    NONE: '性別を選択',
    USER_NAME_LABEL: '氏名',
    USER_NAME_PLACEHOLDER: '名前を入力',
    USER_EMAIL_PLACEHOLDER: 'email@example.com',
    USER_PHONE_PLACEHOLDER: '+81 90 0000 0000',
    STUDENT_CODE_LABEL: '学籍番号',
    STAFF_CODE_LABEL: '職員番号',
    CODE_LABEL: 'コード',
    PASSWORD_CHANGED_HINT: '初期パスワードを変更済み',
    PASSWORD_CHANGED_SHORT: 'PW変更済',
    PASSWORD_UNCHANGED_SHORT: 'PW未変更',
    GENDER: '性別',
    DOB: '生年月日',
    ADDRESS: '住所',
    USER_ADDRESS_PLACEHOLDER: '住所を入力',
    EDUCATION_BACKGROUND: '学歴',
    WORK_EXPERIENCE: '職歴',
    CAREER_PATH: '卒業後の進路',
    QUALIFICATIONS: '取得資格',
    GRADES_LABEL: '成績',
    HEALTH_RESULT: '健康診断結果',
    USER_DETAILS_TITLE: 'ユーザー詳細',
    USER_EDIT_TITLE: 'ユーザーを編集',
    USER_ADD_TITLE: 'ユーザーを追加',

    ADMIN_USERS_ADD_SINGLE: 'ユーザーを追加',
    ADMIN_USERS_ADD_CSV: 'CSVで一括追加',
    ADMIN_USERS_COL_NAME: '名前',
    ADMIN_USERS_COL_CODE: 'ユーザーコード',
    ADMIN_USERS_COL_ROLE: 'ロール',
    ADMIN_USERS_COL_STATUS: 'ステータス',
    ADMIN_USERS_COL_ENROLLMENT: '入学日',
    ADMIN_USERS_COL_DEPARTMENT: '所属学科',
    CSV_BULK_TITLE: 'ユーザーを一括追加',
    CSV_UPLOAD_HINT: 'CSVファイルをアップロードしてください。',
    CSV_UPLOAD_BUTTON: 'CSVを選択',
    CSV_DOWNLOAD_TEMPLATE: 'テンプレートをダウンロード',
    CSV_SELECTED_FILE: '選択したファイル',
    CSV_CHANGE_FILE: 'ファイルを変更',
    CSV_SAVE_ALL: '一括保存',
    CSV_INVALID_FORMAT: 'CSV形式が正しくありません。',
    CSV_NO_DATA: 'CSVにデータがありません。',
    CSV_READ_ERROR: 'CSVの読み込みに失敗しました。',
    CSV_USER_ID_PLACEHOLDER: 'ユーザーコードを入力',
    CSV_USER_NAME_PLACEHOLDER: 'ユーザー名を入力',
    CSV_ROLE_PLACEHOLDER: 'ロールを入力',
    CSV_STATUS_PLACEHOLDER: 'ステータスを入力',
    CSV_EMAIL_PLACEHOLDER: 'メールアドレスを入力',
    CSV_PHONE_PLACEHOLDER: '電話番号を入力',
    CSV_ENROLL_PLACEHOLDER: '入学日を入力',
    CSV_DEPT_PLACEHOLDER: '学科を入力',
    CSV_VALIDATION_HINT:'※ユーザーコードおよびメールアドレスは一意である必要があります。重複しないようにご注意ください。',
    SELECT_ALL: '全て選択',
    SORT_ASC: '昇順',
    SORT_DESC: '降順',
    PAGINATION_PREV: '前へ',
    PAGINATION_NEXT: '次へ',
    STUDENT: '生徒',
    TEACHER: '教師',
    ADMIN: '管理者',
    ACTIVE: '有効',
    INACTIVE: '無効',
    CLOSED: '終了',
    NAME: '名前',
    EMAIL: 'メール',
    PHONE: '電話番号',
    DATE: '日付',
    COURSE: '科目',
    COURSES: '科目数',
    TOTAL_COURSES: '総科目数',
    STUDENTS_LABEL: '生徒数',
    DEPARTMENT: '所属学科',
    USER_DEPARTMENT_PLACEHOLDER: '学科を選択',
    CREDITS: '単位',
    SEMESTER: '学期',
    SCHEDULE_LABEL: 'スケジュール',
    COURSE_CODE: '科目コード',
    COURSE_NAME: '科目名',
    COURSE_CREATED: '科目を作成しました',
    CREATE_COURSE: '科目を作成',
    CREATE_COURSE_DESC: '新しい科目の基本情報を入力してください',
    SEARCH_COURSE: '科目を検索...',
    SEARCH_USER: 'ユーザーを検索...',
    SEARCH_PLACEHOLDER: 'キーワードで検索...',
    DESCRIPTION: '詳細説明',
    TITLE: 'タイトル',
    START_TIME: '開始時間',
    END_TIME: '終了時間',
    TIME_SELECT_HOUR: '時',
    TIME_SELECT_MINUTE: '分',
    MAX_STUDENTS: '最大生徒数',
    UPLOAD_LIMIT: 'アップロード上限 (MB)',
    AVERAGE_ENROLLMENT: '平均登録率',
    ACTIVE_LABEL: 'アクティブ',
    ASSIGNMENT: '課題',
    QUIZ: 'クイズ',
    PROJECT: 'プロジェクト',
    STUDENT_ID: '生徒ID',
    EMPLOYEE_ID: '職員ID',
    LAST_LOGIN: '最終ログイン',
    REGISTRATION_DATE: '登録日',
    EMERGENCY_CONTACT: '緊急連絡先',
    EMERGENCY_PHONE: '緊急連絡先電話',
    PREVIOUS: '前へ',
    NEXT: '次へ',

    // Student Dashboard
    STUDENT_DASHBOARD_TITLE: '{0}さん、ようこそ',
    STUDENT_DASHBOARD_SUBTITLE: '今日の科目の最新情報です',
    QUICK_MATERIALS: '教材',
    QUICK_MATERIALS_DESC: 'PDFとノートを見る',
    QUICK_SCHEDULE: 'スケジュール',
    QUICK_SCHEDULE_DESC: 'カレンダーを見る',
    QUICK_TEST: 'テストを受ける',
    QUICK_TEST_DESC: 'クイズ/試験開始',
    QUICK_PROGRESS: 'マイ進捗',
    QUICK_PROGRESS_DESC: '統計を見る',

    // Course Schedule
    COURSE_SCHEDULE_TITLE: '科目スケジュール',
    COURSE_SCHEDULE_SUBTITLE: '授業、課題、試験を管理',
    BTN_TODAY: '今日',
    BTN_BACK: '戻る',
    VIEW_WEEK: '週',
    VIEW_MONTH: '月',
    VIEW_DAY: '日',
    EVENT_TYPES: 'イベント種類',
    EVENT_TYPE_ONLINE: 'オンライン授業',
    EVENT_TYPE_OFFLINE: '対面授業',
    EVENT_TYPE_ASSIGNMENT: '課題',
    EVENT_TYPE_EXAM: '試験',
    EVENT_TYPE_INTERNSHIP: '実習',
    SCHEDULE_EVENT_MATH: '高等数学 講義',
    SCHEDULE_EVENT_MATH_DESC: '微分方程式の応用について学習します',
    SCHEDULE_EVENT_WEB: 'Web開発 実習',
    SCHEDULE_EVENT_WEB_DESC: 'React Hooksを使った実践的な演習',
    SCHEDULE_EVENT_ASSIGNMENT: '課題提出期限：データ構造',
    SCHEDULE_EVENT_ASSIGNMENT_DESC: '二分探索木の実装課題',
    SCHEDULE_EVENT_EXAM: '中間試験：数学',
    SCHEDULE_EVENT_EXAM_DESC: '第1章から第5章までの範囲',
    SCHEDULE_EVENT_DATA: 'データ構造 講義',
    SCHEDULE_EVENT_DATA_DESC: 'グラフアルゴリズムの基礎',
    MONTH_YEAR: '{0}年{1}月',
    INSTRUCTOR: '教師',
    LOCATION: '場所',
    MATERIALS: '教材',
    ONLINE_LINK: '参加URL',

    // Online Test
    MIDTERM: '中間試験',
    TERM_LABEL: '2025年 秋学期',
    TEST_Q1: '微分方程式 dy/dx = ky の一般解は何ですか？',
    TEST_Q1_OPT1: 'y = Ce^(kx)',
    TEST_Q1_OPT2: 'y = Cx + k',
    TEST_Q1_OPT3: 'y = C/x',
    TEST_Q1_OPT4: 'y = kx^2 + C',
    TEST_Q2: '次のうち、二階線形微分方程式はどれですか？',
    TEST_Q2_OPT1: "y'' + 3y' + 2y = 0",
    TEST_Q2_OPT2: "y' + y^2 = x",
    TEST_Q2_OPT3: "(y')^2 + y = 0",
    TEST_Q2_OPT4: "dy/dx = x + y",
    TEST_Q3: '一階微分方程式を解くために使用できる方法をすべて選択してください：',
    TEST_Q3_OPT1: '変数分離法',
    TEST_Q3_OPT2: '積分因子法',
    TEST_Q3_OPT3: 'ラプラス変換',
    TEST_Q3_OPT4: 'ニュートン・ラフソン法',
    TEST_Q4: '同次微分方程式の解は常に原点を通る。',
    TEST_Q5: "微分方程式 y'' - 5y' + 6y = 0 の特性方程式は何ですか？",
    TEST_Q5_OPT1: 'r^2 - 5r + 6 = 0',
    TEST_Q5_OPT2: 'r^2 + 5r + 6 = 0',
    TEST_Q5_OPT3: 'r - 5 + 6 = 0',
    TEST_Q5_OPT4: 'r^2 - 5r - 6 = 0',
    TRUE_LABEL: '正しい',
    FALSE_LABEL: '誤り',
    TEST_PROGRESS: '進捗状況',
    ANSWERED_COUNT: '{0}/{1} 解答済み',
    QUESTION_SINGLE: '一つ選択してください',
    QUESTION_MULTI: '該当するものをすべて選択してください',
    QUESTION_TRUE_FALSE: '正しいか誤りを選択',
    FLAG: 'フラグ',
    FLAGGED: 'フラグ済み',
    QUESTION_OVERVIEW: '問題一覧',
    ANSWERED: '解答済み',
    READY_TO_SUBMIT: '送信準備',
    SUBMIT_HINT: '提出前に回答を確認してください',
    SUBMIT_TEST: '提出する',
    QUESTION: '問題',

    // PDF Viewer
    PDF_VIEWER_TITLE: '第5章：微分方程式',
    NOTES: 'ノート',
    OUTLINE: '目次',
    MY_NOTES: 'マイ注釈',
    PAGE_LABEL: 'ページ {0}',
    NOTE_ONE: '重要な定理 - 試験前に復習',
    NOTE_TWO: 'この例題を練習する',
    NOTE_THREE: 'オフィスアワーで教授に確認',
    PDF_SECTION_HEADER: '微分方程式の概要',
    PDF_PARAGRAPH_ONE: '微分方程式は未知関数とその導関数の関係を記述する方程式です。',
    PDF_PARAGRAPH_TWO: '解法には、変数分離法、積分因子法、ラプラス変換などが含まれます。',
    PDF_LIST_ONE: '一階微分方程式の基本形',
    PDF_LIST_TWO: '初期条件の扱い方',
    PDF_LIST_THREE: '実際の応用例',
    PAGE_OF: '{0} / {1} ページ',

    // Teacher Dashboard
    TEACHER_DASHBOARD_TITLE: '教師ダッシュボード',
    TEACHER_DASHBOARD_SUBTITLE: '科目、生徒、教材を管理',
    TOTAL_STUDENTS: '総生徒数',
    ACTIVE_COURSES: 'アクティブ科目',
    PENDING_GRADING: '採点待ち',
    AVERAGE_GRADE: '平均成績',
    QUICK_ACTIONS: 'クイックアクション',
    CREATE_EVENT: 'イベントを作成',
    UPLOAD_MATERIALS: '教材をアップロード',
    VIEW_SCHEDULE: 'スケジュールを確認',
    VIEW_ANALYTICS: '分析を表示',
    TAB_COURSES: 'マイ科目',
    TAB_GRADING: '採点待ち',
    TAB_STUDENTS: '生徒の進捗',
    TAB_MATERIALS: '教材',
    ACTIVE_ASSIGNMENTS: 'アクティブな課題',
    COURSE_LABEL: '科目',
    SUBMITTED_AT: '提出日時',
    REVIEW: 'レビュー',
    COMPLETED: '完了',
    CURRENT_GRADE: '現在の成績',
    UPLOAD_INSTRUCTIONS: 'PDF、DOCX、PPTX（最大50MB）',
    SELECT_FILE: 'ファイルを選択',
    RECENT_UPLOADS: '最近のアップロード',
    UPLOADED_TIME: '{0}にアップロード',
    RECENT_STUDENT_ACTIVITY: '最近の生徒アクティビティ',
    TEST_COMPLETE: 'クイズを完了しました',
    VIEWED_MATERIAL: '講義ノートを閲覧しました',

    // Teacher Event Registration
    EVENT_REGISTRATION_TITLE: 'イベント登録',
    EVENT_REGISTRATION_SUBTITLE: '新しい授業、課題、試験、または実習を作成',
    EVENT_CREATED: 'イベントが正常に登録されました',
    EVENT_CREATED_DESC: '生徒に通知が送信されました',
    SELECT_EVENT_TYPE: 'イベントタイプを選択',
    SELECT_EVENT_TYPE_DESC: '登録したいイベントの種類を選んでください',
    BASIC_INFORMATION: '基本情報',
    BASIC_INFORMATION_DESC: 'イベントの基本的な詳細を入力してください',
    TITLE_PLACEHOLDER: '例：高等数学 第10講',
    COURSE_PLACEHOLDER: '関連する科目を入力',
    DESCRIPTION_PLACEHOLDER: 'イベントの詳細、トピック、準備事項などを記入...',
    LOCATION_PLACEHOLDER: '場所を入力',
    ONLINE_LINK_PLACEHOLDER: '参加URLを入力',
    MAX_STUDENTS_PLACEHOLDER: '例: 50',
    NOTIFY_STUDENTS: '生徒に通知',
    ATTACH_FILES: 'ファイルを添付',
    SECURITY: 'セキュリティ',
    SECURITY_DESC: 'アカウント保護の設定',
    SEND_WELCOME_EMAIL: 'ウェルカムメールを送信',
    REQUIRE_PASSWORD_CHANGE: '初回ログインでパスワード変更を要求',
    CONFIRM_PASSWORD: 'パスワード確認',
    ADDITIONAL_INFO: '追加情報',

    // Admin Dashboard
    ADMIN_DASHBOARD_TITLE: '管理者ダッシュボード',
    ADMIN_DASHBOARD_SUBTITLE: 'システム管理と設定',
    STORAGE_USAGE: 'ストレージ使用量',
    SYSTEM_UPTIME: 'システム稼働率',
    ADMIN_QUICK_ACTIONS: 'クイックアクション',
    ADMIN_ACTION_REGISTER: 'ユーザー登録',
    ADMIN_ACTION_REGISTER_DESC: '新しいユーザーアカウントを作成',
    ADMIN_ACTION_USER: 'ユーザー管理',
    ADMIN_ACTION_USER_DESC: 'ユーザーの検索、編集、削除',
    ADMIN_ACTION_COURSE: '科目管理',
    ADMIN_ACTION_COURSE_DESC: '科目の作成と管理',
    TAB_USERS: 'ユーザー管理',
    TAB_SETTINGS: 'システム設定',
    TAB_ANALYTICS: '分析',
    ENABLE_STUDENT_REGISTRATION: '生徒登録を許可',
    ENABLE_STUDENT_REGISTRATION_DESC: '新規生徒の登録を許可',
    EMAIL_NOTIFICATIONS: 'メール通知',
    EMAIL_NOTIFICATIONS_DESC: 'ユーザーにメール通知を送信',
    MAINTENANCE_MODE: 'メンテナンスモード',
    MAINTENANCE_MODE_DESC: 'システムをメンテナンスモードにする',
    SECURITY_SETTINGS: 'セキュリティ設定',
    SECURITY_SETTINGS_DESC: 'プラットフォームの保護を強化',
    TWO_FACTOR: '二要素認証',
    SESSION_TIMEOUT: 'セッションタイムアウト',
    RESET_DEFAULTS: 'デフォルトにリセット',
    USER_GROWTH: 'ユーザー増加',
    USER_GROWTH_DESC: '新規登録数の推移',
    COURSE_ENROLLMENT: '科目登録',
    COURSE_ENROLLMENT_DESC: '生徒登録トレンド',
    SYSTEM_USAGE: 'システム使用状況',
    SYSTEM_USAGE_DESC: 'プラットフォーム活動指標',
    DAILY_ACTIVE: 'デイリーアクティブユーザー',
    AVG_SESSION: '平均セッション時間',
    CONTENT_VIEWS: 'コンテンツ閲覧数',
    TESTS_COMPLETED: 'テスト完了数',
    POPULAR_COURSES: '人気科目',
    MINUTES: '分',

    // Admin Course Management
    ADMIN_COURSE_MANAGEMENT_TITLE: '科目管理',
    ADMIN_COURSE_MANAGEMENT_SUBTITLE: 'プラットフォーム全体の科目を作成・管理',

    // Admin User Management
    ADMIN_USER_MANAGEMENT_TITLE: 'ユーザー管理',
    ADMIN_USER_MANAGEMENT_SUBTITLE: '生徒、教師、管理者アカウントの管理',
    USER_DETAIL: 'ユーザー詳細',

    // Admin User Registration
    ADMIN_USER_REGISTRATION: 'ユーザー登録',
    ADMIN_USER_REGISTRATION_SUBTITLE: '生徒、教師、または管理者アカウントを作成',
    USER_REGISTERED: 'ユーザーが登録されました',
    WELCOME_EMAIL_SENT: 'ウェルカムメールが送信されました',
    SELECT_USER_TYPE: 'ユーザータイプを選択',
    SELECT_USER_TYPE_DESC: '登録するユーザーの役割を選んでください',
    PROFILE_IMAGE: 'プロフィール画像',
    PROFILE_IMAGE_DESC: 'ユーザーのプロフィール写真をアップロード（オプション）',
    UPLOAD_IMAGE: '画像をアップロード',
    UPLOAD_HINT: 'JPG、PNG、最大2MB',
    FIRST_NAME: '名',
    LAST_NAME: '姓',
    DATE_OF_BIRTH: '生年月日',
    SPECIALIZATION: '専門分野',
    USER_CODE_EXISTS: 'ユーザーコードはすでに登録されています',
    USER_EMAIL_EXISTS: 'メールアドレスはすでに登録されています',
    USER_UPDATE_NOT_FOUND: "ユーザーの更新に失敗しました。\n対象ユーザーが見つかりません",
    USER_PASSWORD_REQUIRED: 'パスワードは必須項目です',

    USER_CODE_INVALID: 'コードには半角英数字（A～Z、0～9）のみ入力できます。',
    USER_EMAIL_INVALID: 'メールアドレスの形式が正しくありません',
    USER_PHONE_INVALID: '電話番号の形式が正しくありません',

    // Not Found
    NOT_FOUND_TITLE: 'ページが見つかりません',
    NOT_FOUND_MESSAGE: 'お探しのページは存在しないか、移動されました。',
    GO_HOME: 'ダッシュボードに戻る',

    // Fail message
    ERROR_TITLE: 'エラー',
    ERROR_MESSAGE: '処理中に予期しないエラーが発生しました。しばらくしてから再度お試しください。',

    // Admin Class
    CLASS_CODE_EXISTS: 'クラスコードはすでに登録されています',

    // Admin Major
    MAJOR_CODE_EXISTS: '学科コードはすでに登録されています',
    MAJOR_NOT_FOUND: '学科が見つかりません',

    // Admin Semester
    MES_ERR_CHECK_MONTH_START_END: '終了月は翌年の{0}となります',

    // Delete dialog
    DELETE_CONFIRM_TITLE: '削除確認',
    DELETE_CONFIRM_MESSAGE: 'この項目を削除します。\nよろしいですか？',

    DELETE_COMPLETE_TITLE: '削除完了',
    DELETE_COMPLETE_MESSAGE: '削除が完了しました。',
  },
  en: {
    // Common
    CONFIRM: 'Confirm',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    SAVE_ACTION: 'Save',
    EDIT_RECORD_LINK: 'Save',
    DOWNLOAD: 'Download',
    DELETE: 'Delete',
    EDIT: 'Edit',
    ADD: 'Add',
    ADD_NEW: 'Add New',
    SEARCH: 'Search',
    CLOSE: 'Close',
    LOGOUT: 'Logout',
    LOGOUT_CONFIRM_MESSAGE: 'Are you sure you want to log out?',
    USER_INFO_TITLE: 'User Information',
    USER_INFO_TAB_BASIC: 'Basic Info',
    USER_INFO_BASIC_UPDATE: 'Update Basic Information',
    USER_INFO_TAB_OTHER_INFO: 'Other Information',
    USER_INFO_OTHER_UPDATE: 'Update Other Information',
    USER_INFO_TAB_ACADEMIC_WORK_HISTORY: 'Academic & Work History',
    USER_INFO_TAB_HEALTH: 'Health Info',
    USER_INFO_TAB_ONLINE_URLS: 'Online Class URL Management',
    USER_INFO_FURIGANA_LABEL: 'Furigana',
    USER_INFO_NAME_LABEL: 'Name',
    USER_INFO_NAME_PLACEHOLDER: 'Taro Yamada',
    USER_INFO_FURIGANA_PLACEHOLDER: 'Yamada Taro',
    USER_INFO_EMAIL_PLACEHOLDER: 'kurokawa_susumu@example.com',
    USER_INFO_EMAIL_TOOLTIP: 'Email for logging into Mana-vi',
    USER_INFO_ENROLL_DATE_LABEL: 'Enrollment Date',
    USER_INFO_GENDER_PLACEHOLDER: 'Male',
    USER_INFO_DOB_PLACEHOLDER: '2020/8/10',
    USER_INFO_ADDRESS_PLACEHOLDER: '4 Kano Kuroki-cho, Gifu-shi, Gifu',
    USER_INFO_PHONE_PLACEHOLDER: '+61488850430',
    EDUCATION_BACKGROUND_PLACEHOLDER: 'Seiryo Elementary School',
    WORK_EXPERIENCE_PLACEHOLDER: 'Waseda University Faculty of Law',
    CAREER_PATH_PLACEHOLDER: 'Kyoto University Faculty of Economics',
    QUALIFICATIONS_PLACEHOLDER: 'Osaka University Faculty of Medicine',
    GRADES_PLACEHOLDER: 'Nagoya University Faculty of Engineering',
    HEALTH_RESULT_PLACEHOLDER: 'Nagoya University Faculty of Engineering',
    USER_INFO_GOOGLE_MEET_URL_LIST: 'Active Google Meet URL List',
    USER_INFO_URL_ISSUE: 'Issue URL',
    USER_INFO_URL_NAME: 'Name',
    USER_INFO_URL_CODE: 'Meeting code',
    USER_INFO_URL_COHOSTS: 'Co-hosts',
    USER_INFO_URL_CREATED_AT: 'Issue date',
    USER_INFO_URL_CREATED_AT_TOOLTIP: 'This is the creation date of the Google Meet link. The target date and time can also be confirmed as an event in Google Calendar.',
    USER_INFO_URL_OPERATION: 'Action',
    USER_INFO_URL_ISSUE_TITLE: 'Issue URL',
    USER_INFO_URL_ISSUE_TOOLTIP: 'Issuer of Google Meet URL for online classes',
    USER_INFO_URL_ISSUE_MESSAGE: 'A Google Meet join URL will be issued.\nSet an alias that makes the purpose easy to identify.',
    USER_INFO_URL_EDIT_TITLE: 'Edit Issue Link',
    USER_INFO_URL_EDIT_MESSAGE: 'Change the link alias and co-hosts.',
    USER_INFO_URL_EDIT_GUESTS: 'Edit',
    USER_INFO_URL_ALIAS_PLACEHOLDER: 'e.g. Online Class URL',
    CO_HOST_DROPDOWN_PLACEHOLDER: 'Select co-hosts from Mana-vi users',
    USER_INFO_URL_DELETE_TITLE: 'Confirm',
    USER_INFO_URL_DELETE_MESSAGE: 'This Google Meet join link will be disabled and deleted. Continue?',
    USER_INFO_URL_NO_DATA: 'No Google Meet URLs.',
    USER_INFO_ONLINE_URL_PLACEHOLDER: 'e.g. Online class URL',
    CO_HOST_EMAILS_LABEL: 'Add co-hosts',
    CO_HOST_EMAIL_PLACEHOLDER: 'cohost@example.com',
    CO_HOST_SELECT_BUTTON: 'Add co-host',
    CO_HOST_SELECT_TITLE: 'Select co-hosts',
    CO_HOST_SELECT_PLACEHOLDER: 'Search by name or email',
    INVALID_EMAIL_FORMAT: 'Invalid email format',
    EMAIL_ALREADY_ADDED: 'This email has already been added',
    GOOGLE_ACCOUNT_LABEL: 'Google Account',
    GOOGLE_ACCOUNT_LINK_BTN: 'Link Account',
    GOOGLE_ACCOUNT_LINKED_BADGE: 'Linked',
    GOOGLE_ACCOUNT_UNLINKED_BADGE: 'Not linked',
    GOOGLE_ACCOUNT_TAB_LABEL: 'Google account',
    GOOGLE_ACCOUNT_NOT_LINKED_DESC: 'No Google account is linked yet.',
    GOOGLE_STATUS_CHECKING: 'Checking...',
    GOOGLE_ACCOUNT_UNLINK: 'Unlink',
    GOOGLE_ACCOUNT_UNLINK_CONFIRM_TITLE: 'Confirm Google Account Unlink',
    GOOGLE_ACCOUNT_UNLINK_CONFIRM_MESSAGE: 'Unlinking will disable the issued Google Meet URLs. Are you sure?',
    GOOGLE_LINK_TOOLTIP: 'Linking your Google account automates attendance tracking for online classes via Google Meet, making it more convenient.',
    GOOGLE_LINK_UNLINKED_TEXT: 'Your Google account is not <b>linked</b> yet.',
    GOOGLE_LINK_LINKED_TEXT: 'Your Google account is <b>linked</b>.',
    GOOGLE_LINK_TEACHER_UNLINK_CONFIRM: 'Unlinking will delete all Meet URLs and co-host settings associated with this Google account.',
    GOOGLE_LINK_STUDENT_UNLINK_CONFIRM: 'Unlinking means you will need to manually enter your student ID and email when joining Google Meet.\nAre you sure you want to unlink your Google account?',
    CHANGE_PASSWORD_BUTTON: 'Change Password',
    CHANGE_PASSWORD_TITLE: 'Change Password',
    CHANGE_PASSWORD_CURRENT_LABEL: 'Current password',
    CHANGE_PASSWORD_CURRENT_PLACEHOLDER: 'Enter current password',
    CHANGE_PASSWORD_NEW_LABEL: 'New password',
    CHANGE_PASSWORD_NEW_PLACEHOLDER: 'Enter new password',
    CHANGE_PASSWORD_CONFIRM_LABEL: 'Confirm new password',
    CHANGE_PASSWORD_CONFIRM_PLACEHOLDER: 'Enter new password again',
    CHANGE_PASSWORD_HINT: 'Please enter at least 8 characters.',
    CHANGE_PASSWORD_LENGTH_ERROR: 'Please enter at least 8 characters.',
    CHANGE_PASSWORD_MISMATCH_ERROR: 'New password and confirm password do not match.',
    CHANGE_PASSWORD_ACTION: 'Change',
    USER_PREFERENCES: 'Preferences',
    SETTINGS: 'Settings',
    PROFILE_SETTINGS_TITLE: 'Profile settings',
    EDIT_AVATAR: 'Change profile image',
    USER_INFO_ROLE_STUDENT_BADGE: 'Student',
    THEME_LABEL: 'Theme',
    LANGUAGE_LABEL: 'Language',
    SEMESTER_TYPE_LABEL: 'Semester Type',
    REGULAR: 'Regular',
    FLEXIBLE: 'Short / Flexible',
    LOGIN: 'Login',
    NO_DATA: 'No data available',
    NOT_SET: 'Not set',
    USER_INFO_UNSET: 'Unset',
    ITEM_SELECTED: '{0} items selected',
    TABLE_RANGE_TEXT: 'Showing {0}-{1} (Total {2})',
    LOADING: 'Loading...',
    CONFIRM_DISCARD_TITLE: 'Discard changes?',
    CONFIRM_DISCARD_MESSAGE: 'You have unsaved changes.\nDo you want to discard them?',
    CONFIRM_SAVE_TITLE: 'Save changes?',
    CONFIRM_SAVE_MESSAGE: 'Do you want to save these changes?',
    RESET_PASSWORD_TITLE: 'Reset password?',
    RESET_PASSWORD_MESSAGE: 'A new password will be generated for this user.\nContinue?',
    RESET_PASSWORD_BUTTON: 'Reset Password',
    RESET_PASSWORD_ACTION: 'Reset',
    SAVE_COMPLETE_TITLE: 'Save completed',
    SAVE_COMPLETE_MESSAGE: 'Changes have been saved.',
    OK: 'OK',
    AVATAR_CHANGE_TITLE: 'Change avatar',
    SELECT_IMAGE: 'Select image',
    FILE_EXIST: "File is exist, do you want save?",
    COMMON_SHOW_MORE: 'More',
    COMMON_SHOW_LESS: 'Less',
    COPY_TO_CLIPBOARD: 'Copy to clipboard',
    COPIED_TO_CLIPBOARD: 'Copied',
    
    // App
    APP_NAME: 'Mana-Vi',

    // Login
    LOGIN_TITLE: 'Mana-Vi',
    LOGIN_SUBTITLE: 'Login to system',
    EMAIL_LABEL: 'Email',
    EMAIL_PLACEHOLDER: 'Enter email',
    EMAIL_REQUIRED: 'Please enter email',
    PASSWORD_LABEL: 'Password',
    PASSWORD_PLACEHOLDER: 'Enter password',
    PASSWORD_REQUIRED: 'Please enter password',
    LOGIN_BUTTON: 'Login',
    LOGIN_ERROR: 'Email or password is incorrect',

    CHANGE_PASSWORD_SUCCESS: 'Password changed successfully.',
    CHANGE_PASSWORD_FAIL: 'Failed to change password.',
    RESET_PASSWORD_SUCCESS: 'Password reset successfully.',
    RESET_PASSWORD_FAIL: 'Failed to reset password.',
    
    // Dashboard
    DASHBOARD_TITLE: 'Dashboard',
    DASHBOARD_WELCOME: 'Welcome to Mana-Vi!',
    DASHBOARD_WELCOME_USER: 'Welcome, {0}',
    DASHBOARD_TODAY_LECTURES: "Today's Lectures",
    DASHBOARD_MONTHLY_SCHEDULE: 'Monthly Schedule',
    DASHBOARD_MONTHLY_PLACEHOLDER: 'Monthly calendar placeholder',
    DASHBOARD_EVENTS: 'Events',
    DASHBOARD_VIEW_MORE: 'View more',
    DASHBOARD_ATTENDANCE_REQUESTS: "Today's Attendance Requests",
    DASHBOARD_ASSIGNED_CLASSES: 'Assigned Classes',
    DASHBOARD_TIMETABLE: 'Timetable',
    DASHBOARD_CURRENT_COURSES: 'Current Courses',
    DASHBOARD_TAG_EVENT: 'Event',
    DASHBOARD_TAG_TEST: 'Test',
    DASHBOARD_TAG_DEADLINE: 'Deadline',
    DASHBOARD_TAG_PRACTICE: 'Practice',
    ATTENDANCE_COL_STUDENT: 'Student',
    ATTENDANCE_COL_CLASS: 'Class',
    ATTENDANCE_COL_TYPE: 'Type',
    ATTENDANCE_COL_DATE: 'Date',
    ATTENDANCE_COL_REASON: 'Reason',
    ATTENDANCE_TYPE_ABSENT: 'Absent',
    ATTENDANCE_TYPE_LEAVE: 'Leave',
    TOTAL_BOOKS: 'Total Books',
    TOTAL_USERS: 'Users',
    TOTAL_LESSONS: 'Lessons',
    
    // Dashboard Cards
    SCHEDULE: 'Schedule',
    SCHEDULE_DESC: 'View Calendar',
    TAKE_TEST: 'Take Test',
    TAKE_TEST_DESC: 'Start Quiz/Exam',
    MY_PROGRESS: 'My Progress',
    MY_PROGRESS_DESC: 'View Statistics',
    
    // Dashboard Sections
    MY_COURSES: 'My Courses',
    MY_COURSES_DESC: 'Track progress of all enrolled courses',
    UPCOMING_TESTS: 'Upcoming Tests',
    RECENT_ACTIVITY: 'Recent Activity',
    
    // Course Info
    NEXT_CLASS: 'Next Class',
    PROGRESS: 'Progress',
    CONTINUE: 'Continue',
    START_TEST: 'Start Test',
    
    // Days
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
    
    // Courses
    ADVANCED_MATH: 'Advanced Mathematics',
    WEB_DEVELOPMENT: 'Web Development',
    DATA_STRUCTURES: 'Data Structures',
    CALCULUS: 'Calculus',
    LINEAR_ALGEBRA: 'Linear Algebra',
    PHYSICS_101: 'Physics 101',
    CHEMISTRY_101: 'Chemistry 101',
    BIOLOGY_101: 'Biology 101',
    COURSE_CODE_EXISTS: 'Course code already exists',
    COURSE_NOT_FOUND: 'Course not found',
    COURSE_ID_REQUIRED: 'Course ID is required',
    
    // Activity
    SUBMITTED_ASSIGNMENT: 'Submitted assignment',
    NEW_MATERIAL_UPLOADED: 'New material uploaded',
    GRADE_POSTED: 'Grade posted',
    HOURS_AGO_2: '2 hours ago',
    HOURS_AGO_5: '5 hours ago',
    DAY_AGO_1: '1 day ago',
    
    // Date Format
    DATE_FORMAT: '{1} {2}, {0}',
    
    // Menu
    MENU_HOME: 'Home',
    MENU_DASHBOARD: 'Dashboard',
    MENU_STUDENT_DASHBOARD: 'Student Dashboard',
    MENU_COURSE_SCHEDULE: 'Course Schedule',
    MENU_ONLINE_TEST: 'Online Test',
    MENU_PDF_VIEWER: 'PDF Viewer',
    MENU_TEACHER_DASHBOARD: 'Teacher Dashboard',
    MENU_TEACHER_EVENT: 'Event Registration',
    MENU_TIMETABLE: 'Timetable',
    MENU_CALENDAR: 'Calendar',
    MENU_ADMIN_DASHBOARD: 'Admin Dashboard',
    MENU_ADMIN_COURSE: 'Course',
    MENU_ADMIN_USER: 'User',
    MENU_ADMIN_USER_REGISTRATION: 'User Registration',
    MENU_ADMIN_USERS: 'Users',
    MENU_ADMIN_MAJORS: 'Majors',
    MENU_ADMIN_COURSES: 'Courses',
    MENU_ADMIN_CLASSES: 'Classes',
    MENU_ADMIN_SEMESTERS: 'Semesters',
    MENU_SECTION_SYSTEM: 'System',
    MENU_SECTION_ACADEMIC: 'Academic',
    MENU_SECTION_OPERATION: 'Operation',
    MENU_ADMIN_ASSETS: 'Equipment Assets',
    MENU_ADMIN_PERIODS: 'Class Period',
    MENU_ADMIN_TIMETABLE: 'Timetable',

    // Helper
    HELPER_INTERNAL_UI_HELPER: 'Internal UI Helper',
    HELPER_TITLE: 'UI Helper / Component Playground',
    HELPER_LEAD: 'Visual QA surface for checking shared UI primitives, icon states, and design-system behavior in one place.',
    HELPER_CURRENT_PRIMITIVES: 'Current primitives',
    HELPER_PRIMITIVE_BUTTON: 'Button',
    HELPER_PRIMITIVE_TABS: 'Tabs',
    HELPER_PRIMITIVE_ICON_BUTTON: 'Icon Button',
    HELPER_PRIMITIVE_ICON_TOGGLE_BUTTON: 'Icon Toggle Button',
    HELPER_PRIMITIVE_SWITCH: 'Switch',
    HELPER_PRIMITIVE_LABEL: 'Label',
    HELPER_PRIMITIVE_BADGE: 'Badge',
    HELPER_PRIMITIVE_INPUT: 'Input',
    HELPER_PRIMITIVE_DROPDOWN: 'Dropdown',
    HELPER_PRIMITIVE_ICON_HELPER: 'Icon Helper',
    HELPER_PRIMITIVE_AVATAR: 'Avatar',
    HELPER_PRIMITIVE_DATE_PICKER: 'Date Picker',
    HELPER_PRIMITIVE_PAGINATION: 'Pagination',
    HELPER_PRIMITIVE_TOOLTIP: 'Tooltip',
    HELPER_PRIMITIVE_CHECKBOX: 'Checkbox',
    HELPER_PRIMITIVE_RADIO_BUTTON: 'Radio button',
    HELPER_PRIMITIVE_MENU_ITEM: 'Menu Item',
    HELPER_SECTION_PRIMITIVE: 'Primitive',
    HELPER_SECTION_HELPER: 'Helper',
    HELPER_SECTIONS: 'Sections',
    HELPER_NAV_OVERVIEW: 'Overview',
    HELPER_NAV_TABS: 'Tabs',
    HELPER_NAV_BUTTONS: 'Buttons',
    HELPER_NAV_BUTTON_GROUPS: 'Button Groups',
    HELPER_NAV_ICON_BUTTONS: 'Icon Buttons',
    HELPER_NAV_ICON_TOGGLE_BUTTONS: 'Icon Toggle Buttons',
    HELPER_ICON_TOGGLE_BUTTONS_TITLE: 'Icon Toggle Buttons',
    HELPER_ICON_TOGGLE_BUTTONS_DESC: 'Buttons to toggle states, primarily used for changing theme and language.',
    HELPER_TOGGLE_THEME: 'Toggle Theme',
    HELPER_TOGGLE_LANGUAGE: 'Toggle Language',
    HELPER_TOGGLE_DISABLED: 'Disabled',
    HELPER_NAV_SWITCHES: 'Switches',
    HELPER_NAV_LABELS: 'Labels',
    HELPER_NAV_BADGES: 'Badges',
    HELPER_NAV_ICONS: 'Icons',
    HELPER_NAV_AVATARS: 'Avatars',
    HELPER_NAV_AVATAR_GROUP: 'Avatar Group',
    HELPER_NAV_TAG: 'Tag',
    HELPER_DIALOG_TITLE: 'Dialog',
    HELPER_TAG_TITLE: 'Tag',
    HELPER_INPUTS_TITLE: 'Inputs',
    HELPER_DATE_PICKER_TITLE: 'Date Picker',
    HELPER_CALENDAR_CELL_TITLE: 'Calendar Cell',
    HELPER_CHECKBOX_TITLE: 'Checkbox',
    HELPER_MENU_ITEM_TITLE: 'Menu Item',
    HELPER_MENU_ITEM_COLLAPSE_TITLE: 'Menu Item (Collapsed)',
    HELPER_NAV_INPUTS: 'Inputs',
    HELPER_NAV_DROPDOWN: 'Dropdown',
    HELPER_NAV_LINKS: 'Links',
    HELPER_NAV_DATE_PICKER: 'Date Picker',
    HELPER_NAV_CALENDAR_CELL: 'Calendar Cell',
    HELPER_NAV_PAGINATION: 'Pagination',
    HELPER_NAV_PAGINATION_CELL: 'Pagination Cell',
    HELPER_NAV_TOOLTIP: 'Tooltip',
    HELPER_NAV_CHECKBOX: 'Checkbox',
    HELPER_NAV_RADIO: 'Radio',
    HELPER_NAV_DIALOG: 'Dialog',
    HELPER_NAV_SIDEBAR: 'Sidebar',
    HELPER_NAV_SELECT: 'Select',
    HELPER_NAV_DATA_TABLE: 'Data Table',
    HELPER_NAV_TABLE: 'Table',
    HELPER_NAV_TABLE_HEADER_CELL: 'Table Header Cell',
    HELPER_NAV_TABLE_CELL: 'Table Cell',
    HELPER_DIALOG_ANCHORED_TITLE: 'Anchored dialog (popover mode)',
    HELPER_DIALOG_ANCHORED_DESC: 'Dialog appears next to the trigger element instead of screen center. Backdrop is transparent — clicking outside closes it.',
    HELPER_DIALOG_ANCHORED_TRIGGER: 'Open anchored',
    HELPER_DIALOG_ANCHORED_BODY: 'This dialog appears to the right of the trigger button. The backdrop is transparent, so clicking outside closes it.',
    HELPER_DIALOG_ANCHORED_CONFIRM: 'Got it',
    HELPER_TABLE_TITLE: 'Table',
    HELPER_TABLE_DESC: 'The table displays structured data with sorting, filtering, pagination, editing, actions, and row selection.',
    HELPER_TABLE_ROW_DIVIDERS: 'Table with row dividers',
    HELPER_TABLE_ALTERNATING_ROWS: 'Table with alternating rows',
    HELPER_TABLE_SORT_FILTER: 'Sorting and filtering',
    HELPER_TABLE_PAGINATION: 'Pagination',
    HELPER_TABLE_EDITABLE: 'Editable cells',
    HELPER_TABLE_STICKY: 'Sticky columns / horizontal scroll',
    HELPER_TABLE_EMPTY: 'Empty state',
    HELPER_TABLE_MULTI_SELECTION: 'Multiple selection',
    HELPER_TABLE_SELECT_ALL: 'Select all',
    HELPER_TABLE_PARTIAL_SELECTION: 'Partial selection',
    HELPER_TABLE_NON_SELECTABLE: 'Non-selectable row',
    HELPER_TABLE_SELECTED_COUNT: 'Selected rows',
    HELPER_TABLE_CLEAR_SELECTION: 'Clear selection',
    HELPER_TABLE_SELECTED_ACTION: 'Selected-row action background',
    HELPER_TABLE_ALTERNATE: 'Alternate row background',
    HELPER_TABLE_NEUTRAL: 'Neutral row background',
    HELPER_TABLE_HEADER_TITLE: 'Table Header Cell',
    HELPER_TABLE_HEADER_DESC: 'A 48px header cell with 8px padding, body/md bold type, optional action, and bottom outline.',
    HELPER_TABLE_HEADER_DEFAULT: 'Default, no divider',
    HELPER_TABLE_HEADER_BOTTOM_OUTLINE: 'Bottom outline',
    HELPER_TABLE_HEADER_ACTION: 'Action background',
    HELPER_TABLE_HEADER_ALTERNATE: 'Alternate background',
    HELPER_TABLE_HEADER_NEUTRAL: 'Neutral background',
    HELPER_TABLE_HEADER_CHECKBOX: 'Selection checkbox',
    HELPER_TABLE_HEADER_SORTABLE: 'Sortable label',
    HELPER_TABLE_HEADER_FILTERABLE: 'Filterable label',
    HELPER_TABLE_HEADER_ACTIVE: 'Selected sort / filter state',
    HELPER_TABLE_CELL_TITLE: 'Table Cell',
    HELPER_TABLE_CELL_DESC: 'A 60px minimum-height cell with 8px horizontal padding, 4px vertical padding, and shared UI content.',
    HELPER_TABLE_CELL_TEXT: 'Text',
    HELPER_TABLE_CELL_TEXT_SUBTEXT: 'Text with subtext',
    HELPER_TABLE_CELL_AVATAR: 'Avatar',
    HELPER_TABLE_CELL_ACTION_BUTTON: 'Action button',
    HELPER_TABLE_CELL_ICON: 'Icon only',
    HELPER_TABLE_CELL_MULTI_ICONS: 'Multiple icons',
    HELPER_TABLE_CELL_BADGE: 'Badge / pill',
    HELPER_TABLE_CELL_ICON_BADGE: 'Icon badge',
    HELPER_TABLE_CELL_CHECKBOX: 'Checkbox only',
    HELPER_TABLE_CELL_RADIO: 'Radio only',
    HELPER_TABLE_CELL_SWITCH: 'Switch only',
    HELPER_TABLE_CELL_INPUT: 'Compact input',
    HELPER_TABLE_CELL_PROGRESS: 'Progress ring',
    HELPER_TABLE_CELL_DEFAULT: 'Default background',
    HELPER_TABLE_CELL_ACTION: 'Action background',
    HELPER_TABLE_CELL_ALTERNATE: 'Alternate background',
    HELPER_TABLE_CELL_NEUTRAL: 'Neutral background',
    TABLE_SELECT_ROW: 'Select {0}',
    HELPER_NAV_RADIO_BUTTONS: 'Radio button',
    HELPER_TABS_TITLE: 'Tabs',
    HELPER_TABS_DESC: 'Shared tabs primitive covering states, icons, loading, actions, width modes, and custom accent colors.',
    HELPER_TABS_STATE_DEMO: 'States and actions',
    HELPER_TABS_CONFIG_DEMO: 'Layout configuration',
    HELPER_TABS_LAST_ACTION: 'Last action',
    HELPER_LINK_TITLE: 'Link',
    HELPER_LINK_DESC: 'The Link component enables navigation to web pages or specific sections within a page.',
    HELPER_LINK_MAIN_COMPONENT: 'Main component',
    HELPER_LINK_QUICK_TOGGLE: 'Quick toggle',
    HELPER_LINK_TYPE: 'Type',
    HELPER_LINK_STATE: 'State',
    HELPER_LINK_USAGE: 'Usage',
    HELPER_LINK_BASE: 'Base',
    HELPER_LINK_SHOW_LEFT_ICON: 'Show left icon',
    HELPER_LINK_SHOW_RIGHT_ICON: 'Show right icon',
    HELPER_LINK_DEFAULT: 'Default',
    HELPER_LINK_INLINE: 'In-line',
    HELPER_LINK_HOVER: 'Hover',
    HELPER_LINK_FOCUSED: 'Focused',
    HELPER_LINK_DISABLED: 'Disabled',
    HELPER_LINK_INTERNAL_ROUTE: 'Internal route',
    HELPER_LINK_EXTERNAL: 'External link',
    HELPER_LINK_INLINE_PARAGRAPH: 'Inline paragraph',
    HELPER_PAGINATION_TITLE: 'Pagination',
    HELPER_PAGINATION_DESC: 'Figma-aligned shared pagination for navigating long lists and multi-page content.',
    HELPER_PAGINATION_MAIN_COMPONENT: 'Main component',
    HELPER_PAGINATION_LAYOUT: 'Layout',
    HELPER_PAGINATION_STATE: 'States and examples',
    HELPER_PAGINATION_CELL_TITLE: 'Pagination Cell',
    HELPER_PAGINATION_CELL_DESC: 'Internal pagination cell for page numbers, selection, and ellipsis items.',
    HELPER_PAGINATION_CELL_STATE: 'Cell states',
    HELPER_PAGINATION_DEFAULT: 'Default',
    HELPER_PAGINATION_HOVER: 'Hover',
    HELPER_PAGINATION_FOCUSED: 'Focused',
    HELPER_PAGINATION_SELECTED: 'Selected',
    HELPER_PAGINATION_DISABLED: 'Disabled',
    HELPER_PAGINATION_USAGE: 'Usage in other components',
    HELPER_PAGINATION_FIRST_PAGE: 'First page',
    HELPER_PAGINATION_MIDDLE_PAGE: 'Middle page',
    HELPER_PAGINATION_LAST_PAGE: 'Last page',
    HELPER_PAGINATION_NO_FIRST_LAST: 'No first/last controls',
    HELPER_PAGINATION_SMALL_PAGE_COUNT: 'Small page count',
    HELPER_NAV_MENU_ITEM: 'Menu Item',
    HELPER_NAV_MENU_ITEM_COLLAPSE: 'Menu Item (Collapsed)',
    HELPER_NAV_TOAST: 'Toast',
    HELPER_TOAST_TITLE: 'Toast',
    HELPER_TOAST_DESC: 'A notification component that supports 6 positions and background processes.',
    HELPER_TOAST_DEMO_SYNC: 'Trigger Background Sync',
    HELPER_TOAST_SYNC_DESC: 'This demo restores only the visual toast state from localStorage. In production, the backend must provide a jobId and status endpoint so the frontend can reconcile the real process state after refresh or login.',
    HELPER_TOAST_SYNC_TRIGGER: 'Trigger Background Sync (Indefinite)',
    HELPER_TOAST_SYNC_FINISH: 'Finish Background Sync (Simulate API Event)',
    TOAST_SYNC_RUNNING: 'Syncing data...',
    TOAST_SYNC_SUCCESS: 'Data sync completed successfully.',
    HELPER_RADIO_TITLE: 'Radio button',
    HELPER_RADIO_DESC: 'Figma-aligned shared radio primitive with states, labels, hints, and Angular forms support.',
    HELPER_RADIO_MAIN_COMPONENT: 'Main component matrix',
    HELPER_RADIO_SELECTED: 'Selected',
    HELPER_RADIO_STATE: 'State',
    HELPER_RADIO_LABEL_USAGE: 'Label usage',
    HELPER_RADIO_GROUP_USAGE: 'Radio group usage',
    HELPER_RADIO_USAGE_IN_OTHER_COMPONENTS: 'Usage in other components',
    HELPER_RADIO_DEFAULT: 'Default',
    HELPER_RADIO_HOVER: 'Hover',
    HELPER_RADIO_FOCUSED: 'Focused',
    HELPER_RADIO_DISABLED: 'Disabled',
    HELPER_RADIO_SELECTED_YES: 'Yes / selected',
    HELPER_RADIO_SELECTED_NO: 'No / unselected',
    HELPER_RADIO_LABEL: 'Radio with label',
    HELPER_RADIO_HINT: 'Additional guidance can be shown here.',
    HELPER_RADIO_DISABLED_LABEL: 'Disabled radio',
    HELPER_RADIO_READONLY_LABEL: 'Readonly radio',
    HELPER_RADIO_OPTION_COMMON: 'Common',
    HELPER_RADIO_OPTION_SPECIALIZED: 'Specialized',
    HELPER_RADIO_OPTION_OTHER: 'Other',
    HELPER_RADIO_DROPDOWN_MENU_ITEM: 'Menu item',
    HELPER_RADIO_DROPDOWN_META: 'Recommended',
    HELPER_BUTTONS_TITLE: 'Buttons',
    HELPER_BUTTONS_DESC: 'Button directive variants, sizes, disabled state, loading state, and icon composition.',
    HELPER_BUTTON_GROUPS_TITLE: 'Button Groups',
    HELPER_BUTTON_GROUPS_DESC: 'Segmented single-selection buttons and navigation groups with previous/next controls.',
    HELPER_BUTTON_GROUPS_SEGMENTED: 'Single selection',
    HELPER_BUTTON_GROUPS_NAVIGATION: 'Previous / next navigation',
    HELPER_ICON_BUTTONS_TITLE: 'Icon Buttons',
    HELPER_ICON_BUTTONS_DESC: 'Icon-only buttons using appIconButton with variants, tones, sizes, disabled state, and selected state.',
    HELPER_SWITCHES_TITLE: 'Switches',
    HELPER_SWITCHES_DESC: 'Switch component states, labels, disabled behavior, and supported sizes using the app-switch selector.',
    HELPER_LABEL_TITLE: 'Labels',
    HELPER_LABEL_DESC: 'Figma-aligned shared label primitive for form controls with required markers, information icons, and disabled states.',
    HELPER_LABEL_MAIN_COMPONENT: 'Main component',
    HELPER_LABEL_QUICK_TOGGLE: 'Quick toggle',
    HELPER_LABEL_STATE: 'State',
    HELPER_LABEL_ICON_POSITION: 'Icon position',
    HELPER_LABEL_REQUIRED_MARKER: 'Required marker',
    HELPER_LABEL_USAGE: 'Usage examples',
    HELPER_LABEL_BASE: 'Base',
    HELPER_LABEL_REQUIRED: 'Required',
    HELPER_LABEL_INFORMATION: 'Information',
    HELPER_LABEL_DEFAULT: 'Default',
    HELPER_LABEL_DISABLED: 'Disabled',
    HELPER_LABEL_ICON_RIGHT: 'Icon right',
    HELPER_LABEL_ICON_LEFT: 'Icon left',
    HELPER_LABEL_NO_ICON: 'No icon',
    HELPER_LABEL_SHOW_REQUIRED: 'showRequired: true',
    HELPER_LABEL_HIDE_REQUIRED: 'showRequired: false',
    HELPER_LABEL_SAMPLE_TEXT: 'Label',
    HELPER_LABEL_INFO_TEXT: 'Helpful information about how to complete this field.',
    HELPER_LABEL_COURSE_NAME: 'Course Name',
    HELPER_LABEL_COURSE_PLACEHOLDER: 'Enter course name',
    HELPER_LABEL_SELECT_COURSE: 'Select course',
    HELPER_LABEL_USAGE_INPUT: 'Label above app-input',
    HELPER_LABEL_USAGE_DROPDOWN: 'Label above app-dropdown',
    HELPER_LABEL_USAGE_INFO: 'Label with info text',
    HELPER_BADGE_TITLE: 'Badge',
    HELPER_BADGE_DESC: 'Badge displays compact status, category, or metadata information.',
    HELPER_BADGE_MAIN_COMPONENT: 'Main component',
    HELPER_BADGE_ICON_PLACEMENT: 'Icon placement',
    HELPER_BADGE_VARIANT: 'Variant',
    HELPER_BADGE_SIZE: 'Size',
    HELPER_BADGE_DYNAMIC_COLORS: 'Dynamic colors',
    HELPER_BADGE_USAGE: 'Usage',
    HELPER_BADGE_OUTLINE: 'Outline',
    HELPER_BADGE_FILLED: 'Filled',
    HELPER_BADGE_SMALL: 'Small',
    HELPER_BADGE_MEDIUM: 'Medium',
    HELPER_BADGE_LARGE: 'Large',
    HELPER_BADGE_LEFT_ICON: 'Left icon',
    HELPER_BADGE_RIGHT_ICON: 'Right icon',
    HELPER_BADGE_BOTH_ICONS: 'Both icons',
    HELPER_BADGE_NO_ICON: 'No icon',
    HELPER_BADGE_DISABLED: 'Disabled',
    HELPER_BADGE_STATUS: 'Status',
    HELPER_BADGE_COURSE_COLOR: 'Course color',
    HELPER_BADGE_LONG_TEXT: 'Long text',
    HELPER_BADGE_SAMPLE_LABEL: 'Label',
    HELPER_BADGE_ACTION_ORANGE: 'Action orange',
    HELPER_BADGE_SUCCESS_GREEN: 'Success green',
    HELPER_BADGE_INFORMATION_BLUE: 'Information blue',
    HELPER_BADGE_DANGER_RED: 'Danger red',
    HELPER_BADGE_CUSTOM_PURPLE: 'Custom purple',
    HELPER_BADGE_NORMAL_LABEL: 'Normal label',
    HELPER_BADGE_TRUNCATED_LABEL: 'Truncated label',
    HELPER_BADGE_LONG_TEXT_SAMPLE: 'This is a long example label displayed inside a badge',
    HELPER_BADGE_ACTIVE: 'Active',
    HELPER_BADGE_COURSE_VALUE: 'Japanese',
    HELPER_BADGE_REMOVABLE: 'Removable-looking',
    HELPER_BADGE_METADATA: 'Metadata',
    HELPER_DROPDOWN_TITLE: 'Dropdown',
    HELPER_DROPDOWN_DESC: 'Unified single and multi select primitive with search, selection controls, avatars, color dots, and rich option content.',
    HELPER_DROPDOWN_EXAMPLES: 'Dropdown examples',
    HELPER_DROPDOWN_COURSES: 'courses',
    HELPER_DROPDOWN_USERS: 'users',
    HELPER_DROPDOWN_TAGS: 'tags',
    HELPER_DROPDOWN_TEACHERS: 'teachers',
    HELPER_DROPDOWN_BASIC_SINGLE: 'Basic single',
    HELPER_DROPDOWN_SINGLE_SEARCH: 'Single with search',
    HELPER_DROPDOWN_MULTI_CHECKBOX: 'Multi with checkbox',
    HELPER_DROPDOWN_SINGLE_RADIO: 'Single with radio',
    HELPER_DROPDOWN_AVATAR: 'Avatar',
    HELPER_DROPDOWN_MULTI_AVATAR: 'Multi user with avatar',
    HELPER_DROPDOWN_DOT_COLOR: 'Dot / color',
    HELPER_DROPDOWN_DISABLED: 'Disabled',
    HELPER_DROPDOWN_ERROR: 'Error',
    HELPER_DROPDOWN_EMPTY_STATE: 'Empty state',
    HELPER_DROPDOWN_MAX_BADGES: 'Max badges overflow',
    HELPER_DROPDOWN_OPTION_SUBLABEL: 'Option with sublabel',
    HELPER_DROPDOWN_OPTION_ICON: 'Option with icon',
    HELPER_DROPDOWN_SELECT_COURSE: 'Select course',
    HELPER_DROPDOWN_SEARCH_COURSE: 'Search course',
    HELPER_DROPDOWN_SELECT_TEACHERS: 'Select teachers',
    HELPER_DROPDOWN_SELECT_COURSE_TYPE: 'Select course type',
    HELPER_DROPDOWN_SELECT_USER: 'Select user',
    HELPER_DROPDOWN_SELECT_USERS: 'Select users',
    HELPER_DROPDOWN_SEARCH_USER: 'Search user',
    HELPER_DROPDOWN_COURSE_REQUIRED: 'Course is required',
    HELPER_DROPDOWN_NO_AVAILABLE_COURSES: 'No available courses',
    HELPER_DROPDOWN_NO_COURSES_FOUND: 'No courses found',
    HELPER_DROPDOWN_SELECTED: 'Selected',
    HELPER_DROPDOWN_NONE: 'None',
    HELPER_ICONS_TITLE: 'Icons',
    HELPER_ICONS_DESC: 'Registered icons rendered from IconHelperService with selected states when available.',
    HELPER_AVATARS_TITLE: 'Avatars',
    HELPER_AVATARS_DESC: 'Image, initial fallback, details, and reversed-order examples using the app-avatar selector.',
    HELPER_AVATAR_IMAGE_SIZES: 'Image Sizes',
    HELPER_AVATAR_INITIALS: 'Initial Fallback',
    HELPER_AVATAR_LABEL_PLACEMENT: 'Label Placement',
    HELPER_AVATAR_DETAILS: 'Details',
    HELPER_AVATAR_GROUP_TITLE: 'Avatar Group',
    HELPER_AVATAR_GROUP_DESC: 'Displays a stack of avatars with a counter for the remaining users.',
    HELPER_AVATAR_GROUP_COUNTS: 'Various User Counts',
    HELPER_AVATAR_GROUP_SIZES: 'Various Sizes',
    HELPER_AVATAR_GROUP_1_USER: '1 User',
    HELPER_AVATAR_GROUP_5_USERS: 'Exactly 5 Users',
    HELPER_AVATAR_GROUP_MORE_USERS: '> 5 Users',
    HELPER_VARIANTS: 'Variants',
    HELPER_SIZES: 'Sizes',
    HELPER_TONES: 'Tones',
    HELPER_STATES: 'States',
    HELPER_STATES_AND_ICONS: 'States and Icons',
    HELPER_SIZES_AND_STATES: 'Sizes and States',
    HELPER_STATE_DISABLED: 'Disabled',
    HELPER_STATE_LOADING: 'Loading',
    HELPER_STATE_SELECTED: 'Selected',
    HELPER_LEFT_ICON: 'Left icon',
    HELPER_RIGHT_ICON: 'Right icon',
    HELPER_TEXT_ONLY: 'Text only',
    HELPER_ACTION_ICON: 'Action icon',
    HELPER_BUTTON_DETAILS: 'Details',
    HELPER_TEXT_BUTTON: 'Text Button',
    HELPER_ADD_ITEM: 'Add Item',
    HELPER_BUTTON_PRIMARY_SIZE: 'Primary {0}',
    HELPER_SWITCH_ON: 'On',
    HELPER_SWITCH_OFF: 'Off',
    HELPER_SWITCH_DISABLED_ON: 'Disabled on',
    HELPER_SWITCH_DISABLED_OFF: 'Disabled off',
    HELPER_SWITCH_WITH_LABEL: 'With label',
    HELPER_SWITCH_ENABLED: 'Enabled',
    HELPER_DIRECTIVE_HOSTS: 'Directive Hosts',
    HELPER_ICON_REGISTRY: 'Icon Registry',
    HELPER_ICON_REGISTERED_COUNT: '{0} registered icons',
    HELPER_ICON_SEARCH_PLACEHOLDER: 'Search icons...',
    HELPER_ICON_SEARCH_LABEL: 'Search icons',
    HELPER_ICON_DEFAULT: 'Default',
    HELPER_ICON_DEFAULT_ONLY: 'Default only',
    HELPER_COPY_CODE: 'Copy code',
    HELPER_CODE_COPIED: 'Copied',
    HELPER_TOOLTIP_TITLE: 'Tooltip',
    HELPER_TOOLTIP_DESC: 'Contextual text for hover and keyboard focus, with viewport fallback, optional arrow, and optional subtext.',
    HELPER_TOOLTIP_BASE_VARIANTS: 'Base and variants',
    HELPER_TOOLTIP_BASE: 'Base',
    HELPER_TOOLTIP_SAMPLE_TEXT: 'This is a tooltip.',
    HELPER_TOOLTIP_HOVER_FOCUS: 'Hover or focus',
    HELPER_TOOLTIP_WITH_ARROW: 'With arrow',
    HELPER_TOOLTIP_SHOW_ARROW: 'Show arrow',
    HELPER_TOOLTIP_WITHOUT_ARROW: 'Without arrow',
    HELPER_TOOLTIP_HIDE_ARROW: 'Hide arrow',
    HELPER_TOOLTIP_WITH_SUBTEXT: 'With subtext',
    HELPER_TOOLTIP_SUBTEXT: 'Additional supporting information can be shown here.',
    HELPER_TOOLTIP_SHOW_SUBTEXT: 'Show subtext',
    HELPER_TOOLTIP_DISABLED: 'Disabled',
    HELPER_TOOLTIP_DISABLED_TEXT: 'This tooltip is disabled.',
    HELPER_TOOLTIP_DISABLED_TRIGGER: 'Disabled tooltip',
    HELPER_TOOLTIP_ONLY_OVERFLOW: 'Only when overflow',
    HELPER_TOOLTIP_OVERFLOW_TEXT: 'This long label only shows a tooltip when its content overflows.',
    HELPER_TOOLTIP_PLACEMENT: 'Placement',
    HELPER_TOOLTIP_PLACEMENT_VALUE: 'Placement: {0}',
    HELPER_TOOLTIP_PLACEMENT_TOP: 'Top',
    HELPER_TOOLTIP_PLACEMENT_TOP_START: 'Top start',
    HELPER_TOOLTIP_PLACEMENT_TOP_END: 'Top end',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM: 'Bottom',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM_START: 'Bottom start',
    HELPER_TOOLTIP_PLACEMENT_BOTTOM_END: 'Bottom end',
    HELPER_TOOLTIP_PLACEMENT_LEFT: 'Left',
    HELPER_TOOLTIP_PLACEMENT_RIGHT: 'Right',
    HELPER_TOOLTIP_THEME_API: 'Theme and API',
    HELPER_TOOLTIP_DARK_CONTEXT: 'Dark theme context',
    HELPER_TOOLTIP_DARK_TEXT: 'Dark theme tooltip',
    HELPER_TOOLTIP_DARK_SUBTEXT: 'Theme tokens are inherited from the closest theme context.',
    HELPER_TOOLTIP_DARK_TRIGGER: 'Dark tooltip',
    HELPER_TOOLTIP_API_TITLE: 'Tooltip title',
    HELPER_TOOLTIP_API_SUBTEXT: 'Optional subtext',
    HELPER_TOOLTIP_API_TRIGGER: 'Trigger',

    // Timetable
    TIMETABLE_TITLE: 'Timetable',
    TIMETABLE_SUBTITLE: 'Your timetable is displayed.',
    TIMETABLE_VIEW_LABEL: 'Change view',
    TIMETABLE_VIEW_TEACHER: 'Teacher',
    TIMETABLE_VIEW_CLASS: 'Class',
    TIMETABLE_TEACHER_LABEL: 'Teacher',
    TIMETABLE_CLASS_LABEL: 'Class',
    TIMETABLE_SHOW_UNASSIGNED: 'Show unassigned classes',
    TIMETABLE_BADGE_ONLINE: 'Online',
    TIMETABLE_BADGE_OFFLINE: 'Offline',

    // Calendar
    CALENDAR_TITLE: 'Calendar',
    CALENDAR_SUBTITLE: 'View your schedule by month, week, or day',
    CALENDAR_MORE_EVENTS: ' more',
    CALENDAR_ALL_DAY: 'All day',
    CALENDAR_TOGGLE_COURSE_TIME: 'Show course times',
    CALENDAR_TOGGLE_EVENT: 'Show events',
    CALENDAR_EVENT_LIST_TITLE: 'Events',
    CALENDAR_EVENT_CREATE_TITLE: 'Schedule Registration',
    CALENDAR_EVENT_EDIT_TITLE: 'Edit Schedule',
    CALENDAR_EVENT_REGISTER: 'Register',
    CALENDAR_EVENT_KIND: 'Type',
    CALENDAR_EVENT_KIND_LECTURE: 'Lecture',
    CALENDAR_EVENT_KIND_EVENT: 'Event',
    CALENDAR_EVENT_CLASS_MODE: 'Class mode',
    CALENDAR_EVENT_CLASS_MODE_OFFLINE: 'Offline',
    CALENDAR_EVENT_SUBJECT: 'Subject',
    CALENDAR_EVENT_TEACHERS: 'Teachers',
    CALENDAR_EVENT_TIME: 'Time',
    CALENDAR_EVENT_START_TIME: 'Start time',
    CALENDAR_EVENT_END_TIME: 'End time',
    CALENDAR_EVENT_PARTICIPANTS: 'Participants',
    CALENDAR_EVENT_LEARNING_METHOD: 'Learning method',
    CALENDAR_EVENT_JOIN_URL: 'Join URL',
    CALENDAR_EVENT_JOIN_NOW: 'Join meet',
    CALENDAR_EVENT_MEMO: 'Memo',
    CALENDAR_EVENT_DATE_RANGE_INVALID: 'Start date must be on or before end date',
    CALENDAR_EVENT_TIME_RANGE_INVALID: 'Start time must be on or before end time',
    CALENDAR_EVENT_CONFIRM_TITLE: 'Schedule Registration Confirmation',
    CALENDAR_EVENT_CONFIRM_MESSAGE: 'The following schedules will be registered.\nProceed?',
    CALENDAR_EVENT_CREATE_CONFIRM_TITLE: 'Create this schedule?',
    CALENDAR_EVENT_CREATE_CONFIRM_MESSAGE: 'Do you want to create this schedule with the current details?',
    CALENDAR_EVENT_EDIT_CONFIRM_TITLE: 'Save changes?',
    CALENDAR_EVENT_EDIT_CONFIRM_MESSAGE: 'Do you want to save the current changes?',
    CALENDAR_EVENT_DELETE_CONFIRM_TITLE: 'Delete this schedule?',
    CALENDAR_EVENT_DELETE_CONFIRM_MESSAGE: 'Do you want to delete this schedule?',
    CALENDAR_EVENT_TOTAL_COUNT: 'Total ',
    CALENDAR_EVENT_TOTAL_SUFFIX: ' items',
    CALENDAR_EVENT_DETAIL_DATETIME: 'Date & time',
    CALENDAR_EVENT_DETAIL_TEACHER: 'Teacher',
    CALENDAR_EVENT_DETAIL_LECTURE_TYPE: 'Lecture type',
    CALENDAR_EVENT_DETAIL_LOCATION: 'Location / URL',
    CALENDAR_EVENT_DETAIL_MATERIALS: 'Materials',
    CALENDAR_EVENT_ASSIGNMENTS: 'Assignments',
    CALENDAR_EVENT_WITHDRAW: 'Withdraw from class',
    CALENDAR_EVENT_SCOPE_EDIT_TITLE: 'Edit recurring events?',
    CALENDAR_EVENT_SCOPE_EDIT_MESSAGE: 'Editing the date and time for all future recurring events will delete any exceptions.',
    CALENDAR_EVENT_SCOPE_DELETE_TITLE: 'Delete recurring events?',
    CALENDAR_EVENT_SCOPE_DELETE_MESSAGE: 'Deleting this and all future recurring events will delete any exceptions.',
    CALENDAR_EVENT_SCOPE_EDIT_SINGLE: 'This event only',
    CALENDAR_EVENT_SCOPE_EDIT_FUTURE: 'This and following events',
    CALENDAR_EVENT_SCOPE_EDIT_ALL: 'All events',
    CALENDAR_EVENT_SCOPE_DELETE_SINGLE: 'This event only',
    CALENDAR_EVENT_SCOPE_DELETE_FUTURE: 'This and following events',
    CALENDAR_EVENT_SCOPE_DELETE_ALL: 'All events',
    CALENDAR_EVENT_EDIT_SINGLE_HINT: 'Editing schedule on {date}',
    CALENDAR_EVENT_EDIT_FUTURE_HINT: 'Editing all schedules from {date}',
    CALENDAR_EVENT_EDIT_ALL_HINT: 'Editing all recurring schedules',
    CALENDAR_EVENT_LEARNING_METHOD_OFFLINE_PLACE: 'Offline location',
    CALENDAR_EVENT_LEARNING_METHOD_ONDEMAND_URL: 'Video URL',
    CALENDAR_REPEAT_DIALOG_TITLE: 'Repeat schedule set',
    CALENDAR_REPEAT_LABEL: 'Repeat',
    CALENDAR_REPEAT_WEEK_LABEL: 'Repeat weeks',
    CALENDAR_REPEAT_DAY_LABEL: 'Days',
    CALENDAR_REPEAT_END_DATE_LABEL: 'End date',
    CALENDAR_REPEAT_END_NONE: 'None',
    CALENDAR_REPEAT_END_HAS: 'Set',
    CALENDAR_REPEAT_NO_DEADLINE: 'No deadline',
    CALENDAR_REPEAT_END_SUFFIX: 'End',
    CALENDAR_REPEAT_END_PLACEHOLDER: 'Select end date',
    CALENDAR_REPEAT_EVERY_DAY: 'Every day',
    CALENDAR_REPEAT_NONE: 'None',
    CALENDAR_REPEAT_SET: 'Set',
    CALENDAR_REPEAT_WEEK_1: 'Week 1',
    CALENDAR_REPEAT_WEEK_2: 'Week 2',
    CALENDAR_REPEAT_WEEK_3: 'Week 3',
    CALENDAR_REPEAT_WEEK_4: 'Week 4',
    CALENDAR_REPEAT_WEEK_5: 'Week 5',

    // E-book management
    EBOOK_TITLE: 'E-Book Management',
    EBOOK_SUBTITLE: 'Manage textbooks and course materials',
    EBOOK_SEARCH: 'Search materials...',
    EBOOK_COL_NAME: 'File Name',
    EBOOK_COL_CATEGORY: 'Category',
    EBOOK_COL_UPLOADER: 'Uploader',
    EBOOK_COL_UPLOADED_AT: 'Uploaded At',
    EBOOK_COL_STATUS: 'Status',
    EBOOK_COL_EXPIRY: 'Expiry Date',
    EBOOK_DIALOG_ADD_TITLE: 'Add Material',
    EBOOK_DIALOG_EDIT_TITLE: 'Edit Material',
    EBOOK_DIALOG_VIEW_TITLE: 'Material Details',
    EBOOK_FIELD_NAME: 'File Name',
    EBOOK_FIELD_NAME_PLACEHOLDER: 'Enter file name',
    EBOOK_FIELD_CATEGORY: 'Category',
    EBOOK_FIELD_CATEGORY_PLACEHOLDER: 'Select category',
    EBOOK_FIELD_UPLOADER: 'Uploader',
    EBOOK_FIELD_UPLOADER_PLACEHOLDER: 'Enter uploader',
    EBOOK_FIELD_UPLOADED_AT: 'Uploaded At',
    EBOOK_FIELD_UPLOADED_AT_PLACEHOLDER: 'Select uploaded date',
    EBOOK_FIELD_STATUS: 'Status',
    EBOOK_FIELD_STATUS_PLACEHOLDER: 'Select status',
    EBOOK_FIELD_EXPIRY: 'Expiry Date',
    EBOOK_FIELD_EXPIRY_PLACEHOLDER: 'Select expiry date',
    EBOOK_FIELD_DESCRIPTION: 'Description',
    EBOOK_FIELD_DESCRIPTION_PLACEHOLDER: 'Enter description',
    EBOOK_DETAIL_TITLE: 'PDF Viewer',
    EBOOK_DETAIL_SUBTITLE: 'Preview the selected PDF file',
    EBOOK_DETAIL_EMPTY: 'No file to display',
    PDF_TOOLBAR_HAND: 'Switch to Hand',
    PDF_TOOLBAR_SELECT: 'Switch to Select',
    PDF_TOOLBAR_DOWNLOAD: 'Download',
    PDF_TOOLBAR_FULLSCREEN: 'Fullscreen',
    PDF_TOOLBAR_EXIT_FULLSCREEN: 'Exit Fullscreen',
    PDF_TOOLBAR_SEARCH_PLACEHOLDER: 'Search in PDF...',
    COURSE_DETAIL_TITLE: 'Course Detail',
    COURSE_DETAIL_SUBTITLE: 'Review course content and materials',
    COURSE_DETAIL_TAB_INFO: 'Info',
    COURSE_DETAIL_TAB_LECTURES: 'Lectures',
    COURSE_DETAIL_TAB_ASSIGNMENTS: 'Assignments',
    COURSE_DETAIL_TAB_STUDENTS: 'Students',
    COURSE_DETAIL_TAB_COMING_SOON: 'This screen will be available soon.',
    COURSE_DETAIL_TAB_EBOOK: 'E-Book',
    COURSE_DETAIL_TAB_VIDEOS: 'Videos',
    COURSE_DETAIL_TAB_TEST: 'Test',
    COURSE_DETAIL_INFO_TITLE: 'Course Information',
    COURSE_DETAIL_INFO_SUBTITLE: 'Course overview will be available here.',
    COURSE_DETAIL_INFO_OVERVIEW: 'Overview',
    COURSE_DETAIL_INFO_CLASS_INFO: 'Class info',
    COURSE_DETAIL_INFO_PROGRESS: 'Class progress',
    COURSE_DETAIL_INFO_TEACHING: 'Teaching info',
    COURSE_DETAIL_INFO_YEAR: 'Year',
    COURSE_DETAIL_INFO_SEMESTER: 'Semester',
    COURSE_DETAIL_INFO_MAJOR: 'Major',
    COURSE_DETAIL_INFO_TEACHER: 'Instructor',
    COURSE_DETAIL_INFO_CREDITS: 'Credits',
    COURSE_DETAIL_INFO_GRADING: 'Grading',
    COURSE_DETAIL_INFO_EVALUATION: 'Evaluation',
    COURSE_DETAIL_INFO_CLASS_TYPE: 'Class type',
    COURSE_DETAIL_INFO_SCHEDULE: 'Timetable',
    COURSE_DETAIL_PROGRESS_COMPLETE: '{0}% completed',
    COURSE_DETAIL_PROGRESS_DAYS_LEFT: 'Days to final',
    COURSE_DETAIL_PROGRESS_ATTENDANCE: 'Attendance rate',
    COURSE_DETAIL_PROGRESS_ASSIGNMENT: 'Assignment due in',
    COURSE_DETAIL_FLEX_PROGRESS_TITLE: 'Course progress',
    COURSE_DETAIL_FLEX_PROGRESS_TEACHER_TITLE: 'Course completion progress',
    COURSE_DETAIL_FLEX_SUBMIT_RATE: 'Submit',
    COURSE_DETAIL_FLEX_WATCH_RATE: 'Watch',
    COURSE_DETAIL_FLEX_MISSING_COUNT: 'Missing count',
    COURSE_DETAIL_FLEX_AVG_SUBMIT: 'Avg submission',
    COURSE_DETAIL_FLEX_AVG_WATCH: 'Avg watch',
    COURSE_DETAIL_FLEX_COURSE_COUNT: 'Courses',
    COURSE_DETAIL_FLEX_UNWATCHED: 'Unwatched list',
    COURSE_DETAIL_FLEX_PENDING_ASSIGNMENT: 'Missing assignments',
    COURSE_DETAIL_FLEX_CONTINUE: 'Continue',
    COURSE_DETAIL_FLEX_FINISH: 'Mark complete',
    COURSE_DETAIL_FLEX_FINISHED: 'Completed',
    COURSE_DETAIL_FLEX_FINISH_CONFIRM_TITLE: 'Mark this course as completed?',
    COURSE_DETAIL_FLEX_FINISH_CONFIRM_MESSAGE: 'This action cannot be undone.\nDo you want to continue?',
    COURSE_DETAIL_FLEX_MODE_OFFLINE: 'Offline',
    COURSE_DETAIL_FLEX_MODE_ONDEMAND: 'On-demand',
    COURSE_DETAIL_FLEX_MODE_ONLINE: 'Online',
    COURSE_DETAIL_FLEX_DUE_DATE: 'Due date',
    COURSE_DETAIL_TEST_TITLE: 'Test',
    COURSE_DETAIL_TEST_SUBTITLE: 'Test content will be added later.',
    PDF_TOOL_HIGHLIGHT: 'Highlight',
    PDF_TOOL_DRAW: 'Draw',
    PDF_TOOL_ERASE: 'Erase',
    PDF_TOOL_NOTE: 'Note',
    PDF_TOOL_UNDO: 'Undo',
    PDF_TOOL_REDO: 'Redo',
    PDF_TOOL_SAVE: 'Save',
    PDF_TOOL_DOWNLOAD: 'Download',
    PDF_LOADING_TITLE: 'Loading PDF...',
    PDF_LOADING_CONNECTING: 'Connecting...',
    PDF_LOADING_DOWNLOADED: '{0} downloaded...',
    EBOOK_CATEGORY_ALL_CLASSES: 'All Classes',
    EBOOK_CATEGORY_KG202601: 'KG202601',
    EBOOK_CATEGORY_KG202602: 'KG202602',
    EBOOK_CATEGORY_KG202701: 'KG202701',
    EBOOK_CATEGORY_KG202702: 'KG202702',
    EBOOK_UPLOAD_TITLE: 'Upload Learning Materials',
    EBOOK_UPLOAD_DROP_TITLE: 'Drag & drop files here',
    EBOOK_UPLOAD_DROP_SUBTITLE: 'or click to browse',
    EBOOK_UPLOAD_SELECT_FILE: 'Select file',
    EBOOK_UPLOAD_UPLOADING: 'Uploading',
    EBOOK_UPLOAD_NAME_LABEL: 'Name',
    EBOOK_UPLOAD_NAME_PLACEHOLDER: 'Enter name',
    EBOOK_UPLOAD_SHARE_LABEL: 'Share to',
    EBOOK_UPLOAD_SHARE_PLACEHOLDER: 'Select share target',
    EBOOK_UPLOAD_EXPIRY_LABEL: 'Expiry',
    EBOOK_UPLOAD_EXPIRY_NONE: 'None',
    EBOOK_UPLOAD_EXPIRY_HAS: 'Set',
    EBOOK_UPLOAD_REGISTER: 'OK',
    VIDEO_TITLE: 'Video Management',
    VIDEO_SUBTITLE: 'Manage course videos',
    VIDEO_SEARCH: 'Search videos...',
    VIDEO_COL_NAME: 'Video Name',
    VIDEO_COL_SESSION: 'Session',
    VIDEO_COL_UPLOADER: 'Uploader',
    VIDEO_COL_UPLOADED_AT: 'Uploaded At',
    VIDEO_COL_STATUS: 'Status',
    VIDEO_COL_DURATION: 'Duration',
    VIDEO_UPLOAD_TITLE: 'Upload Video',
    VIDEO_UPLOAD_DROP_TITLE: 'Drag & Drop',
    VIDEO_UPLOAD_DROP_SUBTITLE: 'or',
    VIDEO_UPLOAD_SELECT_FILE: 'Select file',
    VIDEO_UPLOAD_UPLOADING: 'Uploading',
    VIDEO_UPLOAD_NAME_LABEL: 'Name',
    VIDEO_UPLOAD_NAME_PLACEHOLDER: 'Enter name',
    VIDEO_UPLOAD_SESSION_LABEL: 'Session',
    VIDEO_UPLOAD_SESSION_PLACEHOLDER: 'Select session',
    VIDEO_UPLOAD_DESCRIPTION_LABEL: 'Description',
    VIDEO_UPLOAD_DESCRIPTION_PLACEHOLDER: 'Enter description',
    VIDEO_UPLOAD_REGISTER: 'Register',
    VIDEO_DETAIL_SUBTITLE: 'Review the course video content',
    VIDEO_DETAIL_NAME: 'Video name',
    VIDEO_DETAIL_DESCRIPTION: 'Description',
    VIDEO_DETAIL_NEXT: 'Up next',
    VIDEO_DETAIL_STATS_TITLE: 'Viewing stats',
    VIDEO_DETAIL_AVG_PROGRESS: 'avg progress',
    VIDEO_DETAIL_STAT_VIEWERS: 'Viewers',
    VIDEO_DETAIL_STAT_COMPLETED: 'Completed',
    VIDEO_DETAIL_STAT_PROGRESS: 'Average progress',
    VIDEO_DETAIL_TABLE_NAME: 'Learner',
    VIDEO_DETAIL_TABLE_PROGRESS: 'Progress',
    VIDEO_DETAIL_TABLE_LAST: 'Last watched',
    VIDEO_DETAIL_TABLE_STATUS: 'Status',
    VIDEO_DETAIL_VIEWERS: 'viewers',
    VIDEO_DETAIL_COMPLETED: 'completed',
    VIDEO_DETAIL_MATERIALS: 'Materials',
    VIDEO_DETAIL_SUBMIT: 'Assignment',
    VIDEO_DETAIL_SUBMIT_PDF: 'Kiểm tra giữa kỳ giải tích 1.pdf',
    VIDEO_DETAIL_SUBMIT_LINK: 'Submission URL',
    VIDEO_DETAIL_SUBMITTED: 'Submitted',
    VIDEO_DETAIL_SUBMIT_ACTION: 'Submit',
    VIDEO_DETAIL_SUBMIT_CONFIRM_NOTE: 'Clicking this button confirms the assignment as submitted.',
    VIDEO_DETAIL_NOT_SUBMITTED: 'Not submitted',
    VIDEO_DETAIL_SUBMIT_URL_LABEL: 'Assignment submission URL',
    VIDEO_DETAIL_SUBMIT_URL_PLACEHOLDER: 'Paste your Google Drive URL here',
    VIDEO_DETAIL_SUBMIT_URL_NOTE: 'Paste the shared link URL. Make sure the sharing setting is set to "Anyone with the link".',
    VIDEO_DETAIL_COL_VIEWER_PROGRESS: 'Viewing Progress',
    VIDEO_DETAIL_COL_SUBMISSION_PROGRESS: 'Submission Progress',
    VIDEO_DETAIL_SYNC: 'Update Viewing Progress',
    VIDEO_DETAIL_LAST_SYNC: 'Last synced:',
    VIDEO_DETAIL_PREZI_OPEN: 'Click here to view the document',
    VIDEO_DETAIL_HLS_PREPARING_PAGE_TITLE: 'Preparing your video...',
    VIDEO_DETAIL_HLS_PREPARING_PAGE_DESC: 'Please come back to this page again in a little while.',
    VIDEO_DETAIL_HLS_BACK_TO_COURSE: 'Return to course detail',
    VIDEO_DETAIL_HLS_NOT_PROCESSED_TITLE: 'Video has not been processed yet',
    VIDEO_DETAIL_HLS_NOT_PROCESSED_DESC: 'The recording URL has not been queued for processing yet. Please ask an administrator to set the recording URL.',
    VIDEO_DETAIL_HLS_QUEUED_TITLE: 'Video is queued',
    VIDEO_DETAIL_HLS_QUEUED_DESC: 'The recording transcode job is queued. Please wait until processing starts.',
    VIDEO_DETAIL_HLS_PENDING_TITLE: 'Video is being prepared',
    VIDEO_DETAIL_HLS_PENDING_DESC: 'The recording is being processed. Please check back later.',
    VIDEO_DETAIL_HLS_FAILED_TITLE: 'Video processing failed',
    VIDEO_DETAIL_HLS_FAILED_DESC: 'Transcoding failed. Please ask an administrator to re-set the recording URL.',
    VIDEO_DETAIL_HLS_NEW_VERSION_TITLE: 'A newer video version is available',
    VIDEO_DETAIL_HLS_NEW_VERSION_DESC: 'The video you are watching has been updated. Your progress is saved. Please reload the page to watch the latest version.',
    VIDEO_DETAIL_HLS_RELOAD: 'Reload',
    VIDEO_DETAIL_HLS_COOKIE_ERROR_TITLE: 'Could not load the video',
    VIDEO_DETAIL_HLS_COOKIE_ERROR_DESC: 'Authentication failed. Please reload the page and try again.',
    SYNC_UPLOAD_DROP_LABEL: 'Drag & drop a file here',
    SYNC_UPLOAD_DROP_HINT: 'or click to browse',
    SYNC_UPLOAD_CONFIRM: 'Upload',
    VIDEO_MGMT_LECTURE_TITLE: 'Lecture Session Management',
    VIDEO_MGMT_LECTURE_SUBTITLE:
      'This screen centrally manages each lecture session. You can review lecture details, attendance status, and assignment submission status. You can also publish lecture content for students and set recorded meeting video URLs so students can watch later.',
    VIDEO_MGMT_STUDENT_SUBTITLE:
      'This screen lets students track each lecture session. You can review details, download learning materials, and watch lecture recordings.',
    VIDEO_MGMT_CLASS_FILTER: 'Filter by class',
    VIDEO_MGMT_CLASS_OPTION_1: 'Course 1 (2026/4/4-6/27)',
    VIDEO_MGMT_CLASS_OPTION_2: 'Course 2 (2026/7/4-9/26)',
    VIDEO_MGMT_CLASS_OPTION_3: 'Course 3 (2026/10/3-12/26)',
    VIDEO_MGMT_COL_TITLE: 'Lecture Title',
    VIDEO_MGMT_COL_TYPE: 'Lecture Type',
    VIDEO_MGMT_COL_SCHEDULE: 'Schedule',
    VIDEO_MGMT_COL_ATTENDANCE: 'Attendance',
    VIDEO_MGMT_COL_ASSIGNMENT: 'Assignment Progress',
    VIDEO_MGMT_COL_PUBLISH: 'Public',
    VIDEO_MGMT_COL_RECORDING_LINK: 'Recording Link',
    VIDEO_MGMT_COL_ACTION: 'Action',
    VIDEO_MGMT_COL_WATCH_STATUS: 'Watch Status',
    VIDEO_MGMT_COL_SUBMISSION_STATUS: 'Submission Status',
    VIDEO_MGMT_COL_MATERIAL_DOWNLOAD: 'Material Download',
    VIDEO_MGMT_COL_DETAIL: 'Detail',
    VIDEO_MGMT_LECTURE_TYPE_LIVE: 'LIVE',
    VIDEO_MGMT_LECTURE_TYPE_ON_DEMAND: 'On-Demand',
    VIDEO_MGMT_ATTENDANCE_CONFIRM: 'Confirm Attendance',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_TITLE: 'Confirm Attendance',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_MSG: 'This action will officially end the lecture and confirm attendance for selected students.\nDo you really want to confirm?',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_WARNING_1: '* This action can only be performed once and cannot be undone.',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_WARNING_2: '* Students who are not selected will be treated as absent.',
    VIDEO_MGMT_ATTENDANCE_END_CONFIRM_YES: 'Confirm',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_TITLE: 'Attendance Preview',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_CODE: 'Student ID',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_NAME: 'Name',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_JOIN: 'Join Time',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_LEAVE: 'Leave Time',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_COL_JOINED: 'Present',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_JOINED_COUNT: 'Attending: ',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_EMPTY: 'No participants found',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_BTN_OK: 'Confirm Attendance',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_BTN_EXPORT_CSV: 'Export CSV',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_DESC: 'This is a participant list automatically recorded by Google Meet.',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_ONLINE: 'Online',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_INSTRUCTION: 'Please select the participants who actually attended the class after confirming the content, then click the [Confirm Attendance] button.',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_WARNING: '* The participant list is automatically retrieved from Google Meet. It may not be displayed correctly due to errors in entering student IDs, etc.',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_SELECTED: 'Selected',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_SELECTED_COUNT: '{0}/{1} members',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_NO: 'No',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_MEET_NAME: 'Participant Name',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_USER_NAME: 'Username',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_START: 'Start',
    VIDEO_MGMT_ATTENDANCE_PREVIEW_CSV_END: 'End',
    VIDEO_MGMT_ATTENDANCE_SAVE_SUCCESS_TITLE: 'Attendance Confirmed',
    VIDEO_MGMT_ATTENDANCE_SAVE_SUCCESS_MSG: 'Attendance has been saved successfully.',
    VIDEO_MGMT_RECORD_LINK: 'Set Recording',
    VIDEO_MGMT_RECORD_LINK_ACTION: 'Link',
    VIDEO_MGMT_RECORD_LINKED: 'Recording Set',
    VIDEO_MGMT_RECORD_RELINK: 'Relink',
    VIDEO_MGMT_PUBLISH: 'Public',
    VIDEO_MGMT_RECORD_DIALOG_TITLE: 'Set Recording URL',
    VIDEO_MGMT_RECORD_DIALOG_NOTICE:
      'To allow students who cannot attend the online class to join later, switch the Google Meet URL to the recorded video URL.',
    VIDEO_MGMT_RECORD_DIALOG_URL_LABEL: 'Google Drive URL',
    VIDEO_MGMT_RECORD_DIALOG_URL_PLACEHOLDER: 'https://drive.google.com/...',
    VIDEO_MGMT_RECORD_DIALOG_URL_REQUIRED: 'Please enter a URL.',
    VIDEO_MGMT_RECORD_DIALOG_SET: 'Set',
    VIDEO_MGMT_RECORD_STATUS_CHECKING_SHORT: 'Checking',
    VIDEO_MGMT_RECORD_STATUS_PROCESSING_SHORT: 'Processing',
    VIDEO_MGMT_DOWNLOAD_ALL: 'Download all materials',
    VIDEO_MGMT_STATUS_WATCHED: 'Watched',
    VIDEO_MGMT_STATUS_NOT_WATCHED: 'Not watched',
    VIDEO_MGMT_STATUS_SUBMITTED: 'Submitted',
    VIDEO_MGMT_STATUS_NOT_SUBMITTED: 'Not submitted',
    VIDEO_MGMT_STUDENT_MGMT_TITLE: 'Student Session Management',
    VIDEO_MGMT_STUDENT_MGMT_SUBTITLE:
      'This screen centrally manages each student by lecture session. You can review lecture details, attendance status, assignment submission status, and open submitted assignment links.',
    VIDEO_MGMT_STUDENT_COL_NAME: 'Name',
    VIDEO_MGMT_STUDENT_COL_WATCH_DETAIL: 'Viewing Details',
    VIDEO_MGMT_STUDENT_COL_WATCH_PROGRESS: 'Watch Progress',
    VIDEO_MGMT_STUDENT_COL_ASSIGNMENT_PROGRESS: 'Assignment Progress',
    VIDEO_MGMT_STUDENT_COL_SUBMISSION: 'Submission',
    VIDEO_MGMT_STUDENT_OPEN: 'Open',
    VIDEO_MGMT_STUDENT_EXPORT: 'Export',
    VIDEO_MGMT_STUDENT_EXPORT_TOOLTIP_TITLE: 'Download viewing progress details',
    VIDEO_MGMT_STUDENT_EXPORT_TOOLTIP_DESC:
      'Click to download an Excel or PDF file. Each student has a dedicated sheet, so Google Meet attendance history can be reviewed in detail.',
    VIEWING_DONE: 'Watched',
    VIEWING_IN_PROGRESS: 'Watching',
    VIEWING_NOT_STARTED: 'Not watched',
    SUBMISSION_DONE: 'Submitted',
    SUBMISSION_NOT_SUBMITTED: 'Not submitted',
    IN_PROGRESS: 'In Progress',
    NOT_STARTED: 'Not Started',

    // Admin users
    ADMIN_USERS_TITLE: 'User Management',
    ADMIN_USERS_SUBTITLE: 'Create, edit, and manage login accounts for the system. Supports both individual creation and CSV bulk registration for students, teachers, and admins.',
    ADMIN_USERS_SEARCH: 'Search users...',
    ADMIN_MAJORS_TITLE: 'Major Management',
    ADMIN_MAJORS_SUBTITLE: 'Create and edit school majors. Link subjects to each major and manage curriculum structure.',
    ADMIN_MAJORS_LIST_TITLE: 'Major List',
    ADMIN_MAJORS_DETAIL_TITLE: 'Major Detail',
    ADMIN_MAJORS_SEARCH_PLACEHOLDER: 'Search majors...',
    ADMIN_MAJORS_NAME_LABEL: 'Major Name',
    ADMIN_MAJORS_CODE_LABEL: 'Major Code',
    ADMIN_MAJORS_REQUIRED_CREDITS: 'Required Credits',
    ADMIN_MAJORS_COURSE_SECTION: 'Course Assignment',
    ADMIN_MAJORS_COURSE_COUNT: '{0} courses assigned',
    ADMIN_MAJORS_NAME_PLACEHOLDER: 'Enter major name',
    ADMIN_MAJORS_CODE_PLACEHOLDER: 'Enter major code',
    ADMIN_MAJORS_CREDITS_PLACEHOLDER: 'Enter required credits',
    ADMIN_MAJORS_NO_COURSES: 'No assigned courses',
    ADMIN_MAJORS_ASSIGN_COURSES: 'Assign courses',
    ADMIN_MAJORS_ASSIGN_MODAL_TITLE: 'Assign Courses',
    ADMIN_CLASSES_TITLE: 'Class Management',
    ADMIN_CLASSES_SUBTITLE: 'Create, edit, and manage classes (student groups). Manage students by class to streamline enrollment and timetable operations.',
    ADMIN_CLASSES_LIST_TITLE: 'Class List',
    ADMIN_CLASSES_DETAIL_TITLE: 'Class Detail',
    ADMIN_CLASSES_SEARCH_PLACEHOLDER: 'Search classes...',
    ADMIN_CLASSES_NAME_LABEL: 'Class Name',
    ADMIN_CLASSES_CODE_LABEL: 'Class Code',
    ADMIN_CLASSES_COHORT_YEAR: 'Cohort Year',
    ADMIN_CLASSES_START_DATE: 'Start Date',
    ADMIN_CLASSES_GRAD_YEAR: 'Expected Graduation Year',
    ADMIN_CLASSES_NAME_PLACEHOLDER: 'Enter class name',
    ADMIN_CLASSES_CODE_PLACEHOLDER: 'Enter class code',
    ADMIN_CLASSES_YEAR_PLACEHOLDER: 'Select year',
    ADMIN_CLASSES_STUDENT_SECTION: 'Student Assignment',
    ADMIN_CLASSES_STUDENT_COUNT: '{0} students assigned',
    ADMIN_CLASSES_NO_STUDENTS: 'No assigned students',
    ADMIN_CLASSES_ASSIGN_STUDENTS: 'Assign students',
    ADMIN_CLASSES_ASSIGN_MODAL_TITLE: 'Assign Students',
    SEARCH_STUDENT: 'Search students...',
    ADMIN_COURSES_TITLE: 'Course Management',
    ADMIN_COURSES_SUBTITLE: 'Create and edit subjects, and configure them as common or major-specific courses. Upload learning materials and assign teachers in this screen.',
    ADMIN_COURSES_LIST_TITLE: 'Course List',
    ADMIN_COURSES_DETAIL_TITLE: 'Course Detail',
    ADMIN_COURSES_SEARCH_PLACEHOLDER: 'Search courses...',
    ADMIN_COURSES_NAME_LABEL: 'Course Name',
    ADMIN_COURSES_NAME_PLACEHOLDER: 'Enter course name',
    ADMIN_COURSES_CODE_LABEL: 'Course Code',
    ADMIN_COURSES_CODE_PLACEHOLDER: 'Enter course code',
    ADMIN_COURSES_DESCRIPTION_LABEL: 'Course Description',
    ADMIN_COURSES_DESCRIPTION_PLACEHOLDER: 'Enter course description',
    ADMIN_COURSES_CREDITS_LABEL: 'Credits',
    ADMIN_COURSES_CREDITS_PLACEHOLDER: 'Enter credits',
    ADMIN_COURSES_LECTURES_LABEL: 'Required Lectures',
    ADMIN_COURSES_LECTURES_PLACEHOLDER: 'Enter required lectures',
    ADMIN_COURSES_ACTIVE_PERIOD_LABEL: 'Active Period',
    ADMIN_COURSES_ACTIVE_PERIOD_PLACEHOLDER: 'Enter active period',
    ADMIN_COURSES_COLOR_LABEL: 'Course Color',
    ADMIN_COURSES_COLOR_PLACEHOLDER: '#FFFFFF',
    ADMIN_COURSES_TYPE_LABEL: 'Course Type',
    ADMIN_COURSES_MAJOR_LABEL: 'Major',
    ADMIN_COURSES_TEACHER_LABEL: 'Assigned Teachers',
    ADMIN_COURSES_TEACHER_SECTION: 'Teacher Assignment',
    ADMIN_COURSES_TEACHER_COUNT: '{0} teachers assigned',
    ADMIN_COURSES_ASSIGN_TEACHERS: 'Assign teachers',
    ADMIN_COURSES_NO_TEACHERS: 'No assigned teachers',
    ADMIN_COURSES_ASSIGN_MODAL_TITLE: 'Assign Teachers',
    ADMIN_COURSES_EBOOK_SECTION: 'Upload Learning Materials',
    ADMIN_COURSES_EBOOK_COUNT: '{0} materials assigned',
    ADMIN_COURSES_ASSIGN_EBOOKS: 'Assign materials',
    ADMIN_COURSES_NO_EBOOKS: 'No materials assigned',
    SEARCH_TEACHER: 'Search teachers...',
    COURSE_TYPE_COMMON: 'Common',
    COURSE_TYPE_SPECIAL: 'Specialized',
    ADMIN_SEMESTERS_TITLE: 'Semester Management',
    ADMIN_SEMESTERS_SUBTITLE: 'Create and edit semesters. Configure start and end months and reuse semester settings across academic years.',
    ADMIN_SEMESTERS_LIST_TITLE: 'Semester List',
    ADMIN_SEMESTERS_DETAIL_TITLE: 'Semester Detail',
    ADMIN_SEMESTERS_SEARCH_PLACEHOLDER: 'Search semesters...',
    ADMIN_SEMESTERS_NAME_LABEL: 'Semester Name',
    ADMIN_SEMESTERS_NAME_PLACEHOLDER: 'Enter semester name',
    ADMIN_SEMESTERS_DESC_LABEL: 'Semester Description',
    ADMIN_SEMESTERS_DESC_PLACEHOLDER: 'Enter semester description',
    ADMIN_SEMESTERS_YEAR_LABEL: 'Year',
    ADMIN_SEMESTERS_START_MONTH: 'Start Month',
    ADMIN_SEMESTERS_END_MONTH: 'End Month',
    ADMIN_SEMESTERS_START_MONTH_PLACEHOLDER: 'Select start month',
    ADMIN_SEMESTERS_END_MONTH_PLACEHOLDER: 'Select end month',
    ADMIN_SEMESTERS_COURSE_SECTION: 'Course Assignment',
    ADMIN_SEMESTERS_COURSE_COUNT: '{0} courses assigned',
    ADMIN_SEMESTERS_ASSIGN_COURSES: 'Assign courses',
    ADMIN_SEMESTERS_NO_COURSES: 'No assigned courses',
    ADMIN_SEMESTERS_ASSIGN_MODAL_TITLE: 'Assign Courses',
    YEAR_1: 'Year 1',
    YEAR_2: 'Year 2',
    YEAR_3: 'Year 3',
    YEAR_4: 'Year 4',
    YEAR_5: 'Year 5',
    YEAR_6: 'Year 6',
    MONTH_1: 'Jan',
    MONTH_2: 'Feb',
    MONTH_3: 'Mar',
    MONTH_4: 'Apr',
    MONTH_5: 'May',
    MONTH_6: 'Jun',
    MONTH_7: 'Jul',
    MONTH_8: 'Aug',
    MONTH_9: 'Sep',
    MONTH_10: 'Oct',
    MONTH_11: 'Nov',
    MONTH_12: 'Dec',
    DEVICE_TYPE_CLASSROOM: 'Classroom',
    DEVICE_TYPE_AV: 'AV Equipment',
    DEVICE_STATUS_AVAILABLE: 'Available',
    DEVICE_STATUS_IN_USE: 'In use',
    DEVICE_STATUS_UNAVAILABLE: 'Unavailable',
    ENROLLMENT_SLOT_LABEL: 'Slot',
    ENROLLMENT_ROOM_PLACEHOLDER: 'Select room',
    ENROLLMENT_ONLINE_PLACEHOLDER: 'Enter online link',
    ENROLLMENT_BADGE_ONLINE: 'LIVE',
    DAY_SUN: 'Sun',
    DAY_MON: 'Mon',
    DAY_TUE: 'Tue',
    DAY_WED: 'Wed',
    DAY_THU: 'Thu',
    DAY_FRI: 'Fri',
    DAY_SAT: 'Sat',

    // Shared
    ALL: 'All',
    GO: 'Go',
    ACTIONS: 'Actions',
    VIEW: 'View',
    MANAGE: 'Manage',
    ARCHIVE: 'Archive',
    REGISTER: 'Register',
    BACK: 'Back',
    ROLE: 'Role',
    STATUS: 'Status',
    YES: 'Yes',
    NO: 'No',
    TA_LABEL: 'TA',
    FIELD_REQUIRED: 'This field is required',
    ASSIGN_COURSE_REQUIRED: 'Please select a course',
    VALID_COURSE_TYPE: 'This course has already been assigned to another major.',
    ROLE_STUDENT: 'Student',
    ROLE_TEACHER: 'Teacher',
    ROLE_ADMIN: 'Admin',
    STATUS_ACTIVE: 'Active',
    STATUS_INACTIVE: 'Inactive',
    STATUS_DRAFT: 'Draft',
    STATUS_ARCHIVED: 'Archived',
    STATUS_SUSPENDED: 'Suspended',
    MALE: 'Male',
    FEMALE: 'Female',
    OTHER: 'Other',
    NONE: 'Select gender',
    USER_NAME_LABEL: 'User Name',
    USER_NAME_PLACEHOLDER: 'Enter name',
    USER_EMAIL_PLACEHOLDER: 'email@example.com',
    USER_PHONE_PLACEHOLDER: '+1 234 567 8900',
    STUDENT_CODE_LABEL: 'Student Code',
    STAFF_CODE_LABEL: 'Staff Code',
    CODE_LABEL: 'Code',
    PASSWORD_CHANGED_HINT: 'Initial password updated',
    PASSWORD_CHANGED_SHORT: 'PW changed',
    PASSWORD_UNCHANGED_SHORT: 'PW unchanged',
    GENDER: 'Gender',
    DOB: 'Date of birth',
    ADDRESS: 'Address',
    USER_ADDRESS_PLACEHOLDER: 'Enter address',
    EDUCATION_BACKGROUND: 'Educational Background',
    WORK_EXPERIENCE: 'Work Experience',
    CAREER_PATH: 'Post-Graduation Career Paths',
    QUALIFICATIONS: 'Acquired Qualifications',
    GRADES_LABEL: 'Grades',
    HEALTH_RESULT: 'Health Examination Results',
    USER_DETAILS_TITLE: 'User Details',
    USER_EDIT_TITLE: 'Edit User',
    USER_ADD_TITLE: 'Add User',

    ADMIN_USERS_ADD_SINGLE: 'Add User',
    ADMIN_USERS_ADD_CSV: 'Bulk Upload (CSV)',
    ADMIN_USERS_COL_NAME: 'Name',
    ADMIN_USERS_COL_CODE: 'User Code',
    ADMIN_USERS_COL_ROLE: 'Role',
    ADMIN_USERS_COL_STATUS: 'Status',
    ADMIN_USERS_COL_ENROLLMENT: 'Enrollment Date',
    ADMIN_USERS_COL_DEPARTMENT: 'Major',
    CSV_BULK_TITLE: 'Bulk Upload Users',
    CSV_UPLOAD_HINT: 'Upload a CSV file to add users.',
    CSV_UPLOAD_BUTTON: 'Select CSV',
    CSV_DOWNLOAD_TEMPLATE: 'Download Template',
    CSV_SELECTED_FILE: 'Selected file',
    CSV_CHANGE_FILE: 'Change file',
    CSV_SAVE_ALL: 'Save All',
    CSV_INVALID_FORMAT: 'Invalid CSV format.',
    CSV_NO_DATA: 'CSV has no data.',
    CSV_READ_ERROR: 'Failed to read CSV.',
    CSV_USER_ID_PLACEHOLDER: 'Enter user code',
    CSV_USER_NAME_PLACEHOLDER: 'Enter user name',
    CSV_ROLE_PLACEHOLDER: 'Enter role',
    CSV_STATUS_PLACEHOLDER: 'Enter status',
    CSV_EMAIL_PLACEHOLDER: 'Enter email',
    CSV_PHONE_PLACEHOLDER: 'Enter phone',
    CSV_ENROLL_PLACEHOLDER: 'Enter enrollment date',
    CSV_DEPT_PLACEHOLDER: 'Enter major',
    CSV_VALIDATION_HINT: '* User Code and Email must be unique. Please be careful not to have them duplicated.',
    SELECT_ALL: '(SELECT ALL)',
    SORT_ASC: 'Ascending',
    SORT_DESC: 'Descending',
    PAGINATION_PREV: 'Prev',
    PAGINATION_NEXT: 'Next',
    STUDENT: 'Student',
    TEACHER: 'Teacher',
    ADMIN: 'Admin',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    CLOSED: 'Closed',
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
    DATE: 'Date',
    COURSE: 'Course',
    COURSES: 'Courses',
    TOTAL_COURSES: 'Total Courses',
    STUDENTS_LABEL: 'Students',
    DEPARTMENT: 'Major',
    USER_DEPARTMENT_PLACEHOLDER: 'Select major',
    CREDITS: 'Credits',
    SEMESTER: 'Semester',
    SCHEDULE_LABEL: 'Schedule',
    COURSE_CODE: 'Course Code',
    COURSE_NAME: 'Course Name',
    COURSE_CREATED: 'Course created',
    CREATE_COURSE: 'Create course',
    CREATE_COURSE_DESC: 'Enter course basics to add a new class',
    SEARCH_COURSE: 'Search courses...',
    SEARCH_USER: 'Search users...',
    SEARCH_PLACEHOLDER: 'Search by keyword...',
    DESCRIPTION: 'Description',
    TITLE: 'Title',
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    TIME_SELECT_HOUR: 'Hour',
    TIME_SELECT_MINUTE: 'Minute',
    MAX_STUDENTS: 'Max students',
    UPLOAD_LIMIT: 'Upload limit (MB)',
    AVERAGE_ENROLLMENT: 'Average enrollment',
    ACTIVE_LABEL: 'Active',
    ASSIGNMENT: 'Assignment',
    QUIZ: 'Quiz',
    PROJECT: 'Project',
    STUDENT_ID: 'Student ID',
    EMPLOYEE_ID: 'Employee ID',
    LAST_LOGIN: 'Last login',
    REGISTRATION_DATE: 'Registration date',
    EMERGENCY_CONTACT: 'Emergency contact',
    EMERGENCY_PHONE: 'Emergency phone',
    PREVIOUS: 'Previous',
    NEXT: 'Next',

    // Student Dashboard
    STUDENT_DASHBOARD_TITLE: 'Welcome back, {0}',
    STUDENT_DASHBOARD_SUBTITLE: 'Here are your course updates',
    QUICK_MATERIALS: 'Materials',
    QUICK_MATERIALS_DESC: 'View PDFs and notes',
    QUICK_SCHEDULE: 'Schedule',
    QUICK_SCHEDULE_DESC: 'View calendar',
    QUICK_TEST: 'Take Test',
    QUICK_TEST_DESC: 'Start quiz/exam',
    QUICK_PROGRESS: 'My Progress',
    QUICK_PROGRESS_DESC: 'View statistics',

    // Course Schedule
    COURSE_SCHEDULE_TITLE: 'Course Schedule',
    COURSE_SCHEDULE_SUBTITLE: 'Manage classes, assignments, and exams',
    BTN_TODAY: 'Today',
    BTN_BACK: 'Back',
    VIEW_WEEK: 'Week',
    VIEW_MONTH: 'Month',
    VIEW_DAY: 'Day',
    EVENT_TYPES: 'Event Types',
    EVENT_TYPE_ONLINE: 'Online Class',
    EVENT_TYPE_OFFLINE: 'Offline Class',
    EVENT_TYPE_ASSIGNMENT: 'Assignment',
    EVENT_TYPE_EXAM: 'Exam',
    EVENT_TYPE_INTERNSHIP: 'Internship',
    SCHEDULE_EVENT_MATH: 'Advanced Math Lecture',
    SCHEDULE_EVENT_MATH_DESC: 'Learn applications of differential equations',
    SCHEDULE_EVENT_WEB: 'Web Development Lab',
    SCHEDULE_EVENT_WEB_DESC: 'Hands-on practice with React Hooks',
    SCHEDULE_EVENT_ASSIGNMENT: 'Assignment Deadline: Data Structures',
    SCHEDULE_EVENT_ASSIGNMENT_DESC: 'Binary search tree implementation task',
    SCHEDULE_EVENT_EXAM: 'Midterm Exam: Math',
    SCHEDULE_EVENT_EXAM_DESC: 'Covers chapters 1 through 5',
    SCHEDULE_EVENT_DATA: 'Data Structures Lecture',
    SCHEDULE_EVENT_DATA_DESC: 'Introduction to graph algorithms',
    MONTH_YEAR: '{1} {0}',
    INSTRUCTOR: 'Instructor',
    LOCATION: 'Location',
    MATERIALS: 'Materials',
    ONLINE_LINK: 'Online link',

    // Online Test
    MIDTERM: 'Midterm Exam',
    TERM_LABEL: 'Autumn 2025',
    TEST_Q1: 'What is the general solution to dy/dx = ky?',
    TEST_Q1_OPT1: 'y = Ce^(kx)',
    TEST_Q1_OPT2: 'y = Cx + k',
    TEST_Q1_OPT3: 'y = C/x',
    TEST_Q1_OPT4: 'y = kx^2 + C',
    TEST_Q2: 'Which of the following is a second-order linear differential equation?',
    TEST_Q2_OPT1: "y'' + 3y' + 2y = 0",
    TEST_Q2_OPT2: "y' + y^2 = x",
    TEST_Q2_OPT3: "(y')^2 + y = 0",
    TEST_Q2_OPT4: "dy/dx = x + y",
    TEST_Q3: 'Select all methods that can solve first-order differential equations:',
    TEST_Q3_OPT1: 'Separation of variables',
    TEST_Q3_OPT2: 'Integrating factor',
    TEST_Q3_OPT3: 'Laplace transform',
    TEST_Q3_OPT4: 'Newton-Raphson',
    TEST_Q4: 'Solutions of homogeneous differential equations always pass through the origin.',
    TEST_Q5: 'What is the characteristic equation of y\'\' - 5y\' + 6y = 0?',
    TEST_Q5_OPT1: 'r^2 - 5r + 6 = 0',
    TEST_Q5_OPT2: 'r^2 + 5r + 6 = 0',
    TEST_Q5_OPT3: 'r - 5 + 6 = 0',
    TEST_Q5_OPT4: 'r^2 - 5r - 6 = 0',
    TRUE_LABEL: 'True',
    FALSE_LABEL: 'False',
    TEST_PROGRESS: 'Progress',
    ANSWERED_COUNT: '{0}/{1} answered',
    QUESTION_SINGLE: 'Select one answer',
    QUESTION_MULTI: 'Select all that apply',
    QUESTION_TRUE_FALSE: 'Choose true or false',
    FLAG: 'Flag',
    FLAGGED: 'Flagged',
    QUESTION_OVERVIEW: 'Question Overview',
    ANSWERED: 'Answered',
    READY_TO_SUBMIT: 'Ready to submit',
    SUBMIT_HINT: 'Review answers before submitting',
    SUBMIT_TEST: 'Submit Test',
    QUESTION: 'Question',

    // PDF Viewer
    PDF_VIEWER_TITLE: 'Chapter 5: Differential Equations',
    NOTES: 'Notes',
    OUTLINE: 'Outline',
    MY_NOTES: 'My Notes',
    PAGE_LABEL: 'Page {0}',
    NOTE_ONE: 'Important theorem - review before exam',
    NOTE_TWO: 'Practice this example',
    NOTE_THREE: 'Check with professor during office hours',
    PDF_SECTION_HEADER: 'Overview of Differential Equations',
    PDF_PARAGRAPH_ONE: 'Differential equations describe relationships between an unknown function and its derivatives.',
    PDF_PARAGRAPH_TWO: 'Methods include separation of variables, integrating factors, and Laplace transforms.',
    PDF_LIST_ONE: 'Basic forms of first-order equations',
    PDF_LIST_TWO: 'How to handle initial conditions',
    PDF_LIST_THREE: 'Practical application examples',
    PAGE_OF: 'Page {0} of {1}',

    // Teacher Dashboard
    TEACHER_DASHBOARD_TITLE: 'Teacher Dashboard',
    TEACHER_DASHBOARD_SUBTITLE: 'Manage courses, students, and materials',
    TOTAL_STUDENTS: 'Total Students',
    ACTIVE_COURSES: 'Active Courses',
    PENDING_GRADING: 'Waiting for grading',
    AVERAGE_GRADE: 'Average Grade',
    QUICK_ACTIONS: 'Quick Actions',
    CREATE_EVENT: 'Create Event',
    UPLOAD_MATERIALS: 'Upload Materials',
    VIEW_SCHEDULE: 'View Schedule',
    VIEW_ANALYTICS: 'View Analytics',
    TAB_COURSES: 'My Courses',
    TAB_GRADING: 'Grading',
    TAB_STUDENTS: 'Student Progress',
    TAB_MATERIALS: 'Materials',
    ACTIVE_ASSIGNMENTS: 'Active assignments',
    COURSE_LABEL: 'Course',
    SUBMITTED_AT: 'Submitted at',
    REVIEW: 'Review',
    COMPLETED: 'Completed',
    CURRENT_GRADE: 'Current grade',
    UPLOAD_INSTRUCTIONS: 'PDF, DOCX, PPTX (max 50MB)',
    SELECT_FILE: 'Select File',
    RECENT_UPLOADS: 'Recent uploads',
    UPLOADED_TIME: 'Uploaded {0}',
    RECENT_STUDENT_ACTIVITY: 'Recent student activity',
    TEST_COMPLETE: 'Completed a quiz',
    VIEWED_MATERIAL: 'Viewed lecture notes',

    // Teacher Event Registration
    EVENT_REGISTRATION_TITLE: 'Event Registration',
    EVENT_REGISTRATION_SUBTITLE: 'Create a new class, assignment, exam, or internship',
    EVENT_CREATED: 'Event registered successfully',
    EVENT_CREATED_DESC: 'Students have been notified',
    SELECT_EVENT_TYPE: 'Select event type',
    SELECT_EVENT_TYPE_DESC: 'Choose the type of event to create',
    BASIC_INFORMATION: 'Basic Information',
    BASIC_INFORMATION_DESC: 'Enter the core details for this event',
    TITLE_PLACEHOLDER: 'e.g., Advanced Math Lecture 10',
    COURSE_PLACEHOLDER: 'Enter related course',
    DESCRIPTION_PLACEHOLDER: 'Add details, topics, or prep notes...',
    LOCATION_PLACEHOLDER: 'Enter location',
    ONLINE_LINK_PLACEHOLDER: 'Enter online link',
    MAX_STUDENTS_PLACEHOLDER: 'e.g., 50',
    NOTIFY_STUDENTS: 'Notify students',
    ATTACH_FILES: 'Attach files',
    SECURITY: 'Security',
    SECURITY_DESC: 'Protect the account',
    SEND_WELCOME_EMAIL: 'Send welcome email',
    REQUIRE_PASSWORD_CHANGE: 'Require password change on first login',
    CONFIRM_PASSWORD: 'Confirm password',
    ADDITIONAL_INFO: 'Additional Info',

    // Admin Dashboard
    ADMIN_DASHBOARD_TITLE: 'Admin Dashboard',
    ADMIN_DASHBOARD_SUBTITLE: 'System administration and settings',
    STORAGE_USAGE: 'Storage Usage',
    SYSTEM_UPTIME: 'System Uptime',
    ADMIN_QUICK_ACTIONS: 'Quick Actions',
    ADMIN_ACTION_REGISTER: 'User Registration',
    ADMIN_ACTION_REGISTER_DESC: 'Create a new user account',
    ADMIN_ACTION_USER: 'User Management',
    ADMIN_ACTION_USER_DESC: 'Search, edit, and delete users',
    ADMIN_ACTION_COURSE: 'Course Management',
    ADMIN_ACTION_COURSE_DESC: 'Create and manage courses',
    TAB_USERS: 'Users',
    TAB_SETTINGS: 'System Settings',
    TAB_ANALYTICS: 'Analytics',
    ENABLE_STUDENT_REGISTRATION: 'Allow student registration',
    ENABLE_STUDENT_REGISTRATION_DESC: 'Permit new students to register',
    EMAIL_NOTIFICATIONS: 'Email notifications',
    EMAIL_NOTIFICATIONS_DESC: 'Send notifications to users',
    MAINTENANCE_MODE: 'Maintenance mode',
    MAINTENANCE_MODE_DESC: 'Put the system in maintenance mode',
    SECURITY_SETTINGS: 'Security settings',
    SECURITY_SETTINGS_DESC: 'Strengthen platform protection',
    TWO_FACTOR: 'Two-factor authentication',
    SESSION_TIMEOUT: 'Session timeout',
    RESET_DEFAULTS: 'Reset to defaults',
    USER_GROWTH: 'User Growth',
    USER_GROWTH_DESC: 'Trend of new registrations',
    COURSE_ENROLLMENT: 'Course Enrollment',
    COURSE_ENROLLMENT_DESC: 'Student enrollment trends',
    SYSTEM_USAGE: 'System Usage',
    SYSTEM_USAGE_DESC: 'Platform activity metrics',
    DAILY_ACTIVE: 'Daily active users',
    AVG_SESSION: 'Average session time',
    CONTENT_VIEWS: 'Content views',
    TESTS_COMPLETED: 'Tests completed',
    POPULAR_COURSES: 'Popular courses',
    MINUTES: 'minutes',

    // Admin Course Management
    ADMIN_COURSE_MANAGEMENT_TITLE: 'Course Management',
    ADMIN_COURSE_MANAGEMENT_SUBTITLE: 'Create and manage courses across the platform',

    // Admin User Management
    ADMIN_USER_MANAGEMENT_TITLE: 'User Management',
    ADMIN_USER_MANAGEMENT_SUBTITLE: 'Manage student, teacher, and admin accounts',
    USER_DETAIL: 'User Detail',

    // Admin User Registration
    ADMIN_USER_REGISTRATION: 'User Registration',
    ADMIN_USER_REGISTRATION_SUBTITLE: 'Create student, teacher, or admin accounts',
    USER_REGISTERED: 'User registered successfully',
    WELCOME_EMAIL_SENT: 'Welcome email has been sent',
    SELECT_USER_TYPE: 'Select user type',
    SELECT_USER_TYPE_DESC: 'Choose the role for this user',
    PROFILE_IMAGE: 'Profile image',
    PROFILE_IMAGE_DESC: 'Upload a profile photo (optional)',
    UPLOAD_IMAGE: 'Upload Image',
    UPLOAD_HINT: 'JPG, PNG, up to 2MB',
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    DATE_OF_BIRTH: 'Date of birth',
    SPECIALIZATION: 'Specialization',
    USER_CODE_EXISTS: 'This user code is already registered',
    USER_EMAIL_EXISTS: 'This email address is already registered',
    USER_UPDATE_NOT_FOUND: "User update failed.\nTarget user not found",
    USER_PASSWORD_REQUIRED: 'Password is required',

    USER_CODE_INVALID: 'Only A-Z and 0-9 characters are allowed.',
    USER_EMAIL_INVALID: 'Invalid email',
    USER_PHONE_INVALID: 'Invalid phone',
    
    // Not Found
    NOT_FOUND_TITLE: 'Page Not Found',
    NOT_FOUND_MESSAGE: 'The page you are looking for does not exist or has been moved.',
    GO_HOME: 'Go to Home',

    // Fail message
    ERROR_TITLE: 'Error',
    ERROR_MESSAGE: 'An unexpected error occurred while processing your request. Please try again later.',

    // Admin Class
    CLASS_CODE_EXISTS: 'Class code already exists',

    // Admin Major
    MAJOR_CODE_EXISTS: 'Major code already exists',
    MAJOR_NOT_FOUND: 'Major not found',

    // Admin Semester
    MES_ERR_CHECK_MONTH_START_END: 'The end month will be {0} of the following year',

    // Delete dialog
    DELETE_CONFIRM_TITLE: 'Delete Confirmation',
    DELETE_CONFIRM_MESSAGE: 'Do you want to delete this item?',

    DELETE_COMPLETE_TITLE: 'Delete completed',
    DELETE_COMPLETE_MESSAGE: 'The item has been deleted.',
  }
};

export type Language = 'ja' | 'en';
export const DEFAULT_LANGUAGE: Language = 'ja';
